import * as i0 from '@angular/core';
import { Injectable, Component, EventEmitter, NgZone, Input, Output, ViewChild, Renderer2, ElementRef, NgModule, CUSTOM_ELEMENTS_SCHEMA, Pipe, ViewEncapsulation } from '@angular/core';
import { throwError, noop, of, Subject as Subject$1, from, Observable, forkJoin, BehaviorSubject } from 'rxjs';
import { NgbActiveModal, NgbModalConfig, NgbModal, NgbModule, NgbDateParserFormatter, NgbCalendar, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import * as i1 from '@angular/common';
import { Location, formatDate, CommonModule, DatePipe } from '@angular/common';
import { Subject } from 'rxjs/internal/Subject';
import * as i1$1 from '@angular/common/http';
import { HttpErrorResponse, HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { mergeMap, catchError, map, tap, debounceTime } from 'rxjs/operators';
import { BentoD3PieChartComponent, BentoD3BarChartComponent, BentoD3Module } from '@bento/bento-ng-d3';
import { __awaiter } from 'tslib';
import { has, hasFirmLicense } from '@blue/services/permission';
import { getRoute } from '@blue/services/environment';
import { FormsModule } from '@angular/forms';
import { BentoModule, BentoPaginationModule } from '@bento/bento-ng';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { noop as noop$1 } from 'rxjs/internal/util/noop';
import { getCompanyId } from '@blue/services/session';
import { isString } from 'util';
import { HttpStatusCodes } from '@blue/net-utils';
import * as wjcCore from '@grapecity/wijmo';
import * as wjcGrid from '@grapecity/wijmo.grid';
import * as wjcGridXlsx from '@grapecity/wijmo.grid.xlsx';
import { BentoFlexGridControlModule } from '@bento/bento-ng-flexgrid-control';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridDetailModule } from '@grapecity/wijmo.angular2.grid.detail';
import { WjGridGrouppanelModule } from '@grapecity/wijmo.angular2.grid.grouppanel';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { BrowserModule } from '@angular/platform-browser';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/common/http';
import * as ɵngcc3 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc4 from '@bento/bento-ng';
import * as ɵngcc5 from '@bento/bento-ng-d3';
import * as ɵngcc6 from '@angular/forms';
import * as ɵngcc7 from '@grapecity/wijmo.angular2.grid';

function ClientAssociationDetailsUpdateComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "b");
    ɵngcc0.ɵɵtext(3, " ABN :");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(4, "div", 7);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "auABNFormat");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 1, ctx_r0.clientDetail.clientAbn), " ");
} }
function ClientAssociationDetailsUpdateComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "b");
    ɵngcc0.ɵɵtext(3, " DOB :");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(4, "div", 7);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "date");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(6, 1, ctx_r1.clientDetail.individualDateOfBirth, "dd/MM/yyyy"), " ");
} }
function YearToDateGraphComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "h4", 5);
    ɵngcc0.ɵɵtext(3, "YEAR TO DATE ON TIME LODGMENT PERFORMANCE");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 6)(5, "span")(6, "strong");
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelement(8, "bento-d3-pie-chart", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 8)(10, "div", 9);
    ɵngcc0.ɵɵelement(11, "span", 10);
    ɵngcc0.ɵɵtext(12, " Lodged On Time ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 9);
    ɵngcc0.ɵɵelement(14, "span", 11);
    ɵngcc0.ɵɵtext(15, " Lodged Late ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 9);
    ɵngcc0.ɵɵelement(17, "span", 12);
    ɵngcc0.ɵɵtext(18, " To Be Lodged ");
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵclassMap(ctx_r0.targetHit ? "percentage-text-green" : "percentage-text-red");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.lodgementPercentage);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("options", ctx_r0.dataBasic);
} }
function YearToDateGraphComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "bento-alert", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("inline", true)("items", ctx_r1.alerts);
} }
function AuTaxLodgePerformanceComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 8);
    ɵngcc0.ɵɵelement(2, "year-to-date-graph");
    ɵngcc0.ɵɵelementEnd()();
} }
function AuTaxLodgePerformanceComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 8);
    ɵngcc0.ɵɵelement(2, "lodgement-overall-progress-graph");
    ɵngcc0.ɵɵelementEnd()();
} }
const _c0 = function (a0) { return { "hiddenCaption": a0 }; };
function ClientAddressUpdateComponent_bento_wizard_step_6_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 22);
} if (rf & 2) {
    const clientUpdate_r8 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("ngbTooltip", _r3)("hidden", clientUpdate_r8.id !== "other_details");
} }
function ClientAddressUpdateComponent_bento_wizard_step_6_div_2_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 22);
} if (rf & 2) {
    const clientUpdate_r8 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵnextContext();
    const _r5 = ɵngcc0.ɵɵreference(6);
    ɵngcc0.ɵɵproperty("ngbTooltip", _r5)("hidden", clientUpdate_r8.id !== "other_details");
} }
function ClientAddressUpdateComponent_bento_wizard_step_6_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 18)(1, "input", 19);
    ɵngcc0.ɵɵlistener("click", function ClientAddressUpdateComponent_bento_wizard_step_6_div_2_Template_input_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r14); const clientUpdate_r8 = restoredCtx.$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.onRadioButtonChange(clientUpdate_r8); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "label", 20);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵtemplate(4, ClientAddressUpdateComponent_bento_wizard_step_6_div_2_span_4_Template, 1, 2, "span", 21);
    ɵngcc0.ɵɵtemplate(5, ClientAddressUpdateComponent_bento_wizard_step_6_div_2_span_5_Template, 1, 2, "span", 21);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const clientUpdate_r8 = ctx.$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("id", clientUpdate_r8.id);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", clientUpdate_r8.name, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.isEntityTypeIndividual);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.isEntityTypeIndividual);
} }
function ClientAddressUpdateComponent_bento_wizard_step_6_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, " Resident for Tax Purposes ");
    ɵngcc0.ɵɵelement(1, "br");
    ɵngcc0.ɵɵtext(2, " Date of Death ");
} }
function ClientAddressUpdateComponent_bento_wizard_step_6_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0, " Resident for Tax Purposes ");
} }
function ClientAddressUpdateComponent_bento_wizard_step_6_tr_21_td_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r17 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(col_r17);
} }
function ClientAddressUpdateComponent_bento_wizard_step_6_tr_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr", 23)(1, "th", 24);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, ClientAddressUpdateComponent_bento_wizard_step_6_tr_21_td_3_Template, 2, 1, "td", 25);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r15 = ctx.$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hidden", !ctx_r7.isEntityTypeIndividual && row_r15.rowName === "Date of Death");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(row_r15.rowName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", row_r15.rowValues);
} }
function ClientAddressUpdateComponent_bento_wizard_step_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "bento-wizard-step", 8)(1, "div", 9);
    ɵngcc0.ɵɵtemplate(2, ClientAddressUpdateComponent_bento_wizard_step_6_div_2_Template, 6, 4, "div", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, ClientAddressUpdateComponent_bento_wizard_step_6_ng_template_3_Template, 3, 0, "ng-template", null, 11, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(5, ClientAddressUpdateComponent_bento_wizard_step_6_ng_template_5_Template, 1, 0, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementStart(7, "div", 13)(8, "table", 14)(9, "thead")(10, "tr")(11, "th", 15);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementStart(13, "thead")(14, "tr");
    ɵngcc0.ɵɵelement(15, "td");
    ɵngcc0.ɵɵelementStart(16, "th", 16);
    ɵngcc0.ɵɵtext(17, "Onvio");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(18, "th", 16);
    ɵngcc0.ɵɵtext(19, "ATO");
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementStart(20, "tbody");
    ɵngcc0.ɵɵtemplate(21, ClientAddressUpdateComponent_bento_wizard_step_6_tr_21_Template, 4, 3, "tr", 17);
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const step_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("title", step_r1.title)("description", step_r1.discription)("disabled", step_r1.disable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.currentStep !== 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.clientUpdateTypes);
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("hidden", ctx_r0.currentStep !== 1)("bentoBusyLoader", ctx_r0.isClientUpdateTableBusyLoader)("size", "sm");
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.selectedClientUpdate == null ? null : ctx_r0.selectedClientUpdate.name);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.clientUpdateTableRowList);
} }
function ClientRelationshipUpdateComponent_h4_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h4", 13);
    ɵngcc0.ɵɵtext(1, " Update Client Relationship");
    ɵngcc0.ɵɵelementEnd();
} }
function ClientRelationshipUpdateComponent_h4_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h4", 13);
    ɵngcc0.ɵɵtext(1, " Remove Client Relationship");
    ɵngcc0.ɵɵelementEnd();
} }
function ClientRelationshipUpdateComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5)(1, "div", 14);
    ɵngcc0.ɵɵtext(2, " This will connect to the Australian Tax Office (ATO) to remove the client relationship details ");
    ɵngcc0.ɵɵelementEnd()();
} }
function ClientRelationshipUpdateComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8)(1, "bento-combobox", 15);
    ɵngcc0.ɵɵlistener("ngModelChange", function ClientRelationshipUpdateComponent_div_10_Template_bento_combobox_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.selectedTaxAgent = $event; });
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r3.selectedTaxAgent)("options", ctx_r3.cmbTaxAgentOptions)("itemsObservable", ctx_r3.taxAgentData);
} }
function ClientRelationshipUpdateComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.selectedTaxAgent.name, " ");
} }
function ClientRelationshipUpdateComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "b");
    ɵngcc0.ɵɵtext(3, " Tax Agent Number :");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r5.selectedTaxAgent.tan, " ");
} }
function ClientRelationshipUpdateComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "b");
    ɵngcc0.ɵɵtext(3, " Tax Agent ABN :");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "auABNFormat");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 1, ctx_r6.selectedTaxAgent.abn), " ");
} }
function ClientRelationshipUpdateComponent_div_26_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "b");
    ɵngcc0.ɵɵtext(3, " ABN :");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "auABNFormat");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 1, ctx_r7.clientDetail.clientAbn), " ");
} }
function ClientRelationshipUpdateComponent_div_27_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5)(1, "div", 6)(2, "b");
    ɵngcc0.ɵɵtext(3, " DOB :");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(4, "div", 8);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "date");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(6, 1, ctx_r8.clientDetail.individualDateOfBirth, "dd/MM/yyyy"), " ");
} }
function ClientRelationshipUpdateComponent_button_29_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 16);
    ɵngcc0.ɵɵlistener("click", function ClientRelationshipUpdateComponent_button_29_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.addRelationship(); });
    ɵngcc0.ɵɵtext(1, "Add");
    ɵngcc0.ɵɵelementEnd();
} }
function ClientRelationshipUpdateComponent_button_30_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 17);
    ɵngcc0.ɵɵlistener("click", function ClientRelationshipUpdateComponent_button_30_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.removeRelationship(); });
    ɵngcc0.ɵɵtext(1, "Remove");
    ɵngcc0.ɵɵelementEnd();
} }
function AtoAgentClientRelationshipComponent_span_30_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 20);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.relationshipModel.messageStatus, " ");
} }
function AtoAgentClientRelationshipComponent_span_31_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.relationshipModel.messageStatus, " ");
} }
function DirectDebitPaymentComponent_small_46_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 28);
    ɵngcc0.ɵɵtext(1, "This field is required");
    ɵngcc0.ɵɵelementEnd();
} }
function DirectDebitPaymentComponent_small_48_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 28);
    ɵngcc0.ɵɵtext(1, "Date entered is invalid");
    ɵngcc0.ɵɵelementEnd();
} }
function AtoClientFinanceDetailsComponent_div_37_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1)(1, "div", 2)(2, "h3");
    ɵngcc0.ɵɵtext(3, "Prior year's tax return");
    ɵngcc0.ɵɵelementEnd()()();
} }
function AtoClientFinanceDetailsComponent_div_38_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6)(1, "div", 1)(2, "label", 7);
    ɵngcc0.ɵɵtext(3, " Click to import prior year's tax return ");
    ɵngcc0.ɵɵelementStart(4, "button", 21);
    ɵngcc0.ɵɵlistener("click", function AtoClientFinanceDetailsComponent_div_38_Template_button_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); const _r3 = ɵngcc0.ɵɵreference(42); return ctx_r5.importFromAto(_r3); });
    ɵngcc0.ɵɵtext(5, " Import from ATO ");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.isDisabledRetrieveFromAtoButton)("bentoBusyLoader", ctx_r1.isImportFromAtoButtonBusy);
} }
const _c1 = function (a0) { return [a0]; };
function AtoClientFinanceDetailsComponent_div_40_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1)(1, "div", 22)(2, "div", 23)(3, "div", 1)(4, "label", 7)(5, "h3", 24);
    ɵngcc0.ɵɵtext(6, " Direct Debit Payment");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(7, "\u00A0\u00A0 ");
    ɵngcc0.ɵɵelementStart(8, "button", 25);
    ɵngcc0.ɵɵlistener("click", function AtoClientFinanceDetailsComponent_div_40_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.openDirectDebitDetails(); });
    ɵngcc0.ɵɵtext(9, " ADD ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(10, " \u00A0\u00A0 ");
    ɵngcc0.ɵɵelementStart(11, "button", 25);
    ɵngcc0.ɵɵlistener("click", function AtoClientFinanceDetailsComponent_div_40_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.openDirectDebitCancelDetails(); });
    ɵngcc0.ɵɵtext(12, " CANCEL ");
    ɵngcc0.ɵɵelementEnd()()()()();
    ɵngcc0.ɵɵelementStart(13, "div", 26)(14, "span", 27);
    ɵngcc0.ɵɵtext(15, " (Please ADD/Verify Bank Account (EFT) Details before adding payment) ");
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(14);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c1, ctx_r2.isEFTSDetailsAll ? "EFTS-note-true" : "EFTS-note-false"));
} }
function AtoClientFinanceDetailsComponent_ng_template_41_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 28);
    ɵngcc0.ɵɵlistener("click", function AtoClientFinanceDetailsComponent_ng_template_41_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const d_r11 = restoredCtx.dismiss; return d_r11("Cross click"); });
    ɵngcc0.ɵɵelement(1, "i", 29);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "h4", 30);
    ɵngcc0.ɵɵtext(3, " Prior year's tax return ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 31)(5, "div", 8)(6, "div", 32)(7, "b");
    ɵngcc0.ɵɵtext(8, " Name :");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(9, "div", 33);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(11, "div", 8)(12, "div", 32)(13, "b");
    ɵngcc0.ɵɵtext(14, "TFN :");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(15, "div", 33);
    ɵngcc0.ɵɵtext(16);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(17, "div", 8)(18, "div", 32)(19, "b");
    ɵngcc0.ɵɵtext(20, " DOB :");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(21, "div", 33);
    ɵngcc0.ɵɵtext(22);
    ɵngcc0.ɵɵpipe(23, "date");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(24, "div", 8)(25, "div", 32)(26, "b");
    ɵngcc0.ɵɵtext(27, " Year :");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(28, "div", 34)(29, "bento-combobox", 35);
    ɵngcc0.ɵɵlistener("ngModelChange", function AtoClientFinanceDetailsComponent_ng_template_41_Template_bento_combobox_ngModelChange_29_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.selectedPriorTaxYear = $event; });
    ɵngcc0.ɵɵelementEnd()()()();
    ɵngcc0.ɵɵelementStart(30, "b");
    ɵngcc0.ɵɵtext(31, "Note:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(32, "ul")(33, "li");
    ɵngcc0.ɵɵtext(34, "By selecting \"All\" option, only 2019 and 2020 individual tax returns will be imported from ATO.");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(35, "li");
    ɵngcc0.ɵɵtext(36, "Importing the tax returns form ATO takes addtional time and thus increase the overall time of importing");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(37, "div", 36)(38, "div", 1)(39, "div", 37)(40, "button", 21);
    ɵngcc0.ɵɵlistener("click", function AtoClientFinanceDetailsComponent_ng_template_41_Template_button_click_40_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.importButtonClicked(); });
    ɵngcc0.ɵɵtext(41, "Import");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(42, "div", 38)(43, "button", 39);
    ɵngcc0.ɵɵlistener("click", function AtoClientFinanceDetailsComponent_ng_template_41_Template_button_click_43_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const c_r10 = restoredCtx.close; return c_r10("Close click"); });
    ɵngcc0.ɵɵtext(44, "Cancel");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.isDisabledCancelIcon);
    ɵngcc0.ɵɵadvance(10);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.clientDetail.clientName, " ");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.clientDetail.clientTfn, " ");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(23, 10, ctx_r4.clientDetail.individualDateOfBirth, "dd/MM/yyyy"), " ");
    ɵngcc0.ɵɵadvance(7);
    ɵngcc0.ɵɵproperty("options", ctx_r4.cmbPriorTaxYearOptions)("ngModel", ctx_r4.selectedPriorTaxYear)("itemsObservable", ctx_r4.priortaxYearData);
    ɵngcc0.ɵɵadvance(11);
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.isDisabledRetrieveFromAtoButton)("bentoBusyLoader", ctx_r4.isImportButtonBusy);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("disabled", ctx_r4.isDisabledCancelButton);
} }
const _c2 = ["flexGrid"];
function MigrationDetailsComponent_ng_template_13_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r8 = ɵngcc0.ɵɵnextContext().row;
    const ctx_r10 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r10.data.pageSize * ctx_r10.data.pageIndex + row_r8.index + 1);
} }
function MigrationDetailsComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, MigrationDetailsComponent_ng_template_13_div_0_Template, 2, 1, "div", 14);
} if (rf & 2) {
    const col_r7 = ctx.col;
    ɵngcc0.ɵɵproperty("ngIf", col_r7.index === 0);
} }
function MigrationDetailsComponent_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15)(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r12 = ctx.item;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r12.no);
} }
function MigrationDetailsComponent_ng_template_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15)(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r14 = ctx.item;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r14.clientName);
} }
function MigrationDetailsComponent_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15)(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r16 = ctx.item;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r16.migrationType);
} }
function MigrationDetailsComponent_ng_template_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15)(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r18 = ctx.item;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.statusMap.getDisplayValue(item_r18.status));
} }
function MigrationDetailsComponent_div_23_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div")(1, "bento-pagination", 16);
    ɵngcc0.ɵɵlistener("itemsPerPageChange", function MigrationDetailsComponent_div_23_Template_bento_pagination_itemsPerPageChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.onPageSizeChanged($event); })("pageChange", function MigrationDetailsComponent_div_23_Template_bento_pagination_pageChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r22 = ɵngcc0.ɵɵnextContext(); return ctx_r22.onPageChanged($event); });
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("page", ctx_r6.data.pageIndex + 1)("directionLinks", true)("boundaryLinks", true)("totalItems", ctx_r6.data == null ? null : ctx_r6.data.totalItemCount)("itemsPerPage", ctx_r6.pageInfo.pageSize);
} }
function MigrationModalWindowComponent_label_13_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "label", 16)(1, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function MigrationModalWindowComponent_label_13_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.importType = $event; })("change", function MigrationModalWindowComponent_label_13_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onFormTypeChangeStep1(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "span", 18);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.importType)("value", ctx_r0.importTypes[0].value);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.importTypes[0].label);
} }
function MigrationModalWindowComponent_label_14_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "label", 16)(1, "input", 17);
    ɵngcc0.ɵɵlistener("ngModelChange", function MigrationModalWindowComponent_label_14_Template_input_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.importType = $event; })("change", function MigrationModalWindowComponent_label_14_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.onFormTypeChangeStep1(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "span", 18);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r1.importType)("value", ctx_r1.importTypes[1].value);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.importTypes[1].label);
} }
function MigrationModalWindowComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 7)(2, "h1");
    ɵngcc0.ɵɵtext(3, "Select which data to import");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 19)(5, "label", 16)(6, "input", 20);
    ɵngcc0.ɵɵlistener("ngModelChange", function MigrationModalWindowComponent_div_16_Template_input_ngModelChange_6_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.saImportType = $event; })("click", function MigrationModalWindowComponent_div_16_Template_input_click_6_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onFormTypeChangeClientsOnlyStep2(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "span", 18);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(9, "br");
    ɵngcc0.ɵɵelementStart(10, "span", 21);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(12, "br");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "label", 16)(14, "input", 20);
    ɵngcc0.ɵɵlistener("ngModelChange", function MigrationModalWindowComponent_div_16_Template_input_ngModelChange_14_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.saImportType = $event; })("click", function MigrationModalWindowComponent_div_16_Template_input_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.onFormTypeChangeSaStep2(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "span", 18);
    ɵngcc0.ɵɵtext(16);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(17, "br");
    ɵngcc0.ɵɵelementStart(18, "span", 21);
    ɵngcc0.ɵɵtext(19);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(20, "br");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(21, "label", 16)(22, "input", 20);
    ɵngcc0.ɵɵlistener("ngModelChange", function MigrationModalWindowComponent_div_16_Template_input_ngModelChange_22_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.saImportType = $event; })("click", function MigrationModalWindowComponent_div_16_Template_input_click_22_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r19 = ɵngcc0.ɵɵnextContext(); return ctx_r19.onFormTypeChangeSaStep2(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(23, "span", 18);
    ɵngcc0.ɵɵtext(24);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(25, "br");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.saImportType)("value", ctx_r2.saImportTypes[0].value);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.saImportTypes[0].label);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.saImportTypes[0].label1);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.saImportType)("value", ctx_r2.saImportTypes[1].value);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.saImportTypes[1].label);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.saImportTypes[1].label1);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.saImportType)("value", ctx_r2.saImportTypes[2].value);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.saImportTypes[2].label);
} }
function MigrationModalWindowComponent_div_17_div_2_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 29);
    ɵngcc0.ɵɵelement(1, "i", 30);
    ɵngcc0.ɵɵelementStart(2, "i");
    ɵngcc0.ɵɵtext(3, " Unable to proceed! Your previous request is still in progress. Please wait until the ATO report is received or use an existing ATO report.");
    ɵngcc0.ɵɵelementEnd()();
} }
function MigrationModalWindowComponent_div_17_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 23)(1, "div", 24)(2, "label", 16)(3, "input", 25);
    ɵngcc0.ɵɵlistener("ngModelChange", function MigrationModalWindowComponent_div_17_div_2_Template_input_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(2); return ctx_r23.atoImportType = $event; })("change", function MigrationModalWindowComponent_div_17_div_2_Template_input_change_3_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r25 = ɵngcc0.ɵɵnextContext(2); return ctx_r25.onFormTypeChangeStep2(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 18);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "br");
    ɵngcc0.ɵɵtemplate(7, MigrationModalWindowComponent_div_17_div_2_span_7_Template, 4, 0, "span", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 27)(9, "label", 16)(10, "input", 28);
    ɵngcc0.ɵɵlistener("ngModelChange", function MigrationModalWindowComponent_div_17_div_2_Template_input_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r26 = ɵngcc0.ɵɵnextContext(2); return ctx_r26.atoImportType = $event; })("change", function MigrationModalWindowComponent_div_17_div_2_Template_input_change_10_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r27 = ɵngcc0.ɵɵnextContext(2); return ctx_r27.onFormTypeChangeStep2(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "span", 18);
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(13, "br");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx_r20.isReportCheckBusy);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r20.atoImportType)("value", ctx_r20.atoImportTypes[0].value)("disabled", ctx_r20.isItcrptReportStatusPending);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r20.isItcrptReportStatusPending ? ctx_r20.atoImportTypes[0].label1 : ctx_r20.atoImportTypes[0].label);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r20.isItcrptReportStatusPending);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r20.atoImportType)("value", ctx_r20.atoImportTypes[1].value);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2("", ctx_r20.atoImportTypes[1].label, " ", ctx_r20.latestDate, "");
} }
function MigrationModalWindowComponent_div_17_div_3_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 29);
    ɵngcc0.ɵɵelement(1, "i", 30);
    ɵngcc0.ɵɵelementStart(2, "i");
    ɵngcc0.ɵɵtext(3, " Unable to proceed! Your previous request is still in progress. Please wait until the ATO report is received.");
    ɵngcc0.ɵɵelementEnd()();
} }
function MigrationModalWindowComponent_div_17_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r30 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 23)(1, "div", 31)(2, "label", 16)(3, "input", 25);
    ɵngcc0.ɵɵlistener("ngModelChange", function MigrationModalWindowComponent_div_17_div_3_Template_input_ngModelChange_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r29 = ɵngcc0.ɵɵnextContext(2); return ctx_r29.atoImportType = $event; })("change", function MigrationModalWindowComponent_div_17_div_3_Template_input_change_3_listener() { ɵngcc0.ɵɵrestoreView(_r30); const ctx_r31 = ɵngcc0.ɵɵnextContext(2); return ctx_r31.onFormTypeChangeStep2(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "span", 18);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "br");
    ɵngcc0.ɵɵtemplate(7, MigrationModalWindowComponent_div_17_div_3_span_7_Template, 4, 0, "span", 26);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r21 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx_r21.isReportCheckBusy);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r21.atoImportType)("value", ctx_r21.atoImportTypes[2].value)("disabled", ctx_r21.isItcrptReportStatusPending);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r21.isItcrptReportStatusPending ? ctx_r21.atoImportTypes[2].label1 : ctx_r21.atoImportTypes[2].label);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r21.isItcrptReportStatusPending);
} }
function MigrationModalWindowComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 7);
    ɵngcc0.ɵɵtemplate(2, MigrationModalWindowComponent_div_17_div_2_Template, 14, 10, "div", 22);
    ɵngcc0.ɵɵtemplate(3, MigrationModalWindowComponent_div_17_div_3_Template, 8, 6, "div", 22);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isHaveITCRPTReport);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r3.isHaveITCRPTReport);
} }
function MigrationModalWindowComponent_div_19_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 33)(2, "label", 34);
    ɵngcc0.ɵɵtext(3, "Select the tax year(s) to import");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "bento-combobox", 35);
    ɵngcc0.ɵɵlistener("ngModelChange", function MigrationModalWindowComponent_div_19_div_1_Template_bento_combobox_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r34); const ctx_r33 = ɵngcc0.ɵɵnextContext(2); return ctx_r33.saTaxYearSelected = $event; })("openChange", function MigrationModalWindowComponent_div_19_div_1_Template_bento_combobox_openChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r34); const ctx_r35 = ɵngcc0.ɵɵnextContext(2); return ctx_r35.onFormTypeChangeSaYearStep3(); });
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r32 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r32.saTaxYearSelected)("itemsObservable", ctx_r32.saMigrationYearSelection)("options", ctx_r32.cmbSaMigrationYearOptions);
} }
function MigrationModalWindowComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r37 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, MigrationModalWindowComponent_div_19_div_1_Template, 5, 3, "div", 11);
    ɵngcc0.ɵɵelement(2, "br")(3, "br")(4, "br")(5, "br")(6, "br");
    ɵngcc0.ɵɵelementStart(7, "div")(8, "h4");
    ɵngcc0.ɵɵtext(9, "Select the export file created from Software Assistant");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "bento-file-selector", 32);
    ɵngcc0.ɵɵlistener("ngModelChange", function MigrationModalWindowComponent_div_19_Template_bento_file_selector_ngModelChange_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r36 = ɵngcc0.ɵɵnextContext(); return ctx_r36.selectedFiles = $event; })("fileSelect", function MigrationModalWindowComponent_div_19_Template_bento_file_selector_fileSelect_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r38 = ɵngcc0.ɵɵnextContext(); return ctx_r38.onFileSelect($event); })("fileRemove", function MigrationModalWindowComponent_div_19_Template_bento_file_selector_fileRemove_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r39 = ɵngcc0.ɵɵnextContext(); return ctx_r39.onFileRemove($event); })("change", function MigrationModalWindowComponent_div_19_Template_bento_file_selector_change_10_listener() { ɵngcc0.ɵɵrestoreView(_r37); const ctx_r40 = ɵngcc0.ɵɵnextContext(); return ctx_r40.onFormTypeChangeSaFileStep3(); });
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r4.saIsImportTypeClientOnly);
    ɵngcc0.ɵɵadvance(9);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r4.selectedFiles)("dropFieldLabel", ctx_r4.fileSelectorConstant)("showSelectedFiles", ctx_r4.showSelectedFiles)("multiple", ctx_r4.multipleSelect)("showFileSize", ctx_r4.showFileSize)("appendOnSelection", ctx_r4.appendOnSelection)("disabled", ctx_r4.disableFS)("accept", ".zip");
} }
function MigrationModalWindowComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r42 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 7)(2, "label", 36);
    ɵngcc0.ɵɵtext(3, "Select the tax year(s) to import");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "bento-combobox", 37);
    ɵngcc0.ɵɵlistener("ngModelChange", function MigrationModalWindowComponent_div_20_Template_bento_combobox_ngModelChange_4_listener($event) { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r41 = ɵngcc0.ɵɵnextContext(); return ctx_r41.atoSelectedYear = $event; })("openChange", function MigrationModalWindowComponent_div_20_Template_bento_combobox_openChange_4_listener() { ɵngcc0.ɵɵrestoreView(_r42); const ctx_r43 = ɵngcc0.ɵɵnextContext(); return ctx_r43.onAtoYearSelected(); });
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(5, "div")(6, "b");
    ɵngcc0.ɵɵtext(7, "Note:");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "ul")(9, "li");
    ɵngcc0.ɵɵtext(10, "By selecting \"All\" option, only 2019 and 2020 individual tax returns will be imported from ATO.");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(11, "li");
    ɵngcc0.ɵɵtext(12, "Importing clients and tax returns from ATO can take additional time to import.");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngModel", ctx_r5.atoSelectedYear)("itemsObservable", ctx_r5.atoMigrationYearSelection)("options", ctx_r5.cmbAtoMigrationYearOptions);
} }
function MigrationModalWindowComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 38)(1, "label", 33);
    ɵngcc0.ɵɵtext(2, "To finalise the import of your clients to Onvio, click ");
    ɵngcc0.ɵɵelementStart(3, "b");
    ɵngcc0.ɵɵtext(4, "Import");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(5, ".");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "label", 39)(7, "i");
    ɵngcc0.ɵɵtext(8, "The ability to migrate tax returns is currently under development.");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(9, "label", 40)(10, "i");
    ɵngcc0.ɵɵtext(11, "We plan to release the ATO tax return import in the near future. Stay tuned!");
    ɵngcc0.ɵɵelementEnd()()();
} }
class AutaxStaffConstants {
}
// This constant used as a modaloption property container in nucleus-staff
// So that modal will open within given tag and no worries for css break down issue
AutaxStaffConstants.nucleusStaffModalContainer = '#bentoNGModalContainer';
// This constant used for national identities key
AutaxStaffConstants.nationalIdentitiesExpanded = {
    auTFN: 'AU-TFN',
    auABN: 'AU-ABN'
};
// This constant used for entit type key
AutaxStaffConstants.entityType = {
    auIndividual: 'AUINDIVIDUAL'
};
AutaxStaffConstants.errorConstant = 'No data recovered';
// onvio addresses url value for json-server db.json file
AutaxStaffConstants.onvioAddressesUrl = 'http://localhost:3000/onvioAddresses';
// ato addresses url value for json-server db.json file
AutaxStaffConstants.atoAddressesUrl = 'http://localhost:3000/atoAddresses';
// ato client finance details url value for json-server db.json file
AutaxStaffConstants.atoFinanceUrl = 'http://localhost:3000/atoFinance';
// onvio client url value for json-server db.json file
AutaxStaffConstants.onvioClientFinanceDataUrl = 'http://localhost:3000/onvioClientFinanceData';
// onvio client other details url value for json-server db.json file
AutaxStaffConstants.onvioClientOtherDetailsDataUrl = 'http://localhost:3000/onvioClientOtherDetailsData';
// onvio update client url value for json-server db.json file
AutaxStaffConstants.onvioClientUpdateDataUrl = 'http://localhost:3000/onvioUpdateClientData';
// Generic toaster message in case of unhandled error.
AutaxStaffConstants.genericToasterErrorMessage = 'Something went wrong. Please try again later.';
// Generice toaster message for ato-agent-client relationship toggle.
AutaxStaffConstants.toggleStatusToasterErrorMessage = "Agent Client Relationship has not been established for this client. Turn ON the toggle in General tab";
// This constant used for client contact data type combo option
AutaxStaffConstants.comboOptions = {
    No: 'No',
    Yes: 'Yes'
};
// This constant used for entit type key
AutaxStaffConstants.individualEntityType = {
    auIndividual: 'Individual'
};
// This constant used for client contact data PriorTaxYear combo option
AutaxStaffConstants.combPriorTaxYearOptions = {
    allYear: 'All below year',
    saAllYear: 'All Year',
    taxYear2019: '2019',
    taxYear2020: '2020',
    atoAllYear: 'All',
    none: 'None'
};
// This constant is used for text to represent file selector
AutaxStaffConstants.fileSelectorConstant = 'Drag a file here';
// This constant is used for ato import type selection
AutaxStaffConstants.atoImportType = {
    newReportFromATO: 'newReportFromATO',
    fromLatestITCRPT: 'fromLatestITCRPT',
    newReportFromITCRPT: 'newReportFromITCRPT'
};

// System imports
class HelperService {
    constructor(location) {
        this.location = location;
        this.isAddRelationship = false;
        this.refreshStatus = false;
        this.subjectRelationshipStatus = new Subject();
    }
    // Get the value of current company id
    getCompanyId() {
        return this.companyId;
    }
    // Set the value of current company id
    setCompanyId(companyId) {
        this.companyId = companyId;
    }
    // Set the value of refresh grid status
    setRefreshStatus(refreshStatus) {
        this.refreshStatus = refreshStatus;
    }
    // Get the refresh grid status
    getRefreshStatus() {
        return this.refreshStatus;
    }
    // Get client id
    getClientId() {
        return this.getClientIdFromRouteSegments();
    }
    // Get client id from Route segments
    getClientIdFromRouteSegments() {
        // #/setup/clients/B42F4CD559B2499E9C9BDF7EA4DCB615/general
        return this.getRouteSegments()[3];
    }
    // Get current url and returns it's segments
    getRouteSegments() {
        const currentUrl = this.location.path(true);
        const routeSegments = currentUrl.split('/');
        return routeSegments;
    }
    // Get the value of Is Add Relationship
    getIsAddRelationship() {
        return this.isAddRelationship;
    }
    // Set the value of Is Add Relationship
    setIsAddRelationship(isAddRelationship) {
        this.isAddRelationship = isAddRelationship;
    }
    // Get the value of Client Detail
    getClientDetail() {
        return this.clientDetails;
    }
    // Set the value of Client Detail
    setClientDetail(clientDetail) {
        this.clientDetails = clientDetail;
    }
    // Get relationship status
    getRelationshipStatus() {
        return this.subjectRelationshipStatus.asObservable();
    }
    // Set relationship status
    setRelationshipStatus(relationshipStatus) {
        this.subjectRelationshipStatus.next(relationshipStatus);
    }
    // Set the date format from string format to OnvioCoreClientOtherDetails dateofDeath format.
    dateStringCoreToObject(onvioOtherDetails) {
        const date = onvioOtherDetails.trim().split('-');
        let year = parseInt(date[0].slice(0, 4));
        ;
        let month = parseInt(date[1].slice(0, 2));
        let day = parseInt(date[2].slice(0, 2));
        return { day, month, year };
    }
    // Set the date format from string format to OnvioClientOtherDetails dateofDeath format.
    dateStringToObject(onvioOtherDetails) {
        const date = onvioOtherDetails.trim().split('/');
        let day = parseInt(date[0].slice(0, 2));
        let month = parseInt(date[1].slice(0, 2));
        let year = parseInt(date[2].slice(0, 4));
        ;
        return { day, month, year };
    }
    // Set the date format from ATO format to core format.
    dateObjectToCoreFormat(atoDateOfDeath) {
        if (atoDateOfDeath.year && atoDateOfDeath.month && atoDateOfDeath.day) {
            let month = '' + (atoDateOfDeath.month);
            let day = '' + atoDateOfDeath.day;
            let year = atoDateOfDeath.year;
            if (month.length < 2) {
                month = '0' + month;
            }
            if (day.length < 2) {
                day = '0' + day;
            }
            return [year, month, day].join('-').toString();
        }
        return '';
    }
    // Get object of INamedReferenceDto with id and name
    getNamedReference(referenceId, referenceName) {
        return {
            id: referenceId,
            name: referenceName
        };
    }
    // Change first letter to uppercase
    changeCaseFirstLetter(stringValue) {
        return stringValue.charAt(0).toUpperCase() + stringValue.slice(1);
    }
}
HelperService.ɵfac = function HelperService_Factory(t) { return new (t || HelperService)(ɵngcc0.ɵɵinject(ɵngcc1.Location)); };
HelperService.ɵprov = i0.ɵɵdefineInjectable({ factory: function HelperService_Factory() { return new HelperService(i0.ɵɵinject(i1.Location)); }, token: HelperService, providedIn: "root" });
HelperService.ctorParameters = () => [
    { type: Location }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HelperService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.Location }]; }, null); })();

class RelationshipStatus {
}

var AlertType;
(function (AlertType) {
    AlertType["success"] = "success";
    AlertType["info"] = "info";
    AlertType["warning"] = "warning";
    AlertType["danger"] = "danger";
})(AlertType || (AlertType = {}));
var OnvioAddressType;
(function (OnvioAddressType) {
    OnvioAddressType["postal"] = "POSTAL";
    OnvioAddressType["home"] = "HOME";
    OnvioAddressType["business"] = "BUSINESS";
})(OnvioAddressType || (OnvioAddressType = {}));
var AtoClientUpdateType;
(function (AtoClientUpdateType) {
    AtoClientUpdateType["postal"] = "postal";
    AtoClientUpdateType["home"] = "residential";
    AtoClientUpdateType["business"] = "business";
    AtoClientUpdateType["finance"] = "financialDetails";
    AtoClientUpdateType["otherDetail"] = "otherDetails";
})(AtoClientUpdateType || (AtoClientUpdateType = {}));
var RelationshipMessageStatus;
(function (RelationshipMessageStatus) {
    RelationshipMessageStatus["accepted"] = "Accepted";
    RelationshipMessageStatus["rejected"] = "Rejected";
})(RelationshipMessageStatus || (RelationshipMessageStatus = {}));
var OnvioClientUpdateType;
(function (OnvioClientUpdateType) {
    OnvioClientUpdateType["cufi"] = "cufi";
    OnvioClientUpdateType["cuaddr"] = "cuaddr";
    OnvioClientUpdateType["curel"] = "curel";
    OnvioClientUpdateType["cudtl"] = "cudtl";
})(OnvioClientUpdateType || (OnvioClientUpdateType = {}));

class AddressDescription {
}

// System imports
class ExceptionHandler {
    static handleError(error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('client-side or network error: ', error.error.message);
        }
        else if (error instanceof HttpErrorResponse) {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong.
            console.error(`status code: ${error.status}, ` +
                `status text: ${error.statusText}, ` +
                `body was: ${error.error}, ` +
                `error message: ${error.message}`);
            if (error.status >= 400 && error.status <= 499) {
                // Client make mistake
                switch (error.status) {
                    case 400:
                        // Directly throw the error message that back-end provides.
                        return throwError(error.error);
                    default:
                        return throwError(error);
                }
            }
            else if (error.status >= 500 && error.status <= 599) {
                // Server make mistake
                switch (error.status) {
                    case 500:
                        return throwError('Internal server error');
                    // No need for default case, let it be throw default error message.
                }
            }
            else {
                // Write it for code-coverage branch missing
                noop();
            }
        }
        else {
            console.log(`Error Message: ${error.message}`);
            console.error(`Error Message Stack: ${error.stack}`);
        }
        // Return an observable with a user-facing error message
        return throwError(AutaxStaffConstants.genericToasterErrorMessage);
    }
}

class ClientFinance {
}
class AtoClientFinance extends ClientFinance {
}

class SchematronError {
    constructor(value) {
        this.errorCode = value.errorCode;
        this.severity = value.severity;
        this.location = value.any;
        this.shortDescription = value.shortDescription;
        this.detailDesription = value.detailDesription;
    }
}

class ClientOtherDetails {
}

// System imports
class AtoIntegrationService {
    constructor(http) {
        this.http = http;
    }
    // Get Client Relationship
    getClientRelationship(clientId) {
        const url = `/api/autax/v1/clients/${clientId}/contact-data/curel`;
        return this.http.get(url).pipe(mergeMap((data) => {
            return of(data.data);
        })).pipe(catchError(ExceptionHandler.handleError));
    }
    // Add Client Relationship
    addClientRelationship(clientDetail) {
        const url = `/api/aulodgement/v1/client-update/client-relationship/instances/submit`;
        return this.http.post(url, clientDetail).pipe(catchError(ExceptionHandler.handleError));
    }
    // Remove Client Relationship
    removeClientRelationship(clientDetail) {
        const url = `/api/aulodgement/v1/client-update/client-relationship/instances/remove`;
        return this.http.post(url, clientDetail).pipe(catchError(ExceptionHandler.handleError));
    }
    // Get ato address for given client id
    getAtoClientAddressById(clientId) {
        const atoClientAddresstUrl = `/api/aulodgement/v1/client-update/${clientId}/client-address/instances/list`;
        return this.http.get(atoClientAddresstUrl)
            .pipe(catchError(ExceptionHandler.handleError));
    }
    // Get promise of filterred address from client's list of address by it's addressType.
    getAtoClientAddressByType(clientId, addressType) {
        return this.getAtoClientAddressById(clientId).pipe(mergeMap((clientAddressList) => {
            if (clientAddressList.hasErrors) {
                return throwError(clientAddressList.schematronErrors.map((e) => {
                    return new SchematronError(e);
                }));
            }
            const address = this.getAddressesByType(clientAddressList.response, addressType);
            return of(address);
        }));
    }
    // Update ATO address with given address
    updateAtoAddress(onvioAddress, atoAddressType, clientId) {
        const atoClientAddresstUrl = `/api/aulodgement/v1/client-update/${clientId}/client-address/instances/submit/type/${atoAddressType}`;
        return this.http.post(atoClientAddresstUrl, onvioAddress)
            .pipe(catchError(ExceptionHandler.handleError));
    }
    // Get ATO CUFI List call data
    getAtoClientFinanceDetails(clientId) {
        const atoClientFinancetUrl = `/api/aulodgement/v1/client-update/${clientId}/client-financial-institution/instances/list`;
        return this.http.get(atoClientFinancetUrl)
            .pipe(catchError(ExceptionHandler.handleError));
    }
    // Get promise of client finance details
    getAtoClientFinanceDetailsByProperty(clientId, financeProperty) {
        return this.getAtoClientFinanceDetails(clientId).pipe(mergeMap((clientFinanceDetail) => {
            if (clientFinanceDetail.hasErrors) {
                return throwError(clientFinanceDetail.schematronErrors.map((e) => {
                    return new SchematronError(e);
                }));
            }
            const financeDetail = clientFinanceDetail.response[financeProperty] ?
                clientFinanceDetail.response[financeProperty] : new AtoClientFinance();
            return of(financeDetail);
        }));
    }
    // update ATO CUFI submit call data
    updateAtoClientFinanceDetails(clientId, clientFinanceData) {
        const atoClientFinancetUrl = `/api/aulodgement/v1/client-update/${clientId}/client-financial-institution/instances/submit`;
        return this.http.post(atoClientFinancetUrl, clientFinanceData)
            .pipe(catchError(ExceptionHandler.handleError));
    }
    // Get ATO CUDTL List call data
    getAtoClientOtherDetails(clientId) {
        const atoClientOtherDetailsUrl = `/api/aulodgement/v1/ato-client-update/clients/${clientId}/other-details`;
        return this.http.get(atoClientOtherDetailsUrl)
            .pipe(catchError(ExceptionHandler.handleError));
    }
    // Get promise of client other details
    getAtoClientOtherDetailsByProperty(clientId, otherDetailsProperty) {
        return this.getAtoClientOtherDetails(clientId).pipe(mergeMap((clientOtherDetail) => {
            if (clientOtherDetail.hasErrors) {
                return throwError(clientOtherDetail.schematronErrors.map((e) => {
                    return new SchematronError(e);
                }));
            }
            const otherDetail = clientOtherDetail.response[otherDetailsProperty] ?
                clientOtherDetail.response[otherDetailsProperty] : new ClientOtherDetails();
            return of(otherDetail);
        }));
    }
    // Get the migration status for client associate data from ATO to Onvio.
    getMigrationStatusFromAtoToOnvio(clientId) {
        const url = `/api/autax/migration/v1/client-update/ato-onvio/clients/${clientId}/relationships`;
        return this.http.post(url, '')
            .pipe(catchError(ExceptionHandler.handleError));
    }
    // Get the response of client migrated from Ato to Onvio.
    getClientAssociateDetailsFromAto(clientId) {
        return this.getMigrationStatusFromAtoToOnvio(clientId).pipe(mergeMap((associateDetailsResponse) => {
            if (associateDetailsResponse.hasErrors) {
                return throwError(associateDetailsResponse.schematronErrors.map((e) => {
                    return new SchematronError(e);
                }));
            }
            return of(associateDetailsResponse);
        }));
    }
    // Starts client migration from ato to onvio using rabbitmq.
    startAtoClientMigration(clientId, atoOnvioMigrationV1) {
        const url = `/api/autax/migration/v1/ato-migration/migrate/clients/${clientId}`;
        return this.http.post(url, atoOnvioMigrationV1, { observe: 'response' }).pipe(catchError(ExceptionHandler.handleError));
    }
    // Update Ato Client Other Data
    updateAtoCLientOtherDetails(clientId, clientOtherDetails) {
        const atoCLientUpdateOtherDetailsUrl = `/api/aulodgement/v1/ato-client-update/clients/${clientId}/other-details`;
        return this.http.post(atoCLientUpdateOtherDetailsUrl, clientOtherDetails)
            .pipe(catchError(ExceptionHandler.handleError));
    }
    // Get filterred address from client's list of address by it's addressType.
    getAddressesByType(contactAddresses, addressType) {
        return contactAddresses[addressType] ? contactAddresses[addressType] : new AddressDescription();
    }
}
AtoIntegrationService.ɵfac = function AtoIntegrationService_Factory(t) { return new (t || AtoIntegrationService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient)); };
AtoIntegrationService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AtoIntegrationService_Factory() { return new AtoIntegrationService(i0.ɵɵinject(i1$1.HttpClient)); }, token: AtoIntegrationService, providedIn: "root" });
AtoIntegrationService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtoIntegrationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }]; }, null); })();

// System Import
class AlertService {
    constructor() {
        this.alerts = [];
        this.subjectAlert = new Subject();
    }
    // Add alert message
    show(type = 'success', msg = '', timeout = 0, id) {
        this.alerts.push({
            type,
            msg: `<div id="${id}">${msg}</div>`,
            closeable: true,
            timeout
        });
        this.subjectAlert.next(this.alerts);
    }
    // Clear all alert
    clear() {
        this.alerts = [];
        this.subjectAlert.next(this.alerts);
    }
    // Show alert message
    onAlert() {
        return this.subjectAlert.asObservable();
    }
}
AlertService.ɵfac = function AlertService_Factory(t) { return new (t || AlertService)(); };
AlertService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AlertService_Factory() { return new AlertService(); }, token: AlertService, providedIn: "root" });
AlertService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();

class ClientDetail {
}

//System imports
class ClientAssociationDetailsUpdateComponent {
    constructor(activeModal, helperService, atoIntegrationService, alertService) {
        this.activeModal = activeModal;
        this.helperService = helperService;
        this.atoIntegrationService = atoIntegrationService;
        this.alertService = alertService;
        this.entityType = AutaxStaffConstants.individualEntityType;
        this.clientDetail = new ClientDetail();
        this.isRetrieveButtonBusy = false;
        this.isDisabledCancelIcon = false;
        this.isDisabledRetrieveButton = false;
        this.isDisabledCancelButton = false;
        this.refreshStatus = false;
    }
    /**
     * Initialize client data through helper service
     * @returns void
     */
    ngOnInit() {
        this.clientDetail = this.helperService.getClientDetail();
    }
    /**
     * Unbscription before the component is destroyed
     * @returns void
     */
    ngOnDestroy() {
        if (this.unSubscription) {
            this.unSubscription.unsubscribe();
        }
    }
    /**
     * Migration of details from ATO to onvio , it will return the migration status representing success/failure
     * @returns void
     */
    migrateClientAssociationDetails() {
        this.disableAllButtonsWhileBusy();
        this.unSubscription = this.atoIntegrationService.getClientAssociateDetailsFromAto(this.clientDetail.clientId)
            .subscribe((isAssociateDataMigrated) => {
            if (isAssociateDataMigrated.response) {
                this.refreshStatus = true;
                this.helperService.setRefreshStatus(this.refreshStatus);
            }
            else {
                this.alertService.show(AlertType.danger, AutaxStaffConstants.genericToasterErrorMessage);
            }
        }, (error) => {
            if (error instanceof Array && error.every(i => i instanceof SchematronError)) {
                error.map((e, index) => {
                    this.alertService.show(AlertType.danger, e.shortDescription, undefined, `schematron_error_${index + 1}`);
                });
            }
            else {
                this.alertService.show(AlertType.danger, AutaxStaffConstants.genericToasterErrorMessage, undefined, 'get_finance_error');
            }
        }).add(() => {
            // It's like finally function
            this.enableAllButtonsWhileNotBusy();
            this.activeModal.close('cuassoc ato submit');
        });
    }
    /**
     * It will enable the busy loader and diable the cancel icon of modal, cancel button and retrieve button once the RETRIEVE button is clicked
     * @returns void
     */
    disableAllButtonsWhileBusy() {
        this.isRetrieveButtonBusy = true;
        this.isDisabledCancelIcon = true;
        this.isDisabledRetrieveButton = true;
        this.isDisabledCancelButton = true;
    }
    /**
     * It will disable the busy loader and enable the cancel icon of modal, cancel button and retrieve button after migration result.
     * @returns void
     */
    enableAllButtonsWhileNotBusy() {
        this.isRetrieveButtonBusy = false;
        this.isDisabledCancelIcon = false;
        this.isDisabledRetrieveButton = false;
        this.isDisabledCancelButton = false;
    }
}
ClientAssociationDetailsUpdateComponent.ɵfac = function ClientAssociationDetailsUpdateComponent_Factory(t) { return new (t || ClientAssociationDetailsUpdateComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(HelperService), ɵngcc0.ɵɵdirectiveInject(AtoIntegrationService), ɵngcc0.ɵɵdirectiveInject(AlertService)); };
ClientAssociationDetailsUpdateComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ClientAssociationDetailsUpdateComponent, selectors: [["autax-client-association-details-update"]], decls: 27, vars: 8, consts: [["id", "btnClose", "name", "btnClose", "type", "button", "aria-label", "Close", 1, "close", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-close-x"], [1, "modal-header"], [2, "margin", "0 auto"], [1, "modal-body"], [1, "row", "mb-3"], [1, "col-md-4", "col-sm-4", "col-xs-4", "text-right"], [1, "col-md-8", "col-sm-8", "col-xs-8", "text-left"], ["class", "row mb-3", 4, "ngIf"], [1, "modal-footer"], ["id", "btnAdd", "name", "btnAdd", "type", "button", 1, "btn", "btn-primary", "mr-auto", 3, "disabled", "bentoBusyLoader", "click"], ["id", "btnCancel", "name", "btnCancel", "type", "button", "data-dismiss", "modal", 1, "btn", "btn-outline-primary", "float-right", 3, "disabled", "click"], [1, "ng-bento"]], template: function ClientAssociationDetailsUpdateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function ClientAssociationDetailsUpdateComponent_Template_button_click_0_listener() { return ctx.activeModal.close(); });
        ɵngcc0.ɵɵelement(1, "i", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2)(3, "h1", 3);
        ɵngcc0.ɵɵtext(4, " Retrieve Relationship Details From ATO ");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(5, "div", 4)(6, "div", 5)(7, "div", 6)(8, "b");
        ɵngcc0.ɵɵtext(9, " Name :");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵtext(11);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(12, "div", 5)(13, "div", 6)(14, "b");
        ɵngcc0.ɵɵtext(15, "TFN :");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(16, "div", 7);
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(18, ClientAssociationDetailsUpdateComponent_div_18_Template, 7, 3, "div", 8);
        ɵngcc0.ɵɵtemplate(19, ClientAssociationDetailsUpdateComponent_div_19_Template, 7, 4, "div", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "div", 9)(21, "button", 10);
        ɵngcc0.ɵɵlistener("click", function ClientAssociationDetailsUpdateComponent_Template_button_click_21_listener() { return ctx.migrateClientAssociationDetails(); });
        ɵngcc0.ɵɵtext(22, "Retrieve");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "button", 11);
        ɵngcc0.ɵɵlistener("click", function ClientAssociationDetailsUpdateComponent_Template_button_click_23_listener() { return ctx.activeModal.close(); });
        ɵngcc0.ɵɵtext(24, "Cancel");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(25, "div", 12);
        ɵngcc0.ɵɵelement(26, "autax-alert");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("disabled", ctx.isDisabledCancelIcon);
        ɵngcc0.ɵɵadvance(11);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.clientDetail.clientName, " ");
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.clientDetail.clientTfn, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.clientDetail.clientType !== ctx.entityType.auIndividual);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.clientDetail.clientType === ctx.entityType.auIndividual);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", ctx.isDisabledRetrieveButton)("bentoBusyLoader", ctx.isRetrieveButtonBusy);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", ctx.isDisabledCancelButton);
    } }, directives: function () { return [ɵngcc4.BentoFocusMonitorDirective, ɵngcc1.NgIf, ɵngcc4.BentoFooterTabHelper, ɵngcc4.BentoBusyLoaderDirective, AlertComponent]; }, pipes: function () { return [AUABNFormat, ɵngcc1.DatePipe]; }, styles: [""] });
ClientAssociationDetailsUpdateComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: HelperService },
    { type: AtoIntegrationService },
    { type: AlertService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ClientAssociationDetailsUpdateComponent, [{
        type: Component,
        args: [{
                selector: 'autax-client-association-details-update',
                template: "<button id=\"btnClose\" name=\"btnClose\" type=\"button\" class=\"close\" aria-label=\"Close\"  [disabled]=\"isDisabledCancelIcon\"\r\n(click)=\"activeModal.close()\">  <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\r\n</button>\r\n<div class=\"modal-header\">\r\n<h1 style=\"margin: 0 auto;\"> Retrieve Relationship Details From ATO </h1>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <div class=\"row mb-3\">\r\n    <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n      <b> Name :</b>\r\n    </div>\r\n    <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\">\r\n      {{clientDetail.clientName}}\r\n    </div>\r\n  </div>\r\n  <div class=\"row mb-3\">\r\n    <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n      <b>TFN :</b>\r\n    </div>\r\n    <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\">\r\n      {{clientDetail.clientTfn}}\r\n    </div>\r\n  </div>\r\n  <div class=\"row mb-3\" *ngIf=\"clientDetail.clientType !== entityType.auIndividual\">\r\n    <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n      <b> ABN :</b>\r\n    </div>\r\n    <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\">\r\n      {{clientDetail.clientAbn|auABNFormat}}\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row mb-3\" *ngIf=\"clientDetail.clientType === entityType.auIndividual\">\r\n    <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n      <b> DOB :</b>\r\n    </div>\r\n    <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\">\r\n      {{clientDetail.individualDateOfBirth|date:'dd/MM/yyyy'}}\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button id=\"btnAdd\" name=\"btnAdd\" type=\"button\"  class=\"btn btn-primary mr-auto\" [disabled]=\"isDisabledRetrieveButton\"\r\n    [bentoBusyLoader]='isRetrieveButtonBusy' (click)=\"migrateClientAssociationDetails()\">Retrieve</button>\r\n  <button id=\"btnCancel\" name=\"btnCancel\"  type=\"button\"  [disabled]=\"isDisabledCancelButton\"\r\n      class=\"btn btn-outline-primary float-right\" (click)=\"activeModal.close()\" data-dismiss=\"modal\" >Cancel</button>\r\n</div>\r\n<div class=\"ng-bento\">\r\n  <autax-alert></autax-alert>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc3.NgbActiveModal }, { type: HelperService }, { type: AtoIntegrationService }, { type: AlertService }]; }, null); })();

// System imports
class CoreService {
    constructor(http) {
        this.http = http;
    }
    // NOTE: soon will have to use bm-cs-swaggergen models or @blue/services models
    // Get Tax Agent list by company Id
    getTaxAgentByCompanyId(companyId) {
        const url = `/api/core/v6/companies/${companyId}/contact-roles?pagingDataRequest.startIndex=1&pagingDataRequest.itemsPerPage=9999`;
        return this.http.get(url).pipe(catchError(ExceptionHandler.handleError));
    }
    // Get Frim data by company id
    getFirmByCompanyId(companyId) {
        const url = `/api/core/v3/companies/${companyId}/main`;
        return this.http.get(url).pipe(catchError(ExceptionHandler.handleError));
    }
    // This method will get the using the filtered criteria.
    getClientWithExpansion(companyId, postClientWithExpansionRequestV3Dto) {
        const clientUrl = `/api/core/v3/companies/${companyId}/clients/search`;
        return this.http.post(clientUrl, postClientWithExpansionRequestV3Dto)
            .pipe(map((response) => {
            return response;
        }), catchError(ExceptionHandler.handleError));
    }
    // Get client expansion data by client id
    getClientWithExpansionById(companyId, clientId) {
        const clientUrl = `/api/core/v3/companies/${companyId}/clients/${clientId}?` +
            `expand=primaryContactExpanded,primaryContactExpanded.nationalIdentitiesExpanded,` +
            `primaryContactExpanded.contactImageExpanded,clientMainExpanded`;
        return this.http.get(clientUrl)
            .pipe(map((response) => {
            this.setCurrentClientWithExpansion(response);
            return response;
        }), catchError(ExceptionHandler.handleError));
    }
    // Get promise of filterred address from client's list of address by it's addressType.
    getOnvioClientAddressesByType(companyId, clientId, addressType) {
        return this.getClientWithExpansionById(companyId, clientId).pipe(mergeMap((clientWithExpansionV3) => {
            const contactAddresses = clientWithExpansionV3.primaryContactExpanded.addresses;
            const address = this.getAddressesByType(contactAddresses, addressType);
            return of(address);
        }));
    }
    // Get list of countires that exists in onvio.
    getOnvioContactAddressCountries() {
        const contactAddressCountriesUrl = `/api/core/v1/contact-address-countries`;
        return this.http.get(contactAddressCountriesUrl)
            .pipe(map((response) => {
            return response.items;
        }), catchError(ExceptionHandler.handleError));
    }
    // Get list of state province that exists in onvio for given country code.
    getOnvioContactAddressStateProvince(country = 'AU') {
        const contactAddressStateProvinceUrl = `/api/core/v1/contact-address-state-provinces?contactAddressCountryId=${country}`;
        return this.http.get(contactAddressStateProvinceUrl)
            .pipe(map((response) => {
            return response.items;
        }), catchError(ExceptionHandler.handleError));
    }
    // Get onvio contact data by contact id
    getOnvioContact(companyId, contactId) {
        const contactV6Url = `/api/core/v6/companies/${companyId}/contacts/${contactId}`;
        return this.http.get(contactV6Url)
            .pipe(catchError(ExceptionHandler.handleError));
    }
    // update onvio contact data by contact id
    updateOnvioContact(companyId, contactId, contactData) {
        const contactV6Url = `/api/core/v6/companies/${companyId}/contacts/${contactId}`;
        return this.http.put(contactV6Url, contactData)
            .pipe(catchError(ExceptionHandler.handleError));
    }
    // Get current Client With Expansion
    getCurrentClientWithExpansion() {
        return this.currentClientWithExpansion;
    }
    // Set current Client With Expansion
    setCurrentClientWithExpansion(clientDataWithExpansion) {
        this.currentClientWithExpansion = clientDataWithExpansion;
    }
    // Get contact address countries
    getContactAddressCountries() {
        return this.contactAddressCountries;
    }
    // Set contact address countries
    setContactAddressCountries(countries) {
        this.contactAddressCountries = countries;
    }
    // Get contact address state province
    getContactAddressStateProvince() {
        return this.contactAddressStateProvince;
    }
    // Set contact address state province
    setContactAddressStateProvince(stateProvince) {
        this.contactAddressStateProvince = stateProvince;
    }
    // Get contact id from cached client data
    GetCachedContactId() {
        return this.currentClientWithExpansion.primaryContact.id;
    }
    // Get filterred address from client's list of address by it's addressType.
    getAddressesByType(contactAddresses, addressType) {
        const contactAddress = contactAddresses.filter((address) => {
            return address.addressType.id === addressType;
        })[0];
        if (contactAddress) {
            return {
                addressLine1: contactAddress.addressLine1,
                addressLine2: contactAddress.addressLine2,
                postCode: contactAddress.postalCode.toString(),
                state: contactAddress.stateProvince.name,
                suburb: contactAddress.city,
                countryName: contactAddress.country.name
            };
        }
        else {
            return new AddressDescription();
        }
    }
    // This method will get the dateOfDeath value from core.
    getOnvioClientDateOfDeath(companyId, clientId) {
        return this.getClientWithExpansionById(companyId, clientId).pipe(mergeMap((clientWithExpansionV3) => {
            const contactDateOfDeath = clientWithExpansionV3.primaryContactExpanded.dateOfDeath;
            const dateOfDeath = this.checkClientDateOfDeath(contactDateOfDeath);
            return of(dateOfDeath);
        }));
    }
    // It will check the reponse from the core anf return the caller the excpected dateOfDeath value.
    checkClientDateOfDeath(checkClientDateOfDeath) {
        if (checkClientDateOfDeath && checkClientDateOfDeath !== null) {
            return checkClientDateOfDeath;
        }
        else {
            return '';
        }
    }
    // It will set the isEntityTypeIndividual true if the entity type is individual else will written false in other cases.
    setOnvioClientEntityType(entityType) {
        if (entityType === AutaxStaffConstants.entityType.auIndividual) {
            this.isEntityTypeIndividual = true;
        }
        else {
            this.isEntityTypeIndividual = false;
        }
    }
    // This method will return the Entity Type status
    getCurrentClientEntityType() {
        return this.isEntityTypeIndividual;
    }
}
CoreService.ɵfac = function CoreService_Factory(t) { return new (t || CoreService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient)); };
CoreService.ɵprov = i0.ɵɵdefineInjectable({ factory: function CoreService_Factory() { return new CoreService(i0.ɵɵinject(i1$1.HttpClient)); }, token: CoreService, providedIn: "root" });
CoreService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CoreService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }]; }, null); })();

// System Imports
class AtoClientAssociationDetailsComponent {
    constructor(config, modalService, alertService, coreService, helperService, atoIntegrationService, zone) {
        this.modalService = modalService;
        this.alertService = alertService;
        this.coreService = coreService;
        this.helperService = helperService;
        this.atoIntegrationService = atoIntegrationService;
        this.zone = zone;
        this.onmodalclose = new EventEmitter();
        this.refreshrelationshipgrid = new EventEmitter();
        this.relationshipModel = new RelationshipStatus();
        this.isValidData = true;
        this.refreshStatus = false;
        this.clientDetail = new ClientDetail();
        config.backdrop = 'static';
        this.modalOptions = {
            container: AutaxStaffConstants.nucleusStaffModalContainer
        };
    }
    /**
     * Initialize the request validation ,once the component is loaded
     * @returns void
     */
    ngOnInit() {
        const postClientWithExpansionRequestV3Dto = {
            filterSearchSort: {
                search: this.contactdetails.id,
                searchBy: 'primaryContact.id'
            }
        };
        // set the status whether to refresh the relationship grid or not
        this.helperService.setRefreshStatus(this.refreshStatus);
        // get client contact details and start the validation
        if (this.contactdetails) {
            if (this.clientid) {
                this.getClientRelationshipDetails(this.contactdetails, this.clientid);
            }
            else {
                this.unSubscription = this.coreService.getClientWithExpansion(this.contactdetails.companyId, postClientWithExpansionRequestV3Dto).subscribe(clientList => {
                    this.getClientRelationshipDetails(this.contactdetails, clientList.items[0].id);
                });
            }
        }
    }
    /**
      * Unbscription before the component is destroyed
      * @returns void
      */
    ngOnDestroy() {
        if (this.unSubscription) {
            this.unSubscription.unsubscribe();
        }
    }
    /**
     * open the modal window when the request successfully passes the validation
     */
    open() {
        this.modalService.open(ClientAssociationDetailsUpdateComponent, this.modalOptions).result.then((result) => {
            this.refreshStatus = this.helperService.getRefreshStatus();
            if (this.refreshStatus) {
                this.refreshRelationshipGrid();
            }
            this.refreshStatus = false;
        }).catch(() => {
            noop();
        });
    }
    /**
     * It will get the client's relationship details with ATO.
     * @param clientData reuired for validation of request
     */
    getClientRelationshipDetails(clientData, clientId) {
        this.zone.run(() => {
            this.unSubscription = this.atoIntegrationService.getClientRelationship(clientId).subscribe((data) => {
                this.relationshipModel.messageStatus = data.messageStatus;
                this.relationshipModel.relationshipStatus = data.toggleStatus === 'true' ? true : false;
                this.onmodalclose.emit();
                if (this.relationshipModel.relationshipStatus) {
                    this.validatedClientData(clientData, clientId);
                }
                else {
                    this.alertService.show(AlertType.danger, AutaxStaffConstants.toggleStatusToasterErrorMessage, undefined, 'ato_remove_error');
                }
            }, (error) => {
                if (error instanceof HttpErrorResponse) {
                    switch (error.status) {
                        case 404:
                            this.alertService.show(AlertType.danger, AutaxStaffConstants.toggleStatusToasterErrorMessage, undefined, 'onvio_data_notfound');
                            break;
                        default:
                            this.alertService.show(AlertType.danger, AutaxStaffConstants.genericToasterErrorMessage, undefined, 'onvio_data_notfound');
                    }
                }
                else {
                    this.alertService.show(AlertType.danger, AutaxStaffConstants.genericToasterErrorMessage, undefined, 'onvio_data_notfound');
                }
            });
        });
    }
    /**
     * It will validate the request based on the client data
     * @param clientData required for validation of request
     */
    validatedClientData(clientData, clientId) {
        this.alertService.clear();
        let errorMessage = 'Following detail(s) are missing </br><ul>';
        if (!clientData.clientCode) {
            errorMessage = errorMessage + '<li>Client\'s ID</li>';
            this.isValidData = false;
        }
        if (!clientData.fullName) {
            errorMessage = errorMessage + '<li>Name of the Client</li>';
            this.isValidData = false;
        }
        const tfn = clientData.nationalIdentitiesExpanded.filter(function (item) {
            return item.kind.id === AutaxStaffConstants.nationalIdentitiesExpanded.auTFN;
        });
        if (tfn && !tfn[0].identity) {
            errorMessage = errorMessage + '<li>Client\'s TFN</li>';
            this.isValidData = false;
        }
        const abn = clientData.nationalIdentitiesExpanded.filter(function (item) {
            return item.kind.id === AutaxStaffConstants.nationalIdentitiesExpanded.auABN;
        });
        if (clientData.entityType.id !== AutaxStaffConstants.entityType.auIndividual) {
            if (abn && !abn[0].identity) {
                errorMessage = errorMessage + '<li>Client\'s ABN</li>';
                this.isValidData = false;
            }
        }
        if (clientData.entityType.id === AutaxStaffConstants.entityType.auIndividual) {
            if (!clientData.dateOfBirth) {
                errorMessage = errorMessage + '<li>Date of Birth</li>';
                this.isValidData = false;
            }
        }
        if (!this.isValidData) {
            errorMessage = errorMessage + '</ul>';
            this.alertService.show(AlertType.danger, errorMessage);
        }
        else {
            this.clientDetail = new ClientDetail();
            this.clientDetail.clientId = clientId;
            this.clientDetail.clientTfn = tfn[0].identity;
            this.clientDetail.intermediarySignatureIndicator = true; // Default it to "True" while creating the instance
            this.clientDetail.clientName = clientData.fullName;
            this.clientDetail.clientType = clientData.entityType.name;
            this.clientDetail.clientAbn = abn[0].identity;
            if (clientData.entityType.id === AutaxStaffConstants.entityType.auIndividual) {
                this.clientDetail.individualDateOfBirth = clientData.dateOfBirth;
            }
            this.helperService.setClientDetail(this.clientDetail);
            this.open();
        }
    }
    /**
     * It will trigger the function of core to refresh the grid and display toaster message.
     */
    refreshRelationshipGrid() {
        this.refreshrelationshipgrid.emit();
    }
}
AtoClientAssociationDetailsComponent.ɵfac = function AtoClientAssociationDetailsComponent_Factory(t) { return new (t || AtoClientAssociationDetailsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbModalConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbModal), ɵngcc0.ɵɵdirectiveInject(AlertService), ɵngcc0.ɵɵdirectiveInject(CoreService), ɵngcc0.ɵɵdirectiveInject(HelperService), ɵngcc0.ɵɵdirectiveInject(AtoIntegrationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
AtoClientAssociationDetailsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AtoClientAssociationDetailsComponent, selectors: [["autax-ato-client-association-details"]], inputs: { contactdetails: "contactdetails", clientid: "clientid" }, outputs: { onmodalclose: "onmodalclose", refreshrelationshipgrid: "refreshrelationshipgrid" }, decls: 2, vars: 0, consts: [[1, "ng-bento"]], template: function AtoClientAssociationDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "autax-alert");
        ɵngcc0.ɵɵelementEnd();
    } }, directives: function () { return [AlertComponent]; }, styles: [""] });
AtoClientAssociationDetailsComponent.ctorParameters = () => [
    { type: NgbModalConfig },
    { type: NgbModal },
    { type: AlertService },
    { type: CoreService },
    { type: HelperService },
    { type: AtoIntegrationService },
    { type: NgZone }
];
AtoClientAssociationDetailsComponent.propDecorators = {
    contactdetails: [{ type: Input }],
    clientid: [{ type: Input }],
    onmodalclose: [{ type: Output }],
    refreshrelationshipgrid: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtoClientAssociationDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'autax-ato-client-association-details',
                template: "<div class=\"ng-bento\">\r\n    <autax-alert></autax-alert>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc3.NgbModalConfig }, { type: ɵngcc3.NgbModal }, { type: AlertService }, { type: CoreService }, { type: HelperService }, { type: AtoIntegrationService }, { type: ɵngcc0.NgZone }]; }, { onmodalclose: [{
            type: Output
        }], refreshrelationshipgrid: [{
            type: Output
        }], contactdetails: [{
            type: Input
        }], clientid: [{
            type: Input
        }] }); })();

// @dynamic
class BuildRoute {
}
/**
 * to build the route that will be use to call the endpoint
 * @param  {string} route
 * @param  {any} urlParameters
 * @returns string
 */
BuildRoute.getBuildRoute = (route, urlParameters) => {
    if (urlParameters === void 0) {
        urlParameters = {};
    }
    for (let paramName in urlParameters) {
        if (urlParameters.hasOwnProperty(paramName)) {
            if (route.indexOf(paramName) === -1) {
                throw (new Error(`The url parameter ${paramName} was not found in route ${route}`));
            }
            route = route.replace(`{${paramName}}`, urlParameters[paramName]);
        }
    }
    if (route.indexOf('{') !== -1 || route.indexOf('}') !== -1) {
        throw (new Error(`The url parameters for route ${route} have not been properly replaced`));
    }
    return route;
};

// System imports
class SessionService {
    constructor() {
        this.hasPermission = has;
        this.hasFirmLicensePermission = hasFirmLicense;
        this.getRoute = getRoute;
    }
    /**
     * This method will return the current development status
     * @returns boolean
     */
    getCurrentDevelopmentPermission() {
        return this.hasCurrentDevelopment;
    }
    /**
     *  This method will check for the permission
     * @returns void
     */
    setCurrentDevelopmentPermission() {
        this.hasPermission('Internal.CurrentDevelopment').
            then((currentDevelopment) => {
            this.hasCurrentDevelopment = currentDevelopment;
        }).catch(() => {
            this.hasCurrentDevelopment = false;
        });
    }
    /**
     *  This method will return the status of Firm Licenses permission for AUTax.ATOMigrationV2
     * @returns boolean
     */
    getCurrentFirmLicensePermissionATOMigrationV2() {
        return this.hasAUTaxATOMigrationV2;
    }
    /**
     *  This method will check for the Firm Licenses permission for AUTax.ATOMigrationV2 and set value accordingly
     * @returns void
     */
    checkFirmLicensePermissionForATOMigrationV2() {
        this.hasFirmLicensePermission('AUTax.ATOMigrationV2').
            then((currentFirmLicenseDevelopment) => {
            this.hasAUTaxATOMigrationV2 = currentFirmLicenseDevelopment;
        }).catch(() => {
            this.hasAUTaxATOMigrationV2 = false;
        });
    }
    /**
     *  This method will return the status of Firm Licenses permission for AUTax.ATOTaxMigrationV1
     * @returns boolean
     */
    getCurrentFirmLicensePermissionATOTaxMigrationV1() {
        return this.hasAUTaxATOTaxMigrationV1;
    }
    /**
     *  This method will check for the Firm Licenses permission for AUTax.ATOTaxMigrationV1 and set value accordingly
     * @returns void
     */
    checkFirmLicensePermissionForATOTaxMigrationV1() {
        this.hasFirmLicensePermission('AUTax.ATOTaxMigrationV1').
            then((currentFirmLicenseDevelopment) => {
            this.hasAUTaxATOTaxMigrationV1 = currentFirmLicenseDevelopment;
        }).catch(() => {
            this.hasAUTaxATOTaxMigrationV1 = false;
        });
    }
    /**
     *  This method will return the status of Firm Licenses permission for AUTax.SAMigrationV2
     * @returns boolean
     */
    getCurrentFirmLicensePermissionSAMigrationV2() {
        return this.hasAUTaxSAMigrationV2;
    }
    /**
     *  This method will check for the Firm Licenses permission for AUTax.SAMigrationV2 and set value accordingly
     * @returns void
     */
    checkFirmLicensePermissionForSAMigrationV2() {
        this.hasFirmLicensePermission('AUTax.SAMigrationV2').
            then((currentFirmLicenseDevelopment) => {
            this.hasAUTaxSAMigrationV2 = currentFirmLicenseDevelopment;
        }).catch(() => {
            this.hasAUTaxSAMigrationV2 = false;
        });
    }
    /**
   * This method will return the current Firm Licenses development status
   * @returns boolean
   */
    getCurrentFirmLicenseDevelopmentPermission() {
        return this.hasCurrentFirmLicenseDevelopment;
    }
    /**
     *  This method will check for the Firm Licenses permission and set value accordingly
     * @returns void
     */
    setCurrentFirmLicenseDevelopmentPermission(license) {
        this.hasFirmLicensePermission(license).
            then((currentFirmLicenseDevelopment) => {
            this.hasCurrentFirmLicenseDevelopment = currentFirmLicenseDevelopment;
        }).catch(() => {
            this.hasCurrentFirmLicenseDevelopment = false;
        });
    }
    /**
     *  This method will check for the Firm Licenses permission
     * @returns boolean
     */
    getCurrentFirmLicenseDevelopmentPermissionByLicence(license) {
        return this.hasFirmLicensePermission(license).
            then((currentFirmLicenseDevelopment) => {
            return currentFirmLicenseDevelopment;
        }).catch(() => {
            return false;
        });
    }
    /**
     * to get the base path
     * @param  {string} serviceName
     * @returns Promise
     */
    getBasePath(serviceName) {
        return this.getRoute(serviceName).then(result => {
            console.log('result');
            return this.stripDomainName(result);
        }, err => {
            console.log('error encountered', err);
            return err;
        });
    }
    /**
     * to strip domain name
     * @param  {string} route
     * @returns string
     */
    stripDomainName(route) {
        let routeSegments = route.split('/');
        routeSegments = routeSegments.slice(3, routeSegments.length);
        const joinedRouteSegments = routeSegments.join('/');
        const strippedDomainName = `/${joinedRouteSegments}`;
        return strippedDomainName;
    }
}
SessionService.ɵfac = function SessionService_Factory(t) { return new (t || SessionService)(); };
SessionService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SessionService_Factory() { return new SessionService(); }, token: SessionService, providedIn: "root" });
SessionService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SessionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

var EndpointRoute;
(function (EndpointRoute) {
    EndpointRoute["Get_v1_LodgementReport"] = "v1/atoreports/ldgprgm/{currentYear}/summary";
    EndpointRoute["Get_v1_SubscriptionByCompany"] = "v1/atoreports/ldgprgm/companies/{companyId}/subscriptions";
    EndpointRoute["Get_v1_atoreports_ldgprgm"] = "v1/atoreports/ldgprgm";
    EndpointRoute["Get_v1_successItcrptReport"] = "v1/atoreports/itcrpt?status=Success&latestOnly=true";
    EndpointRoute["Get_v1_pendingItcrptReport"] = "v1/atoreports/itcrpt?status=Pending&latestOnly=true";
    EndpointRoute["Post_v1_atoToOnvio_clientMigration"] = "v1/migrate/atoclient";
    EndpointRoute["Post_v1_atoToOnvio_bulkMigration"] = "v1/ato-migration/migrate";
    EndpointRoute["Post_v1_itcrpt_clientMigration"] = "v1/atoreports/migrateitcrpt";
    EndpointRoute["Post_v2_Startmigration"] = "v2/migrate";
    EndpointRoute["Post_v1_Migrate"] = "v1/softassist-migration/migrate";
    EndpointRoute["Get_v1_directDebitHolidays"] = "v1/atoreports/holidays";
})(EndpointRoute || (EndpointRoute = {}));
var ServiceKey;
(function (ServiceKey) {
    ServiceKey["AUTaxReportingServices"] = "AUTaxReportingServices";
    ServiceKey["AUTaxMigrationServices"] = "AUTaxMigrationServices";
})(ServiceKey || (ServiceKey = {}));
var UrlParameter;
(function (UrlParameter) {
    UrlParameter["TaxYear"] = "currentYear";
    UrlParameter["SubscriptionValue"] = "subscribe";
    UrlParameter["CompanyId"] = "companyId";
})(UrlParameter || (UrlParameter = {}));

class AuTaxLodgePerformanceService {
    /**
     * Instantiate the service
     * @param  {HttpClient} privatehttp Injected http service for dependency
     * @param  {SessionService} session Bluemoon service injected for dependency
     */
    constructor(http, session) {
        this.http = http;
        this.session = session;
        this.barGraphObservable = new Subject$1();
        this.yearToDateObservable = new Subject$1();
        this.currentYear = formatDate(new Date(), 'yyyy', 'en-AU');
        this.UDSLongToken = ""; //insert token here;
    }
    /**
     * send bar graph data to observable
     * @param  {OverallProgressData} barGraphData the overall progress data
     * @returns void
     */
    sendBarGraphData(barGraphData, errorMessage) {
        var _a;
        if (barGraphData == null) {
            const errorMsg = (_a = errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.ErrorMessage) !== null && _a !== void 0 ? _a : AutaxStaffConstants.errorConstant;
            this.barGraphObservable.error(errorMsg);
        }
        else {
            this.barGraphObservable.next(barGraphData);
        }
    }
    /**
     * send year to date data to observable
     * @param  {yearToDateData} yearToDateData the year to date data
     * @returns void
     */
    sendYearToDateData(yearToDateData, errorMessage) {
        var _a;
        if (yearToDateData == null) {
            const errorMsg = (_a = errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.ErrorMessage) !== null && _a !== void 0 ? _a : AutaxStaffConstants.errorConstant;
            this.yearToDateObservable.error(errorMsg);
        }
        else {
            this.yearToDateObservable.next(yearToDateData);
        }
    }
    /**
     * Observable that returns bar graph data
     * @returns Observable of Overall Progress Data
     */
    getBargraphData() {
        return this.barGraphObservable.asObservable();
    }
    /**
     * Observable that returns year to date data
     * @returns Observable of Year to date data
     */
    getYearToDateData() {
        return this.yearToDateObservable.asObservable();
    }
    /**
     * Get server data from API
     * @returns Observable Server Data that contains bar graph and year to date data
     */
    getLodgementPerformanceData() {
        return from(this.session.getBasePath(ServiceKey.AUTaxReportingServices)).pipe(mergeMap((basePath) => this.http.get(`${basePath}/` + BuildRoute.getBuildRoute(EndpointRoute.Get_v1_LodgementReport, {
            [UrlParameter.TaxYear]: this.currentYear
        }))
            .pipe(map((data) => data), catchError(() => of(null)))));
    }
    /**
     * Get the subscription value from the backend
     * @param  {} companyId
     * @returns Observable an observable of the backend response containing the subscription flag
     */
    getLodgementSubscriptionByCompanyId(companyId) {
        return from(this.session.getBasePath(ServiceKey.AUTaxReportingServices)).pipe(mergeMap((basePath) => this.http.get(`${basePath}/` + BuildRoute.getBuildRoute(EndpointRoute.Get_v1_SubscriptionByCompany, {
            [UrlParameter.CompanyId]: companyId
        }))
            .pipe(map((data) => data), catchError(() => of(null)))));
    }
    /**
     * Get lodge report from back end
     * @returns Observable
     */
    getClientRequestReportData() {
        return from(this.session.getBasePath(ServiceKey.AUTaxReportingServices)).pipe(mergeMap((basePath) => this.http.get(`${basePath}/${BuildRoute.getBuildRoute(EndpointRoute.Get_v1_atoreports_ldgprgm, {})}`)
            .pipe(map((data) => data), catchError(() => of(null)))));
    }
    showHideWidget(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let getLodgeSubsByCmpnyId = yield this.getLodgementSubscriptionByCompanyId(companyId).toPromise();
                if (getLodgeSubsByCmpnyId) {
                    let getClientData = yield this.getClientRequestReportData().toPromise();
                    if (getClientData != null) {
                        return getClientData.length != 0 ? true : false;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
            catch (error) {
                return false;
            }
        });
    }
}
AuTaxLodgePerformanceService.ɵfac = function AuTaxLodgePerformanceService_Factory(t) { return new (t || AuTaxLodgePerformanceService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(SessionService)); };
AuTaxLodgePerformanceService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AuTaxLodgePerformanceService_Factory() { return new AuTaxLodgePerformanceService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(SessionService)); }, token: AuTaxLodgePerformanceService, providedIn: "root" });
AuTaxLodgePerformanceService.ctorParameters = () => [
    { type: HttpClient },
    { type: SessionService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuTaxLodgePerformanceService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: SessionService }]; }, null); })();

class YearToDateGraphComponent {
    /**
     * Construct component
     * @param  {AuTaxLodgePerformanceService} privateparentService Service from AutaxLodgePerformance(parent component's service)
     */
    constructor(parentService) {
        this.parentService = parentService;
        this.dueToday = 0;
        this.lodgeOnTime = 0;
        this.lodgeLate = 0;
        this.toBeLodge = 0;
        this.lodgedOnTimeDeferred = 0;
        this.returnNotNecessary = 0;
        this.furtherReturnNotNecessary = 0;
        this.totalLodgedOnTime = 0;
        this.loadingFailed = true;
        this.targetHit = false;
        this.isBusyLoaderBusy = false;
        this.loading = true;
        this.color = 'cst-text-red';
        this.alerts = [];
        this.dataOne = [];
        this.currentDate = formatDate(new Date(), 'd MMM yyyy', 'en-AU');
    }
    /**
     * Loads data from the parent component
     * @returns void
     */
    ngOnInit() {
        this.loadFromParent();
    }
    /**
     * Unsubscribe to parent service's Subject on component before component is destroyed
     * @returns void
     */
    ngOnDestroy() {
        if (this.subscriptionToParent) {
            this.subscriptionToParent.unsubscribe();
        }
    }
    /**
     * Formats large numbers with comma
     * @param  {x} x any number
     * @returns string formatted with comma
     */
    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    /**
    * Pulls data from the parent component and supply values to the doughnut graph
     * @returns void
     */
    loadFromParent() {
        this.subscriptionToParent = this.parentService.getYearToDateData().subscribe(apiData => {
            this.loadingFailed = false;
            this.loading = false;
            let ytd = apiData;
            this.lodgementPercentage = ytd.lodgmentPercentage;
            this.checkLodgementPercentage();
            this.dueToday = ytd.dueBy;
            this.lodgeOnTime = +ytd.lodgedOnTime;
            this.lodgeLate = +ytd.lodgedLate;
            this.toBeLodge = +ytd.toBeLodge;
            this.lodgedOnTimeDeferred = +ytd.lodgedOnTimeDeferred;
            this.returnNotNecessary = +ytd.returnNotNecessary;
            this.furtherReturnNotNecessary = +ytd.furtherReturnNotNecessary;
            this.totalLodgedOnTime = (this.lodgeOnTime + this.lodgedOnTimeDeferred + this.returnNotNecessary + this.furtherReturnNotNecessary);
            this.dataOne = [
                {
                    name: 'Lodge On Time',
                    y: this.totalLodgedOnTime,
                    color: '#0099C4'
                },
                {
                    name: 'Lodge late',
                    y: this.lodgeLate,
                    color: '#ABABAB'
                },
                {
                    name: 'To Be Lodge',
                    y: this.toBeLodge,
                    color: '#ffffff'
                }
            ];
            this.dataBasic = {
                plotOptions: {
                    pie: {
                        dataLabels: {
                            enabled: false,
                            inside: false,
                            format: d => { } //remove label format since it is disabled
                        }
                    },
                    series: {
                        allowPointSelect: false
                    }
                },
                series: [
                    {
                        size: '0.9',
                        innerSize: '0.7',
                        data: this.dataOne
                    }
                ],
                tooltip: {
                    enabled: false,
                    formatter: d => this.generateTooltip()
                }
            };
        }, error => {
            console.error('Error encountered', error);
            this.loadingFailed = true;
            this.loading = false;
            this.dataOne = this.dataOne;
            this.dataBasic = this.dataBasic;
            this.showErrorMessage(error === AutaxStaffConstants.errorConstant ? null : error);
        });
    }
    /**
     * Displays error message on the HTML file when requests failed
     * @returns void
     */
    showErrorMessage(errorMsg) {
        this.loading = false; //remove the loader to show the error
        const errMsg = errorMsg !== null && errorMsg !== void 0 ? errorMsg : 'An error was encountered. Please refresh the page. If problem persists, please contact <a rel="noopener" target="_blank" href="https://taxtraining.thomsonreuters.com.au/products/onvio/contact-us">Onvio Support</a>.';
        this.alerts.push({
            type: 'warning',
            msg: errMsg,
            closeable: false
        });
    }
    /*
    * Generates and format tooltip for donut graph
    */
    /**
     * @returns string for innerHTML of tooltip
     */
    generateTooltip() {
        const tooltipTemplate = '<span class=\'tooltip-text-35\'> Due By ' + this.currentDate.toString() + ': <strong>' + this.numberWithCommas(this.dueToday) + '</strong> </span>  <br>' +
            '<span class=\'tooltip-text-0\'> Lodged On Time: <span class=\'cst-text-blue\'> <strong>' + this.numberWithCommas(this.lodgeOnTime) + '</strong> </span> </span> <br>' +
            '<span class=\'tooltip-text-0\'> Lodged On Time Deffered: <span class=\'cst-text-blue\'> <strong>' + this.numberWithCommas(this.lodgedOnTimeDeferred) + '</strong> </span> </span> <br>' +
            '<span class=\'tooltip-text-0\'> Return Not Necessary: <span class=\'cst-text-blue\'> <strong>' + this.numberWithCommas(this.returnNotNecessary) + '</strong> </span> </span> <br> ' +
            '<span class=\'tooltip-text-0\'> Further Return Not Necessary: <span class=\'cst-text-blue\'> <strong>' + this.numberWithCommas(this.furtherReturnNotNecessary) + '</strong> </span> </span> <br> ' +
            '<span class=\'tooltip-text-35\'> Lodged Late: <span class=\'cst-text-gray\'> <strong>' + this.numberWithCommas(this.lodgeLate) + '</strong> </span> </span>  <br> ' +
            '<span class=\'tooltip-text-25\'> Lodgment Percentage: <span class=\'' + this.color + '\'><strong> ' + this.lodgementPercentage + '</strong> </span>  </span>';
        return tooltipTemplate;
    }
    /**
     * Use for default values to supply when doing unit tests
     * @returns void
     */
    useMockDataForTesting() {
        this.loadingFailed = false;
        this.dueToday = 588;
        this.lodgeOnTime = 4254;
        this.lodgeLate = 575;
        this.toBeLodge = 0;
        this.lodgedOnTimeDeferred = 0;
        this.returnNotNecessary = 25;
        this.furtherReturnNotNecessary = 15;
        this.totalLodgedOnTime = (this.lodgeOnTime + this.lodgedOnTimeDeferred + this.returnNotNecessary + this.furtherReturnNotNecessary);
        this.lodgementPercentage = "100.0 %";
        this.checkLodgementPercentage();
        this.dataOne = [
            {
                name: 'Lodge On Time',
                y: this.totalLodgedOnTime,
                color: '#0099C4'
            },
            {
                name: 'Lodge late',
                y: this.lodgeLate,
                color: '#ABABAB'
            },
            {
                name: 'To Be Lodge',
                y: this.toBeLodge,
                color: '#ffffff'
            }
        ];
        this.dataBasic = {
            plotOptions: {
                pie: {
                    dataLabels: {
                        enabled: false,
                        inside: false,
                        format: d => { } //remove label format since it is disabled
                    }
                },
                series: {
                    allowPointSelect: false
                }
            },
            series: [
                {
                    size: '0.9',
                    innerSize: '0.7',
                    data: this.dataOne
                }
            ],
            tooltip: {
                enabled: false,
                formatter: d => this.generateTooltip()
            }
        };
    }
    /**
     * To check the value of this.lodgementPercentage and set the lodgementPercentage color to green if hits the target 100%,
     * if not will set the class as red
     * @returns void
     */
    checkLodgementPercentage() {
        let LP = this.lodgementPercentage.split('%');
        let LPTrimmed = parseFloat(LP[0].trim());
        if (LPTrimmed >= 85) {
            this.targetHit = true;
            this.color = 'cst-text-green';
        }
        else {
            this.targetHit = false;
            this.color = 'cst-text-red';
        }
    }
}
YearToDateGraphComponent.ɵfac = function YearToDateGraphComponent_Factory(t) { return new (t || YearToDateGraphComponent)(ɵngcc0.ɵɵdirectiveInject(AuTaxLodgePerformanceService)); };
YearToDateGraphComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: YearToDateGraphComponent, selectors: [["year-to-date-graph"]], viewQuery: function YearToDateGraphComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BentoD3PieChartComponent, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.pieChart = _t.first);
    } }, decls: 3, vars: 4, consts: [["id", "bento-busyloader-demo-container", 1, "container", "graph-container", 3, "bentoBusyLoader", "size"], ["class", "text-center", 4, "ngIf"], [4, "ngIf"], [1, "text-center"], [1, "donut"], [1, "donut-title"], [1, "percentage"], [1, "custom-pie", 3, "options"], [1, "donut-graph-card-label", "label-text-style"], [1, "d-inline", "mr-2"], [1, "lodge-on-time-dot"], [1, "lodge-late-dot"], [1, "to-be-dot"], ["id", "alerts", 3, "inline", "items"]], template: function YearToDateGraphComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, YearToDateGraphComponent_div_1_Template, 19, 4, "div", 1);
        ɵngcc0.ɵɵtemplate(2, YearToDateGraphComponent_div_2_Template, 2, 2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx.loading)("size", "sm");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.loadingFailed);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loadingFailed);
    } }, directives: [ɵngcc4.BentoBusyLoaderDirective, ɵngcc1.NgIf, ɵngcc5.BentoD3PieChartComponent, ɵngcc4.BentoAlertComponent], styles: [".graph-container[_ngcontent-%COMP%]{padding:50px 2px}.custom-pie[_ngcontent-%COMP%]{width:100%!important;position:absolute;top:50%!important;left:50%!important;transform:translate(-50%,-50%)}.donut[_ngcontent-%COMP%]{position:relative;height:300px}.percentage[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:80px}  bento-d3-pie-chart .hover-path:nth-child(4),   bento-d3-pie-chart .hover-path:nth-child(6),   bento-d3-pie-chart .path:nth-child(4),   bento-d3-pie-chart .path:nth-child(6){stroke:#0099c4!important;stroke-width:2px!important;stroke-linejoin:bevel!important}  bento-d3-pie-chart .hover-path:nth-child(5),   bento-d3-pie-chart .path:nth-child(5){stroke:#ababab!important;stroke-width:2px!important;stroke-linejoin:bevel!important}  .tooltip .tooltip-inner{border:.0625rem solid #929292!important;background-color:#f4f5f7!important}  .tooltip-inner{max-width:250px!important;color:#000!important;text-align:left!important;width:182px!important}  #d3-tooltip-709380 .bento-d3-tooltip{position:absolute;pointer-events:none;padding-left:120px!important;padding-top:80px!important}  #d3-tooltip-709380 .bento-d3-tooltip.tooltip.top .tooltip-arrow{border-top-color:#f4f5f7!important}  #d3-tooltip-709380 .bento-d3-tooltip.tooltip.top .tooltip-arrow{bottom:-14px!important;left:44%!important;margin-left:-5px!important;position:absolute;width:0!important;height:0!important;border:solid transparent!important;border-width:15px 15px 0!important}.text-center[_ngcontent-%COMP%]{text-align:center!important}.donut-graph-card[_ngcontent-%COMP%]{height:250px!important;width:250px!important;position:absolute}.donut-graph-card-label[_ngcontent-%COMP%]{height:auto!important;position:relative;text-align:center!important}.percentage-text-red[_ngcontent-%COMP%]{color:#dc3124}.percentage-text-green[_ngcontent-%COMP%], .percentage-text-red[_ngcontent-%COMP%]{font-size:35px;font-weight:500;position:absolute;top:50%;left:50%;margin:0 -50% 0 0;transform:translate(-50%,-50%)}.percentage-text-green[_ngcontent-%COMP%]{color:#15ba49}.red[_ngcontent-%COMP%]{color:#dc3124}.green[_ngcontent-%COMP%]{color:#15ba49}.lodge-on-time-dot[_ngcontent-%COMP%]{background-color:#0099c4}.lodge-late-dot[_ngcontent-%COMP%], .lodge-on-time-dot[_ngcontent-%COMP%]{height:10px;width:10px;border-radius:50%;display:inline-block}.lodge-late-dot[_ngcontent-%COMP%]{background-color:#ababab}.to-be-dot[_ngcontent-%COMP%]{height:11px;width:11px;background-color:#fff;border-radius:50%;display:inline-block;border:1.9px solid #0099c4}.donut-title[_ngcontent-%COMP%]{margin:0;line-height:25px;font-weight:700;font-size:18px}.donut-title[_ngcontent-%COMP%], .label-text-style[_ngcontent-%COMP%]{font-family:Knowledge;font-style:normal}.label-text-style[_ngcontent-%COMP%]{font-weight:400;font-size:16px;margin-top:-10px}  #donut bento-d3-pie-chart .tooltip .tooltip-inner{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:left!important;background-color:#000;border-radius:.357rem}  bento-d3-pie-chart div.bento-d3-tooltip.tooltip.top .tooltip-arrow{border-top-color:#f4f5f7!important}  bento-d3-pie-chart div.bento-d3-tooltip.tooltip.top .tooltip-arrow{top:50%!important;left:42%!important;margin-left:0!important;border-width:29px 15px 0!important;position:absolute;width:0!important;height:0!important;border-style:solid;transform:rotate(90deg)}  bento-d3-pie-chart div.bento-d3-tooltip{border:none;position:absolute;pointer-events:none;padding-left:32%!important;top:50px!important;left:218px!important}  bento-d3-pie-chart div.tooltip{z-index:2001;border:none;box-shadow:none}  bento-d3-pie-chart div.tooltip>.tooltip-arrow,   bento-d3-pie-chart div.tooltip>.tooltip-arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent!important;border-style:solid}  .tooltip-text-35{line-height:35px;font-size:.7rem;font-family:Knowledge;font-weight:400;font-style:normal}  .tooltip-text-25{line-height:25px;font-size:.7rem;font-family:Knowledge;font-weight:400;font-style:normal}  .tooltip-text-0{line-height:0px;font-size:.7rem;font-family:Knowledge;font-weight:400;font-style:normal}  .cst-text-blue{color:#0099c4}  .cst-text-red{color:#dc3124}  .cst-text-gray{color:#717172}  .cst-text-green{color:#15ba49}"] });
YearToDateGraphComponent.ctorParameters = () => [
    { type: AuTaxLodgePerformanceService }
];
YearToDateGraphComponent.propDecorators = {
    pieChart: [{ type: ViewChild, args: [BentoD3PieChartComponent, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(YearToDateGraphComponent, [{
        type: Component,
        args: [{
                selector: 'year-to-date-graph',
                template: "<div [bentoBusyLoader]=\"loading\" [size]=\"'sm'\" id=\"bento-busyloader-demo-container\" class=\"container graph-container\">\r\n    <div class=\"text-center\" *ngIf=\"!loadingFailed\">\r\n      <div class=\"donut\">\r\n        <h4 class=\"donut-title\">YEAR TO DATE ON TIME LODGMENT PERFORMANCE</h4>\r\n        <div class =\"percentage\">\r\n          <span [class]=\"targetHit? 'percentage-text-green': 'percentage-text-red'\"> <strong>{{this.lodgementPercentage}}</strong> </span>\r\n        </div>\r\n        <bento-d3-pie-chart class=\"custom-pie\" [options]=\"dataBasic\"></bento-d3-pie-chart>\r\n      </div>\r\n      <div class=\"donut-graph-card-label label-text-style\">\r\n        <div class=\"d-inline mr-2\">\r\n          <span class=\"lodge-on-time-dot\"></span> Lodged On Time\r\n        </div>\r\n        <div class=\"d-inline mr-2\">\r\n          <span class=\"lodge-late-dot\"></span> Lodged Late\r\n        </div>\r\n        <div class=\"d-inline mr-2\">\r\n          <span class=\"to-be-dot\"></span> To Be Lodged\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div *ngIf=\"loadingFailed\">\r\n      <bento-alert id=\"alerts\" [inline]=\"true\" [items]=\"alerts\"></bento-alert>\r\n    </div>\r\n  </div>\r\n\r\n",
                styles: [".graph-container{padding:50px 2px}.custom-pie{width:100%!important;position:absolute;top:50%!important;left:50%!important;transform:translate(-50%,-50%)}.donut{position:relative;height:300px}.percentage{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:80px}::ng-deep bento-d3-pie-chart .hover-path:nth-child(4),::ng-deep bento-d3-pie-chart .hover-path:nth-child(6),::ng-deep bento-d3-pie-chart .path:nth-child(4),::ng-deep bento-d3-pie-chart .path:nth-child(6){stroke:#0099c4!important;stroke-width:2px!important;stroke-linejoin:bevel!important}::ng-deep bento-d3-pie-chart .hover-path:nth-child(5),::ng-deep bento-d3-pie-chart .path:nth-child(5){stroke:#ababab!important;stroke-width:2px!important;stroke-linejoin:bevel!important}::ng-deep .tooltip .tooltip-inner{border:.0625rem solid #929292!important;background-color:#f4f5f7!important}::ng-deep .tooltip-inner{max-width:250px!important;color:#000!important;text-align:left!important;width:182px!important}::ng-deep #d3-tooltip-709380 .bento-d3-tooltip{position:absolute;pointer-events:none;padding-left:120px!important;padding-top:80px!important}::ng-deep #d3-tooltip-709380 .bento-d3-tooltip.tooltip.top .tooltip-arrow{border-top-color:#f4f5f7!important}::ng-deep #d3-tooltip-709380 .bento-d3-tooltip.tooltip.top .tooltip-arrow{bottom:-14px!important;left:44%!important;margin-left:-5px!important;position:absolute;width:0!important;height:0!important;border:solid transparent!important;border-width:15px 15px 0!important}.text-center{text-align:center!important}.donut-graph-card{height:250px!important;width:250px!important;position:absolute}.donut-graph-card-label{height:auto!important;position:relative;text-align:center!important}.percentage-text-red{color:#dc3124}.percentage-text-green,.percentage-text-red{font-size:35px;font-weight:500;position:absolute;top:50%;left:50%;margin:0 -50% 0 0;transform:translate(-50%,-50%)}.percentage-text-green{color:#15ba49}.red{color:#dc3124}.green{color:#15ba49}.lodge-on-time-dot{background-color:#0099c4}.lodge-late-dot,.lodge-on-time-dot{height:10px;width:10px;border-radius:50%;display:inline-block}.lodge-late-dot{background-color:#ababab}.to-be-dot{height:11px;width:11px;background-color:#fff;border-radius:50%;display:inline-block;border:1.9px solid #0099c4}.donut-title{margin:0;line-height:25px;font-weight:700;font-size:18px}.donut-title,.label-text-style{font-family:Knowledge;font-style:normal}.label-text-style{font-weight:400;font-size:16px;margin-top:-10px}::ng-deep #donut bento-d3-pie-chart .tooltip .tooltip-inner{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:left!important;background-color:#000;border-radius:.357rem}::ng-deep bento-d3-pie-chart div.bento-d3-tooltip.tooltip.top .tooltip-arrow{border-top-color:#f4f5f7!important}::ng-deep bento-d3-pie-chart div.bento-d3-tooltip.tooltip.top .tooltip-arrow{top:50%!important;left:42%!important;margin-left:0!important;border-width:29px 15px 0!important;position:absolute;width:0!important;height:0!important;border-style:solid;transform:rotate(90deg)}::ng-deep bento-d3-pie-chart div.bento-d3-tooltip{border:none;position:absolute;pointer-events:none;padding-left:32%!important;top:50px!important;left:218px!important}::ng-deep bento-d3-pie-chart div.tooltip{z-index:2001;border:none;box-shadow:none}::ng-deep bento-d3-pie-chart div.tooltip>.tooltip-arrow,::ng-deep bento-d3-pie-chart div.tooltip>.tooltip-arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent!important;border-style:solid}::ng-deep .tooltip-text-35{line-height:35px;font-size:.7rem;font-family:Knowledge;font-weight:400;font-style:normal}::ng-deep .tooltip-text-25{line-height:25px;font-size:.7rem;font-family:Knowledge;font-weight:400;font-style:normal}::ng-deep .tooltip-text-0{line-height:0px;font-size:.7rem;font-family:Knowledge;font-weight:400;font-style:normal}::ng-deep .cst-text-blue{color:#0099c4}::ng-deep .cst-text-red{color:#dc3124}::ng-deep .cst-text-gray{color:#717172}::ng-deep .cst-text-green{color:#15ba49}"]
            }]
    }], function () { return [{ type: AuTaxLodgePerformanceService }]; }, { pieChart: [{
            type: ViewChild,
            args: [BentoD3PieChartComponent, { static: true }]
        }] }); })();

class GraphData {
    constructor(totalDue, minimumLodgementTarget, remainingLodgementTarget, lodgedOnTime, lodgedLate, dueToday, lodgedOnTimeDeferred, returnNotNecessary, furtherReturnNotNecessary, customizations) {
        this.totalDue = totalDue;
        this.minimumLodgementTarget = minimumLodgementTarget;
        this.remainingLodgementTarget = remainingLodgementTarget;
        this.lodgedOnTime = lodgedOnTime;
        this.lodgedLate = lodgedLate;
        this.dueToday = dueToday;
        this.lodgedOnTimeDeferred = lodgedOnTimeDeferred;
        this.returnNotNecessary = returnNotNecessary;
        this.furtherReturnNotNecessary = furtherReturnNotNecessary;
        this.customizations = customizations;
    }
}

class LodgementOverallProgressGraphComponent {
    /**
     * Construct component
     * @param  {Renderer2} privaterenderer Will be used for DOM rendering
     * @param  {ElementRef} privateel Will be used for DOM queries and selections
     * @param  {AuTaxLodgePerformanceService} privateparentService Service from AutaxLodgePerformance(parent component's service)
     */
    constructor(renderer, el, parentService) {
        this.renderer = renderer;
        this.el = el;
        this.parentService = parentService;
        this.alerts = [];
        this.parentData = null;
        this.currentError = null;
        this.dateNow = formatDate(new Date(), 'd MMM yyyy', 'en-AU');
        this.zeroBarX = null;
        this.isBusyLoaderBusy = false;
        this.styleConstants = {
            visibilityStyle: 'visibility',
            visibilityHidden: 'hidden',
            visibilityShown: 'true'
        };
        this.mockRender = false;
        this.hasBeenResized = false;
        this.graphData = new GraphData(10, 10, 10, 0, 0, 0, 0, 0, 0, {
            markerOffsetX: 24,
            markerOffsetY: 8,
            colors: ['#0099C4', '#ABABAB', 'green', 'orange', 'transparent'],
            markerColors: {
                dueComplete: 'green',
                minimumUnreached: 'orange',
                unreachedDue: 'red',
                dueReachedMinimum: '#0099C4',
                minimumReached: 'green'
            }
        });
    }
    /**
     * Initialize graph after creating the component
     * @returns void
     */
    ngOnInit() {
        try {
            this.initializeGraph();
        }
        catch (e) {
            console.error('error on init');
            this.currentError = 'INITFAILED';
        }
        this.getDataFromParent();
    }
    /**
     * Create resize event handler after view initialization
     * @returns void
     */
    ngAfterViewInit() {
        this.resizerSubscription = this.fromEvent(window, 'resize').pipe(tap(() => {
            this.startLoading();
            this.hasBeenResized = true;
        }), debounceTime(400), tap(() => {
            this.stopLoading();
        }))
            .subscribe(() => {
            this.renderer.destroy();
            this.customizeBarGraph();
            this.resizeCanvas();
            this.removeGraphExtraLine();
            this.stopLoading();
            this.hasBeenResized = false;
        });
    }
    /**
     * Unsubscribe to parent service's Subject on component before component is destroyed
     * @returns void
     */
    ngOnDestroy() {
        if (this.mockRender === false) {
            if (this.subscriptionToParent) {
                this.subscriptionToParent.unsubscribe();
            }
        }
        else {
            this.branchMethod();
        }
    }
    /**
     * Subscribe to parent service and get data
     * @returns void
     */
    getDataFromParent() {
        this.startLoading();
        const component = this;
        this.subscriptionToParent = this.parentService.getBargraphData().subscribe(apiData => {
            this.parentData = apiData;
            setTimeout(() => {
                component.pushToGraph(this.parentData);
            }, 200);
        }, error => {
            this.isBusyLoaderBusy = false;
            component.currentError = 'NODATA';
            this.showErrorMessage(error === AutaxStaffConstants.errorConstant ? null : error);
        });
    }
    /**
     * Push data to Bento Graph then refresh
     * @param  {OverallProgressData} data data to push to the graph
     * @returns void
     */
    pushToGraph(data) {
        this.graphData = new GraphData(data.totalDueForYear, data.minimumLodgmentTarget, data.remainingLodgmentTarget, data.lodgedOnTime, data.lodgedLate, data.dueBy, data.lodgedOnTimeDeferred, data.returnNotNecessary, data.furtherReturnNotNecessary, this.graphData.customizations);
        let lodgedOnTimeCount = data.lodgedOnTime + data.lodgedOnTimeDeferred + data.returnNotNecessary + data.furtherReturnNotNecessary;
        let seriesData = {
            data: [lodgedOnTimeCount, 0 - data.lodgedLate, data.dueBy, data.totalDueForYear, data.minimumLodgmentTarget]
        };
        this.graphOptions.series = [seriesData];
        this.barChart.refresh();
        this.customizeBarGraph();
        this.removeGraphExtraLine();
        this.resizeCanvas();
        this.isBusyLoaderBusy = false;
    }
    /**
     *  Displays error message on the HTML file when requests failed
     * @returns void
     */
    showErrorMessage(errorMsg) {
        this.setStyle(this.el.nativeElement.querySelector('.overall-progress-graph-container'), this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
        const errMsg = errorMsg !== null && errorMsg !== void 0 ? errorMsg : 'An error was encountered. Please refresh the page. If problem persists, please contact <a rel="noopener" target="_blank" href="https://taxtraining.thomsonreuters.com.au/products/onvio/contact-us">Onvio Support</a>.';
        this.alerts.push({
            type: 'warning',
            msg: errMsg,
            closeable: false
        });
    }
    /**
     * Initialize Bento D3 Bar Graph with initial data
     * @returns void
     */
    initializeGraph() {
        const seriesData = {
            data: [
                this.graphData.lodgedOnTime,
                this.graphData.lodgedLate,
                this.graphData.dueToday,
                this.graphData.totalDue,
                this.graphData.minimumLodgementTarget
            ]
        };
        this.graphOptions = {
            chart: { marginTop: 20, marginRight: 10, marginBottom: 60, marginLeft: 45, height: 300 },
            yAxis: {
                categories: ['ontime', 'late', 'duetoday', 'total', 'minimum']
            },
            colors: this.graphData.customizations.colors,
            series: [seriesData],
            tooltip: {
                formatter: d => this.generateTooltip()
            },
        };
    }
    /**
     * Generates the tooltip to be shown by the graph on hover
     * @returns string the tooltip inner HTML
     */
    generateTooltip() {
        const totalLodgeOnTime = this.graphData.lodgedOnTime + this.graphData.lodgedOnTimeDeferred + this.graphData.returnNotNecessary + this.graphData.furtherReturnNotNecessary;
        const requiredOnTime = this.graphData.minimumLodgementTarget - totalLodgeOnTime;
        const stillToBeLodged = this.graphData.totalDue - (totalLodgeOnTime + this.graphData.lodgedLate);
        const tooltipNewTemplate = `
        <span class="tooltipHeader">Summary</span>
        <br>Total Lodgments Due: <strong>${this.numberWithCommas(this.graphData.totalDue)}</strong>
        <br><br>Annual 85% Target: <strong>${this.numberWithCommas(this.graphData.minimumLodgementTarget)}</strong>
        <br>Lodged On-Time: <strong class="blue">${this.numberWithCommas(totalLodgeOnTime)}</strong>
        <br>Lodged Late: <strong class="late">${this.numberWithCommas(this.graphData.lodgedLate)}</strong>
        <br><br>Still To Be Lodged: <strong>${this.numberWithCommas(stillToBeLodged)}</strong>
        <br>Required On-Time: <strong class="remaining">${this.numberWithCommas(requiredOnTime)}</strong>
      `;
        return tooltipNewTemplate;
    }
    /**
     * Returns a number to string decorated with commas
     * @param  {number} x number to be decorated
     * @returns string the comma decorated number in string format
     */
    numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    /**
     * Handles the showing of N/A if remaining lodgement is 0
     * @param  {string} remainingLodgementTarget remaining lodgement target value to be handled
     * @returns string remaining lodgement target to be handled if NA
     */
    handleNA(remainingLodgementTarget) {
        if (remainingLodgementTarget === '0')
            return 'N/A';
        return remainingLodgementTarget.toString();
    }
    /**
     * Render changes on the graph
     * @returns void
     */
    customizeBarGraph() {
        const barGroup = this.el.nativeElement.querySelector('.bar-group');
        const ontimeBar = this.el.nativeElement.querySelector('bento-d3-bar-chart svg .bar:nth-child(1)');
        const lateBar = this.el.nativeElement.querySelector('bento-d3-bar-chart svg .bar:nth-child(2)');
        const dueBar = this.el.nativeElement.querySelector('bento-d3-bar-chart svg .bar:nth-child(3)');
        const minBar = this.el.nativeElement.querySelector('bento-d3-bar-chart svg .bar:nth-child(4)');
        const totalBar = this.el.nativeElement.querySelector('bento-d3-bar-chart svg .bar:nth-child(5)');
        this.setElementAttribute(lateBar, 'y', this.getBarProperties(ontimeBar).y.toString());
        //if(dueBar !== null && minBar !== null && totalBar !== null){
        if (this.checkIfHasNull(['bento-d3-bar-chart svg .bar:nth-child(3)', 'bento-d3-bar-chart svg .bar:nth-child(4)', 'bento-d3-bar-chart svg .bar:nth-child(5)']) === false) {
            this.removeChild(barGroup, dueBar, false);
            this.removeChild(barGroup, minBar, false);
            this.removeChild(barGroup, totalBar, false);
        }
        else {
            this.branchMethod();
        }
        const xAxis = this.el.nativeElement.querySelectorAll('.axis');
        if (this.checkIfHasNull(['.axis']) === true) {
            this.showErrorMessage();
        }
        else {
            this.setElementAttribute(xAxis[0], 'transform', 'translate(0,73)');
        }
        this.getGraphPlotPoints();
        this.setMarkers();
    }
    /**
     * Returns needed properties only from bar element DOM
     * @param  {} bar DOM selection of the bar element
     * @returns IBarProperties bar property returned from DOM
     */
    getBarProperties(bar) {
        const properties = {
            x: bar.x.baseVal.value,
            y: bar.y.baseVal.value,
            width: bar.width.baseVal.value,
            height: bar.height.baseVal.value
        };
        return properties;
    }
    /**
     * Renders and customizes the markers on top of the graph
     * @returns void
     */
    setMarkers() {
        const markerOffset = 39;
        const markerHeight = 3;
        const barValue = this.graphData.dueToday;
        const barX = this.zeroBarX;
        const topLeft = (this.plotPoint * barValue) + markerOffset + barX;
        const topTop = 14 + markerHeight;
        const minPoint = (this.plotPoint * this.graphData.minimumLodgementTarget) + markerOffset + barX;
        const markerLineHeight = 87 - markerHeight;
        const minLineLeftVal = topLeft + 5.2;
        const minLinePaddedVal = minPoint + 5.2;
        const paddedTopLeftDue = topLeft;
        const barChartElement = this.el.nativeElement.querySelector('bento-d3-bar-chart');
        const cMarkerTop = this.el.nativeElement.querySelector('#compMarkerTop');
        const cMarkerBottom = this.el.nativeElement.querySelector('#compMarkerBot');
        const completionLine = this.el.nativeElement.querySelector('#completionLine');
        const cMarkerTopGreen = this.el.nativeElement.querySelector('#compMarkerTopGreen');
        const cMarkerBottomGreen = this.el.nativeElement.querySelector('#compMarkerBotGreen');
        const completionLineGreen = this.el.nativeElement.querySelector('#completionLineGreen');
        const dueLabel = this.el.nativeElement.querySelector('#dueLabel');
        const mMarkerTop = this.el.nativeElement.querySelector('#minMarkerTop');
        const mMarkerBottom = this.el.nativeElement.querySelector('#minMarkerBot');
        const minLine = this.el.nativeElement.querySelector('#minLine');
        const mMarkerTopGreen = this.el.nativeElement.querySelector('#minMarkerTopGreen');
        const mMarkerBottomGreen = this.el.nativeElement.querySelector('#minMarkerBotGreen');
        const minLineGreen = this.el.nativeElement.querySelector('#minLineGreen');
        const mMarkerTopRed = this.el.nativeElement.querySelector('#minMarkerTopRed');
        const mMarkerBottomRed = this.el.nativeElement.querySelector('#minMarkerBotRed');
        const minLineRed = this.el.nativeElement.querySelector('#minLineRed');
        const minLabel = this.el.nativeElement.querySelector('#minLabel');
        const axisWrapper = this.el.nativeElement.querySelector('#xAxisOverlay');
        const hasNullElement = this.checkIfHasNull(['bento-d3-bar-chart', '#xAxisOverlay']);
        if (hasNullElement) {
            this.showErrorMessage();
        }
        this.appendElement(barChartElement, mMarkerTop);
        this.appendElement(barChartElement, mMarkerBottom);
        this.appendElement(barChartElement, minLine);
        this.appendElement(barChartElement, mMarkerTopGreen);
        this.appendElement(barChartElement, mMarkerBottomGreen);
        this.appendElement(barChartElement, minLineGreen);
        this.appendElement(barChartElement, mMarkerTopRed);
        this.appendElement(barChartElement, mMarkerBottomRed);
        this.appendElement(barChartElement, minLineRed);
        this.appendElement(barChartElement, minLabel);
        this.appendElement(barChartElement, axisWrapper);
        if (this.getMarkerStatus('dueMarker').visible === false) {
            if (cMarkerTop !== null) {
                this.removeChild(barChartElement, cMarkerTop);
                this.removeChild(barChartElement, cMarkerBottom);
                this.removeChild(barChartElement, completionLine);
                this.removeChild(barChartElement, dueLabel);
            }
        }
        else {
            if (cMarkerTop !== null) {
                if (this.getMarkerStatus('dueMarker').color == this.graphData.customizations.markerColors.dueComplete) {
                    this.appendElement(barChartElement, cMarkerTopGreen);
                    this.appendElement(barChartElement, cMarkerBottomGreen);
                    this.appendElement(barChartElement, completionLineGreen);
                    this.setStyle(cMarkerTop, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                    this.setStyle(cMarkerBottom, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                    this.setStyle(completionLine, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                }
                else {
                    if (this.graphData.minimumLodgementTarget > this.graphData.dueToday) {
                        this.appendElement(barChartElement, cMarkerTop);
                        this.appendElement(barChartElement, cMarkerBottom);
                        this.appendElement(barChartElement, completionLine);
                        this.setStyle(cMarkerTopGreen, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                        this.setStyle(cMarkerBottomGreen, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                        this.setStyle(completionLineGreen, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                    }
                    else {
                        this.setStyle(cMarkerTopGreen, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                        this.setStyle(cMarkerBottomGreen, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                        this.setStyle(completionLineGreen, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                        this.setStyle(cMarkerTop, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                        this.setStyle(cMarkerBottom, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                        this.setStyle(completionLine, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                        this.setStyle(dueLabel, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                    }
                }
                this.appendElement(barChartElement, dueLabel);
                this.setStyle(dueLabel, 'top', '-64px');
                this.setStyle(dueLabel, 'left', this.toPixelString(paddedTopLeftDue));
                this.setStyle(cMarkerTop, 'left', this.toPixelString(topLeft));
                this.setStyle(cMarkerTop, 'top', this.toPixelString(topTop));
                this.setStyle(cMarkerBottom, 'left', this.toPixelString(topLeft));
                this.setStyle(cMarkerBottom, 'top', this.toPixelString(markerLineHeight));
                this.setStyle(completionLine, 'top', '21px');
                this.setStyle(completionLine, 'left', this.toPixelString(minLineLeftVal));
                this.setStyle(cMarkerTopGreen, 'left', this.toPixelString(topLeft));
                this.setStyle(cMarkerTopGreen, 'top', this.toPixelString(topTop));
                this.setStyle(cMarkerBottomGreen, 'left', this.toPixelString(topLeft));
                this.setStyle(cMarkerBottomGreen, 'top', this.toPixelString(markerLineHeight));
                this.setStyle(completionLineGreen, 'top', '21px');
                this.setStyle(completionLineGreen, 'left', this.toPixelString(minLineLeftVal));
            }
        }
        switch (this.getMarkerStatus('minMarker').color) {
            case this.graphData.customizations.markerColors.minimumReached:
                this.setStyle(mMarkerTopGreen, 'left', this.toPixelString(minPoint));
                this.setStyle(mMarkerTopGreen, 'top', this.toPixelString(topTop));
                this.setStyle(mMarkerBottomGreen, 'left', this.toPixelString(minPoint));
                this.setStyle(mMarkerBottomGreen, 'top', this.toPixelString(markerLineHeight));
                this.setStyle(minLineGreen, 'top', '21px');
                this.setStyle(minLineGreen, 'left', this.toPixelString(minLinePaddedVal));
                this.setStyle(minLabel, 'top', '-5px');
                this.setStyle(minLabel, 'left', this.toPixelString(minPoint));
                this.setStyle(mMarkerTop, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                this.setStyle(mMarkerBottom, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                this.setStyle(minLine, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                this.setStyle(mMarkerTopRed, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                this.setStyle(mMarkerBottomRed, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                this.setStyle(minLineRed, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                break;
            default:
                this.setStyle(mMarkerTop, 'left', this.toPixelString(minPoint));
                this.setStyle(mMarkerTop, 'top', this.toPixelString(topTop));
                this.setStyle(mMarkerBottom, 'left', this.toPixelString(minPoint));
                this.setStyle(mMarkerBottom, 'top', this.toPixelString(markerLineHeight));
                this.setStyle(minLine, 'top', '21px');
                this.setStyle(minLine, 'left', this.toPixelString(minLinePaddedVal));
                this.setStyle(minLabel, 'top', '-5px');
                this.setStyle(minLabel, 'left', this.toPixelString(minPoint));
                this.setStyle(mMarkerTopGreen, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                this.setStyle(mMarkerBottomGreen, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                this.setStyle(minLineGreen, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                this.setStyle(mMarkerTopRed, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                this.setStyle(mMarkerBottomRed, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                this.setStyle(minLineRed, this.styleConstants.visibilityStyle, this.styleConstants.visibilityHidden);
                break;
        }
        this.setStyle(mMarkerTop, 'left', this.toPixelString(minPoint));
        this.setStyle(mMarkerTop, 'top', this.toPixelString(topTop));
        this.setStyle(mMarkerBottom, 'left', this.toPixelString(minPoint));
        this.setStyle(mMarkerBottom, 'top', this.toPixelString(markerLineHeight));
        this.setStyle(minLine, 'top', '21px');
        this.setStyle(minLine, 'left', this.toPixelString(minLinePaddedVal));
        this.setStyle(minLabel, 'top', '-5px');
        this.setStyle(minLabel, 'left', this.toPixelString(minPoint));
    }
    /**
     * Determines the behavior of the markers based on current data
     * @param  {string} markerType marker to be evaluated. types: dueMarker, minMarker
     * @returns IMarkerStatus marker status
     */
    getMarkerStatus(markerType) {
        const lodgeOnTimeCount = this.graphData.lodgedOnTimeDeferred + this.graphData.lodgedOnTime + this.graphData.returnNotNecessary + this.graphData.furtherReturnNotNecessary;
        if (markerType === 'dueMarker') {
            if (lodgeOnTimeCount >= this.graphData.dueToday) {
                if (lodgeOnTimeCount >= this.graphData.minimumLodgementTarget) {
                    return { visible: false, color: this.graphData.customizations.markerColors.dueReachedMinimum };
                }
                else {
                    return { visible: true, color: this.graphData.customizations.markerColors.dueComplete };
                }
            }
            else {
                return { visible: true, color: this.graphData.customizations.markerColors.unreachedDue };
            }
        }
        else {
            if (lodgeOnTimeCount >= this.graphData.minimumLodgementTarget) {
                if (this.graphData.dueToday >= this.graphData.minimumLodgementTarget)
                    return { visible: true, color: this.graphData.customizations.markerColors.unreachedDue };
                else
                    return { visible: true, color: this.graphData.customizations.markerColors.minimumReached };
            }
            else {
                if (this.graphData.dueToday >= this.graphData.minimumLodgementTarget) {
                    return { visible: true, color: this.graphData.customizations.markerColors.unreachedDue };
                }
                else if ((this.graphData.totalDue - this.graphData.minimumLodgementTarget) < Math.abs(this.graphData.lodgedLate)) {
                    return { visible: true, color: this.graphData.customizations.markerColors.minimumUnreached };
                }
                else {
                    return { visible: true, color: this.graphData.customizations.markerColors.minimumUnreached };
                }
            }
        }
    }
    /**
     * Computes the value of plot points that will be used to redraw some elements
     * @returns void
     */
    getGraphPlotPoints() {
        const firstLine = this.el.nativeElement.querySelector('bento-d3-bar-chart svg g line:nth-child(2)');
        const secondLine = this.el.nativeElement.querySelector('bento-d3-bar-chart svg g line:nth-child(3)');
        const unitWidth = firstLine.x1.baseVal.value - secondLine.x1.baseVal.value;
        const firstTick = this.el.nativeElement.querySelector('bento-d3-bar-chart svg g g .tick:nth-child(2) text');
        const secondTick = this.el.nativeElement.querySelector('bento-d3-bar-chart svg g g .tick:nth-child(3) text');
        const unitSize = parseInt(firstTick.innerHTML.replace(',', '')) - parseInt(secondTick.innerHTML.replace(',', ''));
        this.plotPoint = unitWidth / unitSize;
        const allLines = this.el.nativeElement.querySelectorAll('bento-d3-bar-chart svg g line.vertical-grid');
        const allTicks = this.el.nativeElement.querySelectorAll('bento-d3-bar-chart svg g g .tick');
        var zeroLineIndex = 0;
        var ctr = 0;
        allTicks.forEach(tick => {
            var tickContent = tick.innerHTML;
            var pattern = '<text[^>]*>(.+?)</text>';
            var tickValue = tickContent.match(pattern)[1];
            if (tickValue === '0') {
                zeroLineIndex = ctr;
            }
            ctr++;
        });
        this.zeroBarX = this.zeroBarX === null ? allLines[zeroLineIndex].x2.baseVal.value : this.zeroBarX;
    }
    /**
     * Resizes the rendered Bento D3 Bar Graph
     * @returns void
     */
    resizeCanvas() {
        const graphSVG = this.el.nativeElement.querySelectorAll('bento-d3-bar-chart svg');
        if (graphSVG !== null)
            this.setElementAttribute(graphSVG[0], 'height', '111px');
    }
    /**
     * @param  {number} value number to be converted to a pixel string value
     * @returns string a value with px appended on the value supplied. ex: 5px
     */
    toPixelString(value) {
        let pattern = '$value$px';
        let pixelString = pattern.replace('$value$', value.toString());
        return pixelString;
    }
    /**
     * Check if any of the elements is null then return true if there is
     * @param  {string[]} elementNames set of element names to be checked if null
     * @returns boolean true if any of the element is null
     */
    checkIfHasNull(elementNames) {
        let hasNull = false;
        elementNames.map(element => {
            const elementSelection = this.el.nativeElement.querySelector(element);
            if (elementSelection === null)
                hasNull = true;
        });
        return hasNull;
    }
    /**
     * Removes the rendered extra line of the graph to make it less cluttered
     * @returns void
     */
    removeGraphExtraLine() {
        const canvas = this.el.nativeElement.querySelector('bento-d3-bar-chart svg');
        const firstLine = this.el.nativeElement.querySelector('bento-d3-bar-chart svg g line:nth-child(2)');
        const firstTick = this.el.nativeElement.querySelector('bento-d3-bar-chart svg g g .tick:nth-child(2) text');
        if (this.checkIfHasNull([
            'bento-d3-bar-chart svg g line:nth-child(2)',
            'bento-d3-bar-chart svg g g .tick:nth-child(2) text',
            'bento-d3-bar-chart svg'
        ]) === false) {
            this.removeChild(canvas, firstLine);
            this.removeChild(canvas, firstTick);
        }
    }
    /**
     * Show loading animation
     * @returns void
     */
    startLoading() {
        this.isBusyLoaderBusy = true;
    }
    /**
     * Stop and hide loading animation
     * @returns void
     */
    stopLoading() {
        this.isBusyLoaderBusy = false;
    }
    /**
     * Removes a child using renderer2
     * @param  {string} parent parent element of item to be removed
     * @param  {string} child item to be removed
     * @returns void
     */
    removeChild(parent, child, isParent) {
        if (this.mockRender === false) {
            this.renderer.removeChild(parent, child, isParent);
        }
        else {
            console.log('render mode for testing');
        }
    }
    /**
     * Styles an element using renderer2
     * @param  {string} element element to be styled
     * @param  {string} styleProperty style property to be modified
     * @param  {any} styleValue value to apply for the style property
     * @returns void
     */
    setStyle(element, styleProperty, styleValue) {
        if (this.mockRender === false) {
            this.renderer.setStyle(element, styleProperty, styleValue);
        }
        else {
            console.log('render mode for testing');
        }
    }
    /**
     * Append an element to a parent element using renderer2
     * @param  {string} parent element to host the child element
     * @param  {string} child element to be appended
     * @returns void
     */
    appendElement(parent, child) {
        if (this.mockRender === false) {
            this.renderer.appendChild(parent, child);
        }
        else {
            console.log('render mode for testing');
        }
    }
    /**
     * Set element attribute using renderer2
     * @param  {string} element element to modify attribute
     * @param  {string} attribute attribute to change
     * @param  {any} value value to apply on attribute
     * @returns void
     */
    setElementAttribute(element, attribute, value) {
        if (this.mockRender === false)
            this.renderer.setAttribute(element, attribute, value);
    }
    /**
     * Function to run to cover all branches in tests
     *
     * @returns void
     */
    branchMethod() {
        console.log('function to run to cover all branches in tests');
    }
    /**
     * Custom event listener to handle resizes and support debounce
     * @param  {Window} target target to listen the event from which is the current Window
     * @param  {string} eventName the event being listened
     */
    fromEvent(target, eventName) {
        return new Observable((observer) => {
            const handler = (e) => observer.next(e);
            target.addEventListener(eventName, handler);
            return () => {
                target.removeEventListener(eventName, handler);
            };
        });
    }
}
LodgementOverallProgressGraphComponent.ɵfac = function LodgementOverallProgressGraphComponent_Factory(t) { return new (t || LodgementOverallProgressGraphComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(AuTaxLodgePerformanceService)); };
LodgementOverallProgressGraphComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LodgementOverallProgressGraphComponent, selectors: [["lodgement-overall-progress-graph"]], viewQuery: function LodgementOverallProgressGraphComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(BentoD3BarChartComponent, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.barChart = _t.first);
    } }, decls: 67, vars: 5, consts: [["id", "error-wrapper"], ["id", "alerts", 3, "inline", "items"], ["id", "bento-busyloader-demo-container", 1, "overall-progress-graph-container", 3, "bentoBusyLoader", "size"], [1, "graph-title", "mb-4"], [3, "options"], [1, "marker-box"], ["id", "compMarkerTop", 1, "marker-el", "marker-arrow", "top", "red"], ["d", "M 3,3 L 9,3 L 6,6z"], ["id", "compMarkerBot", 1, "marker-el", "marker-arrow", "bot", "red"], ["d", "M 3,9 L 9,9 L 6,6 z"], ["id", "completionLine", 1, "marker-el", "marker-line"], ["x1", "0", "y1", "0", "x2", "0", "y2", "70"], ["id", "compMarkerTopGreen", 1, "marker-el", "marker-arrow", "top", "green"], ["id", "compMarkerBotGreen", 1, "marker-el", "marker-arrow", "bot", "green"], ["id", "completionLineGreen", 1, "marker-el", "marker-line", "green"], ["id", "minMarkerTop", 1, "marker-el", "marker-arrow", "top"], ["d", "M 3,3 L 9,3 L 6,6z", "fill", "orange", "stroke", "orange"], ["id", "minMarkerBot", 1, "marker-el", "marker-arrow", "bot"], ["d", "M 3,9 L 9,9 L 6,6 z", "fill", "orange", "stroke", "orange"], ["id", "minLine", 1, "marker-el", "marker-line"], ["id", "minMarkerTopRed", 1, "marker-el", "marker-arrow", "top", "red"], ["id", "minMarkerBotRed", 1, "marker-el", "marker-arrow", "bot", "red"], ["id", "minLineRed", 1, "marker-el", "marker-line", "red"], ["id", "minMarkerTopGreen", 1, "marker-el", "marker-arrow", "top", "green"], ["id", "minMarkerBotGreen", 1, "marker-el", "marker-arrow", "bot", "green"], ["id", "minLineGreen", 1, "marker-el", "marker-line", "green"], ["id", "dueLabel", 1, "marker-el", "marker-label"], ["id", "minLabel", 1, "marker-el", "marker-label"], ["id", "xAxisOverlay"], [1, "legend-box"], [1, "d-inline", "mr-4"], [1, "lodge-late-box"], [1, "d-inline", "mr-2", "ml-4"], [1, "lodge-on-time-box"]], template: function LodgementOverallProgressGraphComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "bento-alert", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "strong");
        ɵngcc0.ɵɵtext(5, "OVERALL PROGRESS");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelement(6, "bento-d3-bar-chart", 4);
        ɵngcc0.ɵɵelementStart(7, "div", 5)(8, "div", 6);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(9, "svg");
        ɵngcc0.ɵɵelement(10, "path", 7);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(11, "div", 8);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(12, "svg");
        ɵngcc0.ɵɵelement(13, "path", 9);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(14, "div", 10);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(15, "svg");
        ɵngcc0.ɵɵelement(16, "line", 11);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(17, "div", 12);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(18, "svg");
        ɵngcc0.ɵɵelement(19, "path", 7);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(20, "div", 13);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(21, "svg");
        ɵngcc0.ɵɵelement(22, "path", 9);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(23, "div", 14);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(24, "svg");
        ɵngcc0.ɵɵelement(25, "line", 11);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(26, "div", 15);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(27, "svg");
        ɵngcc0.ɵɵelement(28, "path", 16);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(29, "div", 17);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(30, "svg");
        ɵngcc0.ɵɵelement(31, "path", 18);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(32, "div", 19);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(33, "svg");
        ɵngcc0.ɵɵelement(34, "line", 11);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(35, "div", 20);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(36, "svg");
        ɵngcc0.ɵɵelement(37, "path", 7);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(38, "div", 21);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(39, "svg");
        ɵngcc0.ɵɵelement(40, "path", 9);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(41, "div", 22);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(42, "svg");
        ɵngcc0.ɵɵelement(43, "line", 11);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(44, "div", 23);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(45, "svg");
        ɵngcc0.ɵɵelement(46, "path", 7);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(47, "div", 24);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(48, "svg");
        ɵngcc0.ɵɵelement(49, "path", 9);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(50, "div", 25);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(51, "svg");
        ɵngcc0.ɵɵelement(52, "line", 11);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(53, "span", 26)(54, "strong");
        ɵngcc0.ɵɵtext(55, "YTD 85% Target");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(56, "span", 27)(57, "strong");
        ɵngcc0.ɵɵtext(58, "Annual 85% Target");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelement(59, "div", 28);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(60, "div", 29)(61, "div", 30);
        ɵngcc0.ɵɵelement(62, "span", 31);
        ɵngcc0.ɵɵtext(63, " Late ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(64, "div", 32);
        ɵngcc0.ɵɵelement(65, "span", 33);
        ɵngcc0.ɵɵtext(66, " On Time ");
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("inline", true)("items", ctx.alerts);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx.isBusyLoaderBusy)("size", "sm");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("options", ctx.graphOptions);
    } }, directives: [ɵngcc4.BentoAlertComponent, ɵngcc4.BentoBusyLoaderDirective, ɵngcc5.BentoD3BarChartComponent], styles: [".overall-progress-graph-container[_ngcontent-%COMP%]{padding:0}.bar-graph-wrapper[_ngcontent-%COMP%]{overflow:hidden;height:230px;padding-top:115px}.marker-box[_ngcontent-%COMP%]{visibility:hidden}.graph-title[_ngcontent-%COMP%]{text-align:center;font-size:12pt;margin-top:30px;margin-bottom:70px!important}.marker-arrow[_ngcontent-%COMP%]{position:absolute;width:10px}.marker-el[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{width:10px}.orange[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{stroke:#ff8000!important;fill:#ff8000}.green[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{stroke:#15ba49!important;fill:#15ba49}.red[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{stroke:#dc3124!important;fill:#dc3124}#minLine[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   line[_ngcontent-%COMP%]{stroke:#ff8000;fill:none;stroke-width:3px;stroke-dasharray:5,5}#minLineGreen[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   line[_ngcontent-%COMP%]{stroke:#15ba49;fill:none;stroke-width:3px;stroke-dasharray:5,5}#minLineRed[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   line[_ngcontent-%COMP%]{stroke:#dc3124;fill:none;stroke-width:3px;stroke-dasharray:5,5}.marker-line[_ngcontent-%COMP%]{position:absolute;width:10px}.marker-line[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   line[_ngcontent-%COMP%]{stroke:#dc3124;fill:none;stroke-width:3px}.green[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]   line[_ngcontent-%COMP%], .marker-line[_ngcontent-%COMP%]{stroke:#15ba49;fill:none;stroke-width:3px}.marker-label[_ngcontent-%COMP%]{position:absolute;font-size:6pt;writing-mode:vertical-rl;-webkit-text-orientation:mixed;text-orientation:mixed;-webkit-transform:rotate(-180deg)}#minLabel[_ngcontent-%COMP%]{top:-61px!important}#dueLabel[_ngcontent-%COMP%], #minLabel[_ngcontent-%COMP%]{font-family:Knowledge;font-weight:700;font-style:normal;font-size:9px}#dueLabel[_ngcontent-%COMP%]{top:-48px!important}#compMarkerTopGreen[_ngcontent-%COMP%]   .marker-arrow[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{fill:#15ba49!important;stroke:#15ba49!important;stroke-width:1}  #compMarkerTopGreen .marker-arrow svg path{fill:#15ba49!important;stroke:#15ba49!important;stroke-width:1}#xAxisOverlay[_ngcontent-%COMP%]{background-color:#fff;top:94px;height:7px;width:100%;position:absolute}.legend-box[_ngcontent-%COMP%]{margin:auto;width:70%;text-align:center;margin-top:40px!important}.lodge-on-time-box[_ngcontent-%COMP%]{background-color:#0099c4}.lodge-late-box[_ngcontent-%COMP%], .lodge-on-time-box[_ngcontent-%COMP%]{height:15px;width:15px;display:inline-block}.lodge-late-box[_ngcontent-%COMP%]{background-color:#ababab}  bento-d3-bar-chart .domain{visibility:hidden}  bento-d3-bar-chart .tick line{stroke:none}.axis[_ngcontent-%COMP%]   .tick[_ngcontent-%COMP%]   text[_ngcontent-%COMP%],   bento-d3-bar-chart .y{display:none}  bento-d3-bar-chart .vertical-grid{height:30}  bento-d3-bar-chart div.bento-d3-tooltip div.tooltip-arrow{bottom:-14px!important;margin-left:-15px!important;border-width:15px 15px 0!important;border-top-color:#f4f5f7!important}  bento-d3-bar-chart div.bento-d3-tooltip{font-size:8pt!important}  bento-d3-bar-chart div.bento-d3-tooltip .tooltip-inner{margin-right:-100px}  .bento-busyloader-wrapper{height:250px!important}  svg g g .tick{margin-top:20px}#error-wrapper[_ngcontent-%COMP%]{position:relative!important;margin:50px 2px 0!important}  bento-d3-bar-chart div.bento-d3-tooltip .tooltip-inner .blue{color:#0099c4}  bento-d3-bar-chart div.bento-d3-tooltip .tooltip-inner .remaining{color:#ff8000}  bento-d3-bar-chart div.bento-d3-tooltip .tooltip-inner .late{color:#717172}  bento-d3-bar-chart div.bento-d3-tooltip .tooltip-inner .tooltipHeader{text-decoration:underline;font-weight:800;font-size:11px}  bento-d3-bar-chart div.bento-d3-tooltip .tooltip-inner{width:-webkit-fit-content!important;width:-moz-fit-content!important;width:fit-content!important;font-weight:500}  .tooltip-inner{font-size:.7rem;font-family:Knowledge;font-weight:400;font-style:normal}"] });
LodgementOverallProgressGraphComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: AuTaxLodgePerformanceService }
];
LodgementOverallProgressGraphComponent.propDecorators = {
    barChart: [{ type: ViewChild, args: [BentoD3BarChartComponent, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LodgementOverallProgressGraphComponent, [{
        type: Component,
        args: [{
                selector: 'lodgement-overall-progress-graph',
                template: "\r\n<div id=\"error-wrapper\">\r\n    <bento-alert id=\"alerts\" [inline]=\"true\" [items]=\"alerts\"></bento-alert>\r\n</div>\r\n<div class=\"overall-progress-graph-container\" [bentoBusyLoader]=\"isBusyLoaderBusy\" [size]=\"'sm'\" id=\"bento-busyloader-demo-container\">\r\n    <div class=\"graph-title mb-4\"><strong>OVERALL PROGRESS</strong></div>\r\n    <bento-d3-bar-chart [options]=\"graphOptions\"></bento-d3-bar-chart>\r\n    <div class=\"marker-box\">\r\n        <div id=\"compMarkerTop\" class=\"marker-el marker-arrow top red\"><svg><path d=\"M 3,3 L 9,3 L 6,6z\"></path></svg></div>\r\n        <div id=\"compMarkerBot\" class=\"marker-el marker-arrow bot red\"><svg><path d=\"M 3,9 L 9,9 L 6,6 z\"></path></svg></div>\r\n        <div id=\"completionLine\" class=\"marker-el marker-line\"><svg><line x1=\"0\" y1=\"0\" x2=\"0\" y2=\"70\"/></svg></div>\r\n\r\n        <div id=\"compMarkerTopGreen\" class=\"marker-el marker-arrow top green\"><svg><path d=\"M 3,3 L 9,3 L 6,6z\"></path></svg></div>\r\n        <div id=\"compMarkerBotGreen\" class=\"marker-el marker-arrow bot green\"><svg><path d=\"M 3,9 L 9,9 L 6,6 z\"></path></svg></div>\r\n        <div id=\"completionLineGreen\" class=\"marker-el marker-line green\"><svg><line x1=\"0\" y1=\"0\" x2=\"0\" y2=\"70\"/></svg></div>\r\n\r\n        <div id=\"minMarkerTop\" class=\"marker-el marker-arrow top\"><svg><path d=\"M 3,3 L 9,3 L 6,6z\" fill=\"orange\" stroke=\"orange\"></path></svg></div>\r\n        <div id=\"minMarkerBot\"  class=\"marker-el marker-arrow bot\"><svg><path d=\"M 3,9 L 9,9 L 6,6 z\" fill=\"orange\" stroke=\"orange\"></path></svg></div>\r\n        <div id=\"minLine\" class=\"marker-el marker-line\"><svg><line x1=\"0\" y1=\"0\" x2=\"0\" y2=\"70\"/></svg></div>\r\n\r\n        <div id=\"minMarkerTopRed\" class=\"marker-el marker-arrow top red\"><svg><path d=\"M 3,3 L 9,3 L 6,6z\"></path></svg></div>\r\n        <div id=\"minMarkerBotRed\"  class=\"marker-el marker-arrow bot red\"><svg><path d=\"M 3,9 L 9,9 L 6,6 z\"></path></svg></div>\r\n        <div id=\"minLineRed\" class=\"marker-el marker-line red\"><svg><line x1=\"0\" y1=\"0\" x2=\"0\" y2=\"70\"/></svg></div>\r\n\r\n        <div id=\"minMarkerTopGreen\" class=\"marker-el marker-arrow top green\"><svg><path d=\"M 3,3 L 9,3 L 6,6z\"></path></svg></div>\r\n        <div id=\"minMarkerBotGreen\"  class=\"marker-el marker-arrow bot green\"><svg><path d=\"M 3,9 L 9,9 L 6,6 z\"></path></svg></div>\r\n        <div id=\"minLineGreen\" class=\"marker-el marker-line green\"><svg><line x1=\"0\" y1=\"0\" x2=\"0\" y2=\"70\"/></svg></div>\r\n\r\n        <span id=\"dueLabel\" class=\"marker-el marker-label\"><strong>YTD 85% Target</strong></span>\r\n        <span id=\"minLabel\" class=\"marker-el marker-label\"><strong>Annual 85% Target</strong></span>\r\n        <div id=\"xAxisOverlay\"></div>\r\n    </div>\r\n    <div class=\"legend-box\">\r\n        <div class=\"d-inline mr-4\">\r\n            <span class=\"lodge-late-box\"></span> Late\r\n        </div>\r\n        <div class=\"d-inline mr-2 ml-4\">\r\n            <span class=\"lodge-on-time-box\"></span> On Time\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n",
                styles: [".overall-progress-graph-container{padding:0}.bar-graph-wrapper{overflow:hidden;height:230px;padding-top:115px}.marker-box{visibility:hidden}.graph-title{text-align:center;font-size:12pt;margin-top:30px;margin-bottom:70px!important}.marker-arrow{position:absolute;width:10px}.marker-el svg{width:10px}.orange svg{stroke:#ff8000!important;fill:#ff8000}.green svg{stroke:#15ba49!important;fill:#15ba49}.red svg{stroke:#dc3124!important;fill:#dc3124}#minLine svg line{stroke:#ff8000;fill:none;stroke-width:3px;stroke-dasharray:5,5}#minLineGreen svg line{stroke:#15ba49;fill:none;stroke-width:3px;stroke-dasharray:5,5}#minLineRed svg line{stroke:#dc3124;fill:none;stroke-width:3px;stroke-dasharray:5,5}.marker-line{position:absolute;width:10px}.marker-line svg line{stroke:#dc3124;fill:none;stroke-width:3px}.green svg line,.marker-line{stroke:#15ba49;fill:none;stroke-width:3px}.marker-label{position:absolute;font-size:6pt;writing-mode:vertical-rl;-webkit-text-orientation:mixed;text-orientation:mixed;-webkit-transform:rotate(-180deg)}#minLabel{top:-61px!important}#dueLabel,#minLabel{font-family:Knowledge;font-weight:700;font-style:normal;font-size:9px}#dueLabel{top:-48px!important}#compMarkerTopGreen .marker-arrow svg{fill:#15ba49!important;stroke:#15ba49!important;stroke-width:1}::ng-deep #compMarkerTopGreen .marker-arrow svg path{fill:#15ba49!important;stroke:#15ba49!important;stroke-width:1}#xAxisOverlay{background-color:#fff;top:94px;height:7px;width:100%;position:absolute}.legend-box{margin:auto;width:70%;text-align:center;margin-top:40px!important}.lodge-on-time-box{background-color:#0099c4}.lodge-late-box,.lodge-on-time-box{height:15px;width:15px;display:inline-block}.lodge-late-box{background-color:#ababab}::ng-deep bento-d3-bar-chart .domain{visibility:hidden}::ng-deep bento-d3-bar-chart .tick line{stroke:none}.axis .tick text,::ng-deep bento-d3-bar-chart .y{display:none}::ng-deep bento-d3-bar-chart .vertical-grid{height:30}::ng-deep bento-d3-bar-chart div.bento-d3-tooltip div.tooltip-arrow{bottom:-14px!important;margin-left:-15px!important;border-width:15px 15px 0!important;border-top-color:#f4f5f7!important}::ng-deep bento-d3-bar-chart div.bento-d3-tooltip{font-size:8pt!important}::ng-deep bento-d3-bar-chart div.bento-d3-tooltip .tooltip-inner{margin-right:-100px}::ng-deep .bento-busyloader-wrapper{height:250px!important}::ng-deep svg g g .tick{margin-top:20px}#error-wrapper{position:relative!important;margin:50px 2px 0!important}::ng-deep bento-d3-bar-chart div.bento-d3-tooltip .tooltip-inner .blue{color:#0099c4}::ng-deep bento-d3-bar-chart div.bento-d3-tooltip .tooltip-inner .remaining{color:#ff8000}::ng-deep bento-d3-bar-chart div.bento-d3-tooltip .tooltip-inner .late{color:#717172}::ng-deep bento-d3-bar-chart div.bento-d3-tooltip .tooltip-inner .tooltipHeader{text-decoration:underline;font-weight:800;font-size:11px}::ng-deep bento-d3-bar-chart div.bento-d3-tooltip .tooltip-inner{width:-webkit-fit-content!important;width:-moz-fit-content!important;width:fit-content!important;font-weight:500}::ng-deep .tooltip-inner{font-size:.7rem;font-family:Knowledge;font-weight:400;font-style:normal}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: AuTaxLodgePerformanceService }]; }, { barChart: [{
            type: ViewChild,
            args: [BentoD3BarChartComponent, { static: true }]
        }] }); })();

class AuTaxLodgePerformanceComponent {
    /**
     * Construct component
     * @param  {AuTaxLodgePerformanceService} privatecomponentService Service from AutaxLodgePerformance(parent component's service)
     */
    constructor(componentService) {
        this.componentService = componentService;
        this.activeGraph = 1;
        this.dataAvailable = false;
        this.barGraphData = null;
        this.yearToDateData = null;
        this.lastUpdatedTime = "";
        this.atoReportDataTransfer = null;
        //on initial load load all data
        this.subscribeToData();
    }
    /**
     * Isolated subscription to the parent service to get data
     * @returns void
     */
    subscribeToData() {
        this.componentService.getLodgementPerformanceData().subscribe((data) => {
            this.atoReportDataTransfer = data;
            if (this.atoReportDataTransfer != null && !this.atoReportDataTransfer.hasError) {
                // Comment this function if you're going to use mockData
                this.loadDataFromApi(data === null || data === void 0 ? void 0 : data.additionalResponse);
            }
            else {
                this.switchGraphs();
            }
            //uncomment this to use this on cases you need to bypass API
            // this.useMockDataOnLoad();
        }, error => {
            //Comment this function up to this.switchGraphs() if you're going to use mockData
            console.error('error encountered on retrieving initial data');
            this.dataAvailable = this.setDataAvailability();
            this.switchGraphs();
            //uncomment this to use this on cases you need to bypass API
            // this.useMockDataOnLoad();
        });
    }
    /**
    * Gets data from the API then passes data to the child components
    * @param  {IServerData} data data passed from the API which contains bargraph data and ytd data
    * @returns void
    */
    loadDataFromApi(data) {
        if (data === null) {
            this.dataAvailable = this.setDataAvailability();
            this.switchGraphs();
        }
        else {
            this.barGraphData = data.overall;
            this.yearToDateData = data.yearToDate;
            this.lastUpdatedTime = this.getFormattedTime(data.lodgmentStatisticsUpdatedDate);
            this.dataAvailable = this.setDataAvailability();
            this.switchGraphs();
        }
    }
    /**
     * used when mocking data for this component
     * @returns void
     */
    useMockDataOnLoad() {
        const mockApiData = {
            "overall": {
                "totalDueForYear": 2500,
                "minimumLodgmentTarget": 2125,
                "remainingLodgmentTarget": 175,
                "dueBy": 1400,
                "lodgedOnTime": 1150,
                "lodgedLate": 100,
                "lodgedOnTimeDeferred": 25,
                "returnNotNecessary": 50,
                "furtherReturnNotNecessary": 25
            },
            "yearToDate": {
                "lodgmentPercentage": "92.5 %",
                "toBeLodge": 175,
                "dueBy": 2000,
                "lodgedOnTime": 1750,
                "lodgedLate": 100,
                "lodgedOnTimeDeferred": 25,
                "returnNotNecessary": 50,
                "furtherReturnNotNecessary": 25
            },
            "lodgmentStatisticsUpdatedDate": "2018-02-14T15:40:20Z",
            "schematronErrors": []
        };
        this.barGraphData = mockApiData.overall;
        this.yearToDateData = mockApiData.yearToDate;
        this.lastUpdatedTime = this.getFormattedTime(mockApiData.lodgmentStatisticsUpdatedDate);
        this.dataAvailable = this.setDataAvailability();
        this.switchGraphs();
    }
    /**
     * returns true when data from mockApi has been loaded
     * @returns boolean
     */
    setDataAvailability() {
        return true;
    }
    /**
     * Return a formatted ISO Date to another format
     * @param  {string} dateISOString
     * @returns string The return string ould be formatted as DD/MM/YYYY@HH:MM PM
     */
    getFormattedTime(dateISOString) {
        const pad = (n, width, z) => {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        };
        let date = dateISOString;
        let dateObj = new Date(date);
        let pDate = pad(dateObj.getDate(), 2);
        let pMonth = pad(dateObj.getMonth() + 1, 2);
        let fullYear = dateObj.getFullYear();
        let dateString = `${pDate}/${pMonth}/${fullYear}`;
        let tts = dateObj.toLocaleString('en-AU', { hour: 'numeric', minute: 'numeric', hour12: true });
        let fullString = `${dateString} @ ${tts}`;
        return fullString;
    }
    /**
     * @returns void
     */
    ngOnInit() {
    }
    /**
     * @returns void
     */
    onToggle() {
        this.switchGraphs();
    }
    /**
     * Sends data to LodgementOverAllProgressGraph component
     * @returns void
     */
    sendBarGraphData() {
        var _a;
        this.componentService.sendBarGraphData(this.barGraphData, (_a = this.atoReportDataTransfer) === null || _a === void 0 ? void 0 : _a.errorResponse);
    }
    /**
     * Sends data to YearToDateGraph component
     * @returns void
     */
    sendYearToDateData() {
        var _a;
        this.componentService.sendYearToDateData(this.yearToDateData, (_a = this.atoReportDataTransfer) === null || _a === void 0 ? void 0 : _a.errorResponse);
    }
    /**
     * Function the controls data that needs to send on the toggle graph
     * @returns void
     */
    switchGraphs() {
        if (this.activeGraph === 2) {
            this.sendBarGraphData();
        }
        else {
            this.sendYearToDateData();
        }
    }
}
AuTaxLodgePerformanceComponent.ɵfac = function AuTaxLodgePerformanceComponent_Factory(t) { return new (t || AuTaxLodgePerformanceComponent)(ɵngcc0.ɵɵdirectiveInject(AuTaxLodgePerformanceService)); };
AuTaxLodgePerformanceComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AuTaxLodgePerformanceComponent, selectors: [["autax-lodge-performance"]], decls: 16, vars: 12, consts: [[1, "widget-holder"], ["id", "toggleSet", "ngbRadioGroup", "", "name", "dataOption", 1, "btn-group", "btn-group-toggle", "mt-1", "mr-1", "toggleSet", 3, "ngModel", "disabled", "change", "ngModelChange"], ["ngbButtonLabel", "", 1, "btn", "btn-xs", "btn-outline-primary", "btn-toggle"], ["ngbButton", "", "type", "radio", 3, "value"], [1, "graphWrapper"], [4, "ngIf"], [1, "last-update-time", 3, "ngClass"], [1, "last-update-time-value"], [1, "child-wrapper"]], template: function AuTaxLodgePerformanceComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
        ɵngcc0.ɵɵlistener("change", function AuTaxLodgePerformanceComponent_Template_div_change_1_listener() { return ctx.onToggle(); })("ngModelChange", function AuTaxLodgePerformanceComponent_Template_div_ngModelChange_1_listener($event) { return ctx.activeGraph = $event; });
        ɵngcc0.ɵɵelementStart(2, "label", 2);
        ɵngcc0.ɵɵelement(3, "input", 3);
        ɵngcc0.ɵɵtext(4, " Year to Date ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "label", 2);
        ɵngcc0.ɵɵelement(6, "input", 3);
        ɵngcc0.ɵɵtext(7, " Overall Progress ");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(8, "div", 4);
        ɵngcc0.ɵɵtemplate(9, AuTaxLodgePerformanceComponent_div_9_Template, 3, 0, "div", 5);
        ɵngcc0.ɵɵtemplate(10, AuTaxLodgePerformanceComponent_div_10_Template, 3, 0, "div", 5);
        ɵngcc0.ɵɵelementStart(11, "div", 6);
        ɵngcc0.ɵɵtext(12, " Updated by ATO ");
        ɵngcc0.ɵɵelementStart(13, "span", 7);
        ɵngcc0.ɵɵtext(14);
        ɵngcc0.ɵɵpipe(15, "uppercase");
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.activeGraph)("disabled", !ctx.dataAvailable);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("value", 1);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("value", 2);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.activeGraph == 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.activeGraph == 2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(10, _c0, ctx.lastUpdatedTime === ""));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(15, 8, ctx.lastUpdatedTime));
    } }, directives: [ɵngcc3.NgbRadioGroup, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc3.NgbButtonLabel, ɵngcc3.NgbRadio, ɵngcc1.NgIf, YearToDateGraphComponent, LodgementOverallProgressGraphComponent, ɵngcc1.NgClass], pipes: [ɵngcc1.UpperCasePipe], styles: [".widget-holder[_ngcontent-%COMP%]{width:568px;height:400px;border:1.5px solid #d5d4d9!important}.widget-header[_ngcontent-%COMP%]{border:1px solid #d5d4d9;background-color:#d5d4d9}.btn-group[_ngcontent-%COMP%]   .btn.active.btn-outline-primary[_ngcontent-%COMP%]{color:#fff;background-color:#ff8000;border-color:#ac5700}.btn-group[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:last-child.active{border-top-left-radius:7px;border-bottom-left-radius:7px;margin-left:-6px;background-color:#ff8000;color:#fff;border:2px solid #ac5700}.btn-group[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:first-child.active{border-top-right-radius:7px;border-bottom-right-radius:7px;margin-right:-6px;background-color:#ff8000;color:#fff;border:2px solid #ac5700;z-index:2}.btn[_ngcontent-%COMP%]{text-transform:none!important}.toggleSet[_ngcontent-%COMP%]{float:right;z-index:900;margin-top:-32px!important;margin-right:30px!important}.toggleSet[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{padding:12px!important;font-size:10pt!important}.dark-orange[_ngcontent-%COMP%]{color:#ac5700}.orange[_ngcontent-%COMP%]{color:#ff8000}.light-grey[_ngcontent-%COMP%]{color:#f4f5f7}.dark-grey[_ngcontent-%COMP%]{color:#5e5e5e}.black[_ngcontent-%COMP%]{color:#000}.white[_ngcontent-%COMP%]{color:#fff}.last-update-time[_ngcontent-%COMP%]{font-size:8pt;font-weight:700;position:relative;right:10px;bottom:25px;text-align:right}.child-wrapper[_ngcontent-%COMP%]{border:1px solid transparent;height:400px}.hiddenCaption[_ngcontent-%COMP%]{visibility:hidden}"] });
AuTaxLodgePerformanceComponent.ctorParameters = () => [
    { type: AuTaxLodgePerformanceService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuTaxLodgePerformanceComponent, [{
        type: Component,
        args: [{
                selector: 'autax-lodge-performance',
                template: "\r\n<div class=\"widget-holder\">\r\n  <div id=\"toggleSet\" ngbRadioGroup (change)=\"onToggle()\" [(ngModel)]=\"activeGraph\" [disabled]=\"!dataAvailable\" class=\"btn-group btn-group-toggle mt-1 mr-1 toggleSet\" name=\"dataOption\">\r\n    <label ngbButtonLabel class=\"btn btn-xs btn-outline-primary btn-toggle\">\r\n      <input ngbButton type=\"radio\" [value]=\"1\" />\r\n      Year to Date\r\n    </label>\r\n    <label ngbButtonLabel class=\"btn btn-xs btn-outline-primary btn-toggle\">\r\n      <input ngbButton type=\"radio\" [value]=\"2\" />\r\n      Overall Progress\r\n    </label>\r\n  </div>\r\n  <div class=\"graphWrapper\">\r\n    <div *ngIf=\"activeGraph == 1\">\r\n      <div class=\"child-wrapper\">\r\n        <year-to-date-graph></year-to-date-graph>\r\n      </div>\r\n    </div>\r\n    <div *ngIf=\"activeGraph == 2\">\r\n      <div class=\"child-wrapper\">\r\n        <lodgement-overall-progress-graph></lodgement-overall-progress-graph>\r\n      </div>\r\n    </div>\r\n    <div class=\"last-update-time\" [ngClass]=\"{'hiddenCaption': lastUpdatedTime === ''}\">\r\n      Updated by ATO <span class=\"last-update-time-value\">{{ lastUpdatedTime | uppercase }}</span>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n",
                styles: [".widget-holder{width:568px;height:400px;border:1.5px solid #d5d4d9!important}.widget-header{border:1px solid #d5d4d9;background-color:#d5d4d9}.btn-group .btn.active.btn-outline-primary{color:#fff;background-color:#ff8000;border-color:#ac5700}.btn-group .btn:last-child.active{border-top-left-radius:7px;border-bottom-left-radius:7px;margin-left:-6px;background-color:#ff8000;color:#fff;border:2px solid #ac5700}.btn-group .btn:first-child.active{border-top-right-radius:7px;border-bottom-right-radius:7px;margin-right:-6px;background-color:#ff8000;color:#fff;border:2px solid #ac5700;z-index:2}.btn{text-transform:none!important}.toggleSet{float:right;z-index:900;margin-top:-32px!important;margin-right:30px!important}.toggleSet label{padding:12px!important;font-size:10pt!important}.dark-orange{color:#ac5700}.orange{color:#ff8000}.light-grey{color:#f4f5f7}.dark-grey{color:#5e5e5e}.black{color:#000}.white{color:#fff}.last-update-time{font-size:8pt;font-weight:700;position:relative;right:10px;bottom:25px;text-align:right}.child-wrapper{border:1px solid transparent;height:400px}.hiddenCaption{visibility:hidden}"]
            }]
    }], function () { return [{ type: AuTaxLodgePerformanceService }]; }, null); })();

class LodgementOverallProgressGraphModule {
}
LodgementOverallProgressGraphModule.ɵfac = function LodgementOverallProgressGraphModule_Factory(t) { return new (t || LodgementOverallProgressGraphModule)(); };
LodgementOverallProgressGraphModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LodgementOverallProgressGraphModule });
LodgementOverallProgressGraphModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            BentoModule,
            BentoD3Module,
            FormsModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LodgementOverallProgressGraphModule, [{
        type: NgModule,
        args: [{
                declarations: [LodgementOverallProgressGraphComponent],
                imports: [
                    BentoModule,
                    BentoD3Module,
                    FormsModule
                ],
                exports: [LodgementOverallProgressGraphComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LodgementOverallProgressGraphModule, { declarations: function () { return [LodgementOverallProgressGraphComponent]; }, imports: function () { return [BentoModule,
        BentoD3Module,
        FormsModule]; }, exports: function () { return [LodgementOverallProgressGraphComponent]; } }); })();

class YearToDateGraphModule {
}
YearToDateGraphModule.ɵfac = function YearToDateGraphModule_Factory(t) { return new (t || YearToDateGraphModule)(); };
YearToDateGraphModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: YearToDateGraphModule });
YearToDateGraphModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            BentoModule,
            NgbModule,
            BentoD3Module,
            HttpClientModule
        ], BentoModule,
        NgbModule,
        BentoD3Module] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(YearToDateGraphModule, [{
        type: NgModule,
        args: [{
                declarations: [YearToDateGraphComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    BentoModule,
                    NgbModule,
                    BentoD3Module,
                    HttpClientModule
                ],
                exports: [
                    YearToDateGraphComponent,
                    BentoModule,
                    NgbModule,
                    BentoD3Module
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(YearToDateGraphModule, { declarations: function () { return [YearToDateGraphComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        BentoModule,
        NgbModule,
        BentoD3Module,
        HttpClientModule]; }, exports: function () { return [YearToDateGraphComponent, BentoModule,
        NgbModule,
        BentoD3Module]; } }); })();

class AuTaxLodgePerformanceModule {
}
AuTaxLodgePerformanceModule.ɵfac = function AuTaxLodgePerformanceModule_Factory(t) { return new (t || AuTaxLodgePerformanceModule)(); };
AuTaxLodgePerformanceModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AuTaxLodgePerformanceModule });
AuTaxLodgePerformanceModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            LodgementOverallProgressGraphModule,
            YearToDateGraphModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AuTaxLodgePerformanceModule, [{
        type: NgModule,
        args: [{
                declarations: [AuTaxLodgePerformanceComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    LodgementOverallProgressGraphModule,
                    YearToDateGraphModule
                ],
                exports: [AuTaxLodgePerformanceComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AuTaxLodgePerformanceModule, { declarations: function () { return [AuTaxLodgePerformanceComponent]; }, imports: function () { return [CommonModule,
        FormsModule, LodgementOverallProgressGraphModule, YearToDateGraphModule]; }, exports: function () { return [AuTaxLodgePerformanceComponent]; } }); })();

// System imports
class AUTaxService {
    constructor(http) {
        this.http = http;
    }
    // get ato client details for given client id
    getClientContactDetailsById(clientId, type) {
        const clientUrl = `/api/autax/v1/clients/${clientId}/contact-data/${type}`;
        return this.http.get(clientUrl)
            .pipe(catchError(ExceptionHandler.handleError));
    }
    // update client contact details by passing its object
    updateClientContactDetails(clientId, type, clientFinance) {
        const clientUrl = `/api/autax/v1/clients/${clientId}/contact-data/${type}`;
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        // const body = JSON.stringify(clientFinance);
        return this.http
            .put(clientUrl, clientFinance, { headers }).pipe(catchError(ExceptionHandler.handleError));
    }
    // Get promise of finance details from client list by its client id and its type cufi
    getOnvioClientFinanceDetailsById(clientId, type) {
        return this.getClientContactDetailsById(clientId, type).pipe(mergeMap((data) => {
            const clientFinanceDetails = this.clientContactDetailsByJsonData(data);
            return of(clientFinanceDetails);
        }));
    }
    // Get filtered details from client contact details by json data
    clientContactDetailsByJsonData(data) {
        if (data.data != null && data.data != null && data.data.toString() !== '') {
            const financeDetails = JSON.parse(JSON.stringify(data.data));
            return financeDetails;
        }
        return new ClientFinance();
    }
    // Get promise of other details from client list by its client id and its type cudtl
    getOnvioClientOtherDetailsById(clientId, type) {
        return this.getClientContactDetailsById(clientId, type).pipe(mergeMap((data) => {
            const clientOtherDetails = this.clientContactOtherDetailsByJsonData(data);
            return of(clientOtherDetails);
        }));
    }
    // Get filtered other details from client contact details by json data
    clientContactOtherDetailsByJsonData(data) {
        if (data.data != null && data.data != null && data.data.toString() !== '') {
            const otherDetails = JSON.parse(JSON.stringify(data.data));
            return otherDetails;
        }
        return new ClientOtherDetails();
    }
}
AUTaxService.ɵfac = function AUTaxService_Factory(t) { return new (t || AUTaxService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient)); };
AUTaxService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AUTaxService_Factory() { return new AUTaxService(i0.ɵɵinject(i1$1.HttpClient)); }, token: AUTaxService, providedIn: "root" });
AUTaxService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AUTaxService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }]; }, null); })();

class OnvioClientOtherDetails {
}

// System imports
class ClientAddressUpdateComponent {
    constructor(activeModal, alertService, coreService, atoIntegrationService, autaxService, helperService, sessionService) {
        this.activeModal = activeModal;
        this.alertService = alertService;
        this.coreService = coreService;
        this.atoIntegrationService = atoIntegrationService;
        this.autaxService = autaxService;
        this.helperService = helperService;
        this.sessionService = sessionService;
        this.getCompanyId = getCompanyId;
        this.clientUpdateTypes = this.getClientUpdateTypes();
        this.isATOUpdateBusy = false;
        this.isOnvioUpdateBusy = false;
        this.isDisableModalClose = false;
        this.isDisableCancel = false;
        this.isDisableUpdateATO = true;
        this.isDisableUpdateOnvio = true;
        this.currentStep = 0;
        this.hideCustomLeftButtons = true;
        this.steps = [{
                title: 'Select the item type',
                discription: 'Select the detail you want to update',
                disable: false
            },
            {
                title: 'Update Client Details',
                discription: 'Update details to ATO or Onvio',
                disable: true
            }];
    }
    ngOnInit() {
        this.getCompanyId().then((companyId) => {
            this.helperService.setCompanyId(companyId);
        }).catch((error) => {
            console.warn('company id promise failed: ', error);
            this.alertService.show(AlertType.danger, AutaxStaffConstants.genericToasterErrorMessage, undefined, 'companyid_promise_error');
        });
        this.clientDetail = this.helperService.getClientDetail();
        // It will get the current development permission status
        this.hasCurrentDevelopment = this.sessionService.getCurrentDevelopmentPermission();
        // It will get the status of the Entity type i.e for Individual entity type true or false.
        this.isEntityTypeIndividual = this.coreService.getCurrentClientEntityType();
        this.coreService.getOnvioContactAddressCountries()
            .subscribe((response) => {
            this.coreService.setContactAddressCountries(response);
        }, (error) => {
            this.alertService.show(AlertType.danger, error, undefined, 'onvio_country_error');
        });
        this.coreService.getOnvioContactAddressStateProvince()
            .subscribe((response) => {
            this.coreService.setContactAddressStateProvince(response);
        }, (error) => {
            this.alertService.show(AlertType.danger, error, undefined, 'onvio_state_error');
        });
    }
    // This method called on every wizard step change event
    wizardStepChange() {
        if (this.currentStep === 1) {
            this.hideCustomLeftButtons = false;
            this.isClientUpdateTableBusyLoader = true;
            this.clientUpdateTableRowList = [];
            this.isDisableUpdateATO = true;
            this.isDisableUpdateOnvio = true;
            if (this.selectedClientUpdate.onvioAddressType) {
                this.getOnvioAndAtoAddress();
            }
            else if (this.selectedClientUpdate.onvioFinanceType) {
                this.getOnvioAndAtoclientFinanceDetails();
            }
            else if (this.selectedClientUpdate.onvioOtherDetails) {
                this.getOnvioAndAtoClientOtherDetails();
            }
        }
        else {
            this.hideCustomLeftButtons = true;
            this.isClientUpdateTableBusyLoader = false;
        }
    }
    // This method calls on click of radio button checked
    onRadioButtonChange(clientUpdateType) {
        if (clientUpdateType.name) {
            this.processWizardNextStep(clientUpdateType);
        }
    }
    // Checks for any address selected and based on it enable
    processWizardNextStep(clientUpdateType) {
        this.selectedClientUpdate = clientUpdateType;
        this.enableWizardStep(this.currentStep + 1);
    }
    // This method get onvio and ato addresses.
    getOnvioAndAtoAddress() {
        const atoAddressPromise = this.atoIntegrationService.getAtoClientAddressByType(this.clientDetail.clientId, this.selectedClientUpdate.atoAddressType);
        const onvioAddressPromise = this.coreService.getOnvioClientAddressesByType(this.helperService.getCompanyId(), this.clientDetail.clientId, this.selectedClientUpdate.onvioAddressType);
        forkJoin(onvioAddressPromise, atoAddressPromise)
            .subscribe((results) => {
            const [onvioAddress, atoAddress] = results;
            this.onvioAddress = onvioAddress;
            this.atoAddress = atoAddress;
            this.isDisableUpdateATO = this.onvioAddress.addressLine1 ? false : true;
            this.isDisableUpdateOnvio = this.atoAddress.addressLine1 ? false : true;
            this.clientUpdateTableRowList = this.fillAddressTableRow();
        }, (error) => {
            if (error instanceof Array && error.every(i => i instanceof SchematronError)) {
                error.map((e, index) => {
                    this.alertService.show(AlertType.danger, e.shortDescription, undefined, `schematron_error_${index + 1}`);
                });
            }
            else {
                this.alertService.show(AlertType.danger, error, undefined, 'get_address_error');
                console.warn('Promise failed while getting addresses: ', error);
            }
        }).add(() => {
            // It's like finally function
            this.isClientUpdateTableBusyLoader = false;
        });
    }
    // This method get client finance details from onvio and ato.
    getOnvioAndAtoclientFinanceDetails() {
        this.atoIntegrationService.getAtoClientFinanceDetailsByProperty(this.clientDetail.clientId, this.selectedClientUpdate.atoFinanceType).subscribe((atoFinance) => {
            this.atoClientFinanaceDetail = atoFinance;
            this.autaxService.getOnvioClientFinanceDetailsById(this.clientDetail.clientId, OnvioClientUpdateType.cufi).subscribe((onvioFinance) => {
                this.onvioClientFinanaceDetail = onvioFinance;
                this.AddOnvioPropertyThatPassFromAto();
            }, (error) => {
                if (error instanceof HttpErrorResponse) {
                    switch (error.status) {
                        case 404:
                            this.onvioClientFinanaceDetail = new AtoClientFinance();
                            break;
                        default:
                            this.alertService.show(AlertType.danger, AutaxStaffConstants.genericToasterErrorMessage, undefined, 'get_onviofinance_error');
                    }
                }
                else {
                    this.alertService.show(AlertType.danger, AutaxStaffConstants.genericToasterErrorMessage, undefined, 'get_onviofinance_error');
                }
                console.warn('Promise failed while getting addresses: ', error);
            }).add(() => {
                // It's like finally function
                this.isDisableUpdateOnvio = this.atoClientFinanaceDetail.bsbNumber ? false : true;
                this.isDisableUpdateATO = this.onvioClientFinanaceDetail.bsbNumber ? false : true;
                this.clientUpdateTableRowList = this.fillClientFinanceTableRow();
                this.isClientUpdateTableBusyLoader = false;
            });
        }, (error) => {
            if (error instanceof Array && error.every(i => i instanceof SchematronError)) {
                error.map((e, index) => {
                    this.alertService.show(AlertType.danger, e.shortDescription, undefined, `schematron_error_${index + 1}`);
                });
            }
            else {
                this.alertService.show(AlertType.danger, error, undefined, 'get_finance_error');
                console.warn('Promise failed while getting addresses: ', error);
            }
            this.isClientUpdateTableBusyLoader = false;
        });
    }
    // This method get client other details from onvio and ato.
    getOnvioAndAtoClientOtherDetails() {
        this.coreService.getOnvioClientDateOfDeath(this.helperService.getCompanyId(), this.clientDetail.clientId).subscribe((dateOfDeath) => {
            this.onvioCoreDateOfDeath = dateOfDeath;
        }, (error) => {
            this.alertService.show(AlertType.danger, error, undefined, 'onvio_dateOfDeath_error');
        });
        this.atoIntegrationService.getAtoClientOtherDetailsByProperty(this.clientDetail.clientId, this.selectedClientUpdate.atoOtherDetails).subscribe((otherDetails) => {
            this.atoClientOtherDetails = otherDetails;
            if (typeof this.atoClientOtherDetails.dateOfDeath === 'string') {
                this.atoClientOtherDetails.dateOfDeath = this.helperService.dateStringToObject(this.atoClientOtherDetails.dateOfDeath);
            }
            this.autaxService.getOnvioClientOtherDetailsById(this.clientDetail.clientId, OnvioClientUpdateType.cudtl).subscribe((onvioOtherDetails) => {
                this.onvioClientOtherDetails = onvioOtherDetails;
                this.onvioClientOtherDetails.dateOfDeath = this.onvioCoreDateOfDeath;
                if (typeof this.onvioClientOtherDetails.dateOfDeath === 'string') {
                    this.onvioClientOtherDetails.dateOfDeath = this.helperService.dateStringCoreToObject(this.onvioClientOtherDetails.dateOfDeath);
                }
            }, (error) => {
                if (error instanceof HttpErrorResponse) {
                    switch (error.status) {
                        case 404:
                            this.onvioClientOtherDetails = new OnvioClientOtherDetails();
                            break;
                        default:
                            this.alertService.show(AlertType.danger, AutaxStaffConstants.genericToasterErrorMessage, undefined, 'get_onvioOtherDetails_error');
                    }
                }
                else {
                    this.alertService.show(AlertType.danger, AutaxStaffConstants.genericToasterErrorMessage, undefined, 'get_onvioOtherDetails_error');
                }
                console.warn('Promise failed while getting other details: ', error);
            }).add(() => {
                // It's like Finally Function
                this.isDisableUpdateATO = this.checkOtherDetails(this.onvioClientOtherDetails) ? false : true;
                this.isDisableUpdateOnvio = this.checkOtherDetails(this.atoClientOtherDetails) ? false : true;
                this.clientUpdateTableRowList = this.fillClientOtherDetailsTableRow();
                this.isClientUpdateTableBusyLoader = false;
            });
        }, (error) => {
            if (error instanceof Array && error.every(i => i instanceof SchematronError)) {
                error.map((e, index) => {
                    this.alertService.show(AlertType.danger, e.shortDescription, undefined, `schematron_error_${index + 1}`);
                });
            }
            else {
                this.alertService.show(AlertType.danger, error, undefined, 'get_otherDetails_error');
                console.warn('Promise failed while getting other details: ', error);
            }
            this.isClientUpdateTableBusyLoader = false;
        });
    }
    // This method update in Onvio with either of the data that include Addresses , Financial data or Other Details
    updateOnvio() {
        this.disableAllButtonsWhileBusy();
        this.isOnvioUpdateBusy = true;
        if (this.selectedClientUpdate.onvioAddressType) {
            this.updateOnvioAddress();
        }
        else if (this.selectedClientUpdate.onvioFinanceType) {
            this.updateOnvioClientFinanceDetails();
        }
        else if (this.selectedClientUpdate.onvioOtherDetails) {
            this.updateOnvioOtherDetails();
        }
    }
    // This method update in ATO either of the data that include Addresses , Financial data or Other Details
    updateAto() {
        this.disableAllButtonsWhileBusy();
        this.isATOUpdateBusy = true;
        if (this.selectedClientUpdate.atoAddressType) {
            this.updateAtoAddress();
        }
        else if (this.selectedClientUpdate.atoFinanceType) {
            this.updateAtoClientFinanceDetails();
        }
        else if (this.selectedClientUpdate.atoOtherDetails) {
            this.updateAtoOtherDetails();
        }
    }
    // Enable the given wizard step
    enableWizardStep(step) {
        this.steps[step].disable = false;
    }
    // Disable the given wizard step
    disableWizardStep(step) {
        this.steps[step].disable = true;
    }
    // This method update the ato address
    updateAtoAddress() {
        this.atoIntegrationService.updateAtoAddress(this.onvioAddress, this.selectedClientUpdate.atoAddressType, this.clientDetail.clientId).subscribe((result) => {
            if (!result.hasErrors) {
                this.alertService.show(AlertType.success, `Client ${this.selectedClientUpdate.name} have been successfully updated with the ATO`, undefined, 'ato_submit_success');
            }
            else {
                this.alertService.show(AlertType.danger, `The request to update client's${this.selectedClientUpdate.name} has been rejected by the ATO. Refer to the ` +
                    `<a class="btn-link" id="lnkPDFFile" target="_blank" href="${result.pdfFilePath}">PDF</a> for more details.`, undefined, 'schematron_error');
                console.log('schematronErrors: ', result.schematronErrors);
            }
        }, (error) => {
            console.warn('updateAtoAddress: ', error);
            this.alertService.show(AlertType.danger, error.message, undefined, 'ato_submit_error');
        }).add(() => {
            // It's like finally function
            this.isATOUpdateBusy = false;
            this.enableAllButtonsWhileNotBusy();
            this.activeModal.close('cuaddr ato submit');
        });
    }
    // This method update the onvio contact address
    updateOnvioAddress() {
        this.coreService.getOnvioContact(this.helperService.getCompanyId(), this.coreService.GetCachedContactId()).subscribe((res) => {
            this.addOrUpdateAtoAddressToContactData(res);
            this.coreService.updateOnvioContact(this.helperService.getCompanyId(), this.coreService.GetCachedContactId(), res).subscribe((r) => {
                this.alertService.show(AlertType.success, `Client ${this.selectedClientUpdate.name} have been successfully updated in Onvio`, undefined, 'onvio_submit_success');
            }, ((error) => {
                this.alertService.show(AlertType.danger, error, undefined, 'onvio_submit_error');
            })).add(() => {
                // It's like finally function
                this.isOnvioUpdateBusy = false;
                this.enableAllButtonsWhileNotBusy();
                this.activeModal.close('cuaddr onvio submit');
            });
        }, ((error) => {
            this.alertService.show(AlertType.danger, error, undefined, 'onvio_submit_error');
            this.isOnvioUpdateBusy = false;
            this.enableAllButtonsWhileNotBusy();
            this.activeModal.close('cuaddr onvio submit error');
        }));
    }
    // This method update the onvio client finanace details
    updateOnvioClientFinanceDetails() {
        this.autaxService.updateClientContactDetails(this.clientDetail.clientId, OnvioClientUpdateType.cufi, this.atoClientFinanaceDetail).subscribe((res) => {
            this.alertService.show(AlertType.success, `Client ${this.selectedClientUpdate.name} have been successfully updated in Onvio`, undefined, 'onvio_submit_success');
        }, (error) => {
            this.alertService.show(AlertType.danger, error.error.message, undefined, 'onvio_submit_error');
        }).add(() => {
            // It's like finally function
            this.isOnvioUpdateBusy = false;
            this.enableAllButtonsWhileNotBusy();
            this.activeModal.close('cufi onvio submit');
        });
    }
    // This method update the ato client finanace details
    updateAtoClientFinanceDetails() {
        this.atoIntegrationService.updateAtoClientFinanceDetails(this.clientDetail.clientId, this.onvioClientFinanaceDetail).subscribe((result) => {
            if (!result.hasErrors) {
                this.alertService.show(AlertType.success, `Client ${this.selectedClientUpdate.name} have been successfully updated with the ATO`, undefined, 'ato_submit_success');
            }
            else {
                this.alertService.show(AlertType.danger, `The request to update client's ${this.selectedClientUpdate.name} has been rejected by the ATO. Refer to the ` +
                    `<a class="btn-link" id="lnkPDFFile" target="_blank" ` +
                    `href=${result.pdfFilePath}>PDF</a> for more details.`, undefined, 'schematron_error');
                console.log('schematronErrors: ', result.schematronErrors);
            }
        }, (error) => {
            console.warn('updateAtoClientFinance: ', error);
            this.alertService.show(AlertType.danger, error.message, undefined, 'ato_submit_error');
        }).add(() => {
            // It's like finally function
            this.isATOUpdateBusy = false;
            this.enableAllButtonsWhileNotBusy();
            this.activeModal.close('cufi ato submit');
        });
    }
    // This method will update the CUDTL data from ATO to Onvio (dateOfDeath to core and Tax Purposes to TaxTab OtherDetails)
    updateOnvioOtherDetails() {
        // for individual entity type we need to update Resident for TaxPurposes in TaxTab and DateOfDeath in core.
        if (this.isEntityTypeIndividual) {
            // to update DateOfDeath in core
            this.coreService.getOnvioContact(this.helperService.getCompanyId(), this.coreService.GetCachedContactId()).subscribe((res) => {
                this.addOrUpdateAtoDateOfDeathToContactData(res);
                this.coreService.updateOnvioContact(this.helperService.getCompanyId(), this.coreService.GetCachedContactId(), res).subscribe((res) => {
                    // to update the Resident for TaxPurposes in CUDTL.
                    this.autaxService.updateClientContactDetails(this.clientDetail.clientId, OnvioClientUpdateType.cudtl, this.atoClientOtherDetails).subscribe((res) => {
                        this.alertService.show(AlertType.success, `Client ${this.selectedClientUpdate.name} have been successfully updated in Onvio`, undefined, 'onvio_submit_success');
                    }, (error) => {
                        this.alertService.show(AlertType.danger, error.error.message, undefined, 'onvio_submit_error');
                    });
                }, (error) => {
                    this.alertService.show(AlertType.danger, error, undefined, 'onvio_submit_error');
                }).add(() => {
                    // It's like finally function
                    this.isOnvioUpdateBusy = false;
                    this.enableAllButtonsWhileNotBusy();
                    this.activeModal.close('cudtl onvio submit');
                });
            }, (error) => {
                this.alertService.show(AlertType.danger, error, undefined, 'onvio_submit_error');
                this.isOnvioUpdateBusy = false;
                this.enableAllButtonsWhileNotBusy();
                this.activeModal.close('cudtl onvio submit');
            });
        }
        else {
            // for Non Individual entity we need to update the Resident for TaxPurposes only.
            this.autaxService.updateClientContactDetails(this.clientDetail.clientId, OnvioClientUpdateType.cudtl, this.atoClientOtherDetails).subscribe((res) => {
                this.alertService.show(AlertType.success, `Client ${this.selectedClientUpdate.name} have been successfully updated in Onvio`, undefined, 'onvio_submit_success');
            }, (error) => {
                this.alertService.show(AlertType.danger, error.error.message, undefined, 'onvio_submit_error');
            }).add(() => {
                // It's like finally function
                this.isOnvioUpdateBusy = false;
                this.enableAllButtonsWhileNotBusy();
                this.activeModal.close('cudtl onvio submit');
            });
        }
    }
    // This method will update the CUDTL data from Onvio to ATO
    updateAtoOtherDetails() {
        this.atoIntegrationService.updateAtoCLientOtherDetails(this.clientDetail.clientId, this.onvioClientOtherDetails).subscribe((result) => {
            if (!result.hasErrors) {
                this.alertService.show(AlertType.success, `Client ${this.selectedClientUpdate.name} have been successfully updated with the ATO`, undefined, 'ato_submit_success');
            }
            else {
                this.alertService.show(AlertType.danger, `The request to update client's ${this.selectedClientUpdate.name} has been rejected by the ATO. Refer to the ` +
                    `<a class="btn-link" id="lnkPDFFile" target="_blank" ` +
                    `href=${result.pdfFilePath}>PDF</a> for more details.`, undefined, 'schematron_error');
                console.log('schematronErrors: ', result.schematronErrors);
            }
        }, (error) => {
            console.warn('updateAtoClientOtherDetails: ', error);
            this.alertService.show(AlertType.danger, error.message, undefined, 'ato_submit_error');
        }).add(() => {
            // It's like finally function
            this.isATOUpdateBusy = false;
            this.enableAllButtonsWhileNotBusy();
            this.activeModal.close('cudtl onvio submit');
        });
    }
    addOrUpdateAtoAddressToContactData(contactData) {
        const addressIndex = this.findAtoAddressInContactData(contactData.addresses);
        if (addressIndex > -1) {
            contactData.addresses[addressIndex].addressLine1 = this.atoAddress.addressLine1;
            contactData.addresses[addressIndex].addressLine2 = this.atoAddress.addressLine2;
            contactData.addresses[addressIndex].city = this.atoAddress.suburb;
            contactData.addresses[addressIndex].stateProvince = this.getStateProvinceForOnvioAddress();
            contactData.addresses[addressIndex].postalCode = this.atoAddress.postCode;
            contactData.addresses[addressIndex].country = this.getCountryForOnvioAddress();
        }
        else {
            const newAddress = {
                addressType: this.helperService.getNamedReference(this.selectedClientUpdate.onvioAddressType, this.helperService.changeCaseFirstLetter(this.selectedClientUpdate.onvioAddressType.toLocaleLowerCase())),
                addressLine1: this.atoAddress.addressLine1,
                addressLine2: this.atoAddress.addressLine2,
                city: this.atoAddress.suburb,
                postalCode: this.atoAddress.postCode,
                stateProvince: this.getStateProvinceForOnvioAddress(),
                country: this.getCountryForOnvioAddress(),
                isPrimary: contactData.addresses.length > 0 ? false : true,
                isMailing: false,
                isPayroll: false,
                isPrincipal: false,
                isRegistered: false,
                isTax: false,
                isTrading: false
            };
            contactData.addresses.push(newAddress);
        }
    }
    getCountryForOnvioAddress() {
        const onvioCountries = this.coreService.getContactAddressCountries();
        const onvioCountry = onvioCountries.filter((country) => {
            return country.id === this.atoAddress.countryName;
        });
        if (onvioCountry.length > 0) {
            return this.helperService.getNamedReference(onvioCountry[0].id, onvioCountry[0].name);
        }
        return this.helperService.getNamedReference('SPECIFIED', this.atoAddress.countryName);
    }
    getStateProvinceForOnvioAddress() {
        const onvioStateProvince = this.coreService.getContactAddressStateProvince();
        const state = onvioStateProvince.filter((stateProvince) => {
            return stateProvince.abbreviation === this.atoAddress.state;
        });
        if (state.length > 0) {
            return this.helperService.getNamedReference(state[0].id, state[0].name);
        }
        return this.helperService.getNamedReference('SPECIFIED', this.atoAddress.state);
    }
    findAtoAddressInContactData(contactAddresses) {
        return contactAddresses.findIndex(a => a.addressType.id === this.selectedClientUpdate.onvioAddressType);
    }
    AddOnvioPropertyThatPassFromAto() {
        // This are the properties that need to pass in SUBMIT call.
        // This properties should not have effect in onvio.
        if (this.atoClientFinanaceDetail.taxAccountId) {
            this.onvioClientFinanaceDetail.taxAccountId = this.atoClientFinanaceDetail.taxAccountId;
        }
    }
    // It will format the dateOfDeath from the ATO to the core format
    addOrUpdateAtoDateOfDeathToContactData(res) {
        res.dateOfDeath = this.helperService.dateObjectToCoreFormat(this.atoClientOtherDetails.dateOfDeath);
    }
    fillAddressTableRow() {
        return [
            {
                rowName: 'Address line 1',
                rowValues: [
                    this.onvioAddress.addressLine1,
                    this.atoAddress.addressLine1
                ]
            },
            {
                rowName: 'Address line 2',
                rowValues: [
                    this.onvioAddress.addressLine2,
                    this.atoAddress.addressLine2
                ]
            },
            {
                rowName: 'Suburb',
                rowValues: [
                    this.onvioAddress.suburb,
                    this.atoAddress.suburb
                ]
            },
            {
                rowName: 'state',
                rowValues: [
                    this.onvioAddress.state,
                    this.atoAddress.state
                ]
            },
            {
                rowName: 'postcode',
                rowValues: [
                    this.onvioAddress.postCode,
                    this.atoAddress.postCode
                ]
            },
            {
                rowName: 'country',
                rowValues: [
                    this.onvioAddress.countryName,
                    this.atoAddress.countryName
                ]
            }
        ];
    }
    fillClientOtherDetailsTableRow() {
        return [
            {
                rowName: 'Resident for Tax Purposes',
                rowValues: [
                    this.onvioClientOtherDetails.taxPurposes,
                    this.atoClientOtherDetails.taxPurposes
                ]
            },
            {
                rowName: 'Date of Death',
                rowValues: [
                    this.getClientDateOfDeath(this.onvioClientOtherDetails.dateOfDeath),
                    this.getClientDateOfDeath(this.atoClientOtherDetails.dateOfDeath),
                ]
            }
        ];
    }
    fillClientFinanceTableRow() {
        return [
            {
                rowName: 'BSB number',
                rowValues: [
                    this.onvioClientFinanaceDetail.bsbNumber,
                    this.atoClientFinanaceDetail.bsbNumber
                ]
            },
            {
                rowName: 'Account name',
                rowValues: [
                    this.onvioClientFinanaceDetail.accountName,
                    this.atoClientFinanaceDetail.accountName
                ]
            },
            {
                rowName: 'Account number',
                rowValues: [
                    this.onvioClientFinanaceDetail.accountNumber,
                    this.atoClientFinanaceDetail.accountNumber
                ]
            }
        ];
    }
    getClientUpdateTypes() {
        return [{
                id: 'postal_address',
                name: 'Postal Address',
                onvioAddressType: OnvioAddressType.postal,
                atoAddressType: AtoClientUpdateType.postal,
                isChecked: false
            }, {
                id: 'home_address',
                name: 'Home Address',
                onvioAddressType: OnvioAddressType.home,
                atoAddressType: AtoClientUpdateType.home,
                isChecked: false
            }, {
                id: 'business_address',
                name: 'Business Address',
                onvioAddressType: OnvioAddressType.business,
                atoAddressType: AtoClientUpdateType.business,
                isChecked: false
            }, {
                id: 'bank_details',
                name: 'Bank Details',
                onvioFinanceType: OnvioClientUpdateType.cufi,
                atoFinanceType: AtoClientUpdateType.finance,
                isChecked: false
            }, {
                id: 'other_details',
                name: 'Other Details',
                onvioOtherDetails: OnvioClientUpdateType.cudtl,
                atoOtherDetails: AtoClientUpdateType.otherDetail,
                isChecked: false
            }];
    }
    // common method to get client date of death in the dd/mm/yyyy format
    getClientDateOfDeath(dateOfDeath) {
        if (dateOfDeath) {
            return `${dateOfDeath.day}/${dateOfDeath.month}/${dateOfDeath.year}`;
        }
        return '';
    }
    // common method to handle updateAto and updateOnvio buttons
    checkOtherDetails(otherDetails) {
        if (otherDetails.taxPurposes) {
            return true;
        }
        else if (otherDetails.dateOfDeath) {
            return this.CheckClientDateOfDeathType(otherDetails.dateOfDeath);
        }
        return false;
    }
    // This method will check the type of dateOfDeath i.e if the type is undefined then it will return false else true
    CheckClientDateOfDeathType(dateOfDeath) {
        if (dateOfDeath.day && dateOfDeath.month && dateOfDeath.year) {
            return true;
        }
        return false;
    }
    // After user clicks on either of two buttons(updateOnvio and updateATO)
    // This method will disable the updateAto,updateOnvio,modal close symbol, step 1 of modal, and cancel button.
    disableAllButtonsWhileBusy() {
        this.isDisableUpdateOnvio = true;
        this.isDisableUpdateATO = true;
        this.isDisableModalClose = true;
        this.isDisableCancel = true;
        this.disableWizardStep(0);
    }
    // After the alert message appears and before the modal window gets closed
    // This method will enable the updateAto,updateOnvio,modal close symbol, step 1 of modal, and cancel button.
    enableAllButtonsWhileNotBusy() {
        this.isDisableUpdateOnvio = false;
        this.isDisableUpdateATO = false;
        this.isDisableModalClose = false;
        this.isDisableCancel = false;
        this.enableWizardStep(0);
    }
}
ClientAddressUpdateComponent.ɵfac = function ClientAddressUpdateComponent_Factory(t) { return new (t || ClientAddressUpdateComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(AlertService), ɵngcc0.ɵɵdirectiveInject(CoreService), ɵngcc0.ɵɵdirectiveInject(AtoIntegrationService), ɵngcc0.ɵɵdirectiveInject(AUTaxService), ɵngcc0.ɵɵdirectiveInject(HelperService), ɵngcc0.ɵɵdirectiveInject(SessionService)); };
ClientAddressUpdateComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ClientAddressUpdateComponent, selectors: [["autax-client-address-update"]], decls: 14, vars: 12, consts: [["type", "button", "aria-label", "Close", 1, "close", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-close-x"], ["id", "modal-basic-title", 1, "modal-header"], [1, "modal-body", "ng-bento"], [3, "hTag", "currentStep", "hideDoneButton", "currentStepChange"], [3, "title", "description", "disabled", 4, "ngFor", "ngForOf"], [1, "btn", "btn-primary", 3, "hidden", "disabled", "bentoBusyLoader", "click"], [1, "btn", "btn-outline-primary", "float-right", 3, "disabled", "click"], [3, "title", "description", "disabled"], [1, "wizard-content-center", 2, "display", "grid", 3, "hidden"], ["class", "form-group", 4, "ngFor", "ngForOf"], ["otherDetailsTipContentIndividual", ""], ["otherDetailsTipContentNonIndividual", ""], [1, "wizard-content-center", 3, "hidden", "bentoBusyLoader", "size"], [1, "table", "text-center", "table-bordered"], ["colspan", "3", "scope", "colgroup"], ["scope", "col"], [3, "hidden", 4, "ngFor", "ngForOf"], [1, "form-group"], ["type", "radio", "name", "clientUpdateRadio", 3, "id", "click"], [1, "radio-button-margin-left"], ["class", "bento-icon-question-filled", "placement", "right", 3, "ngbTooltip", "hidden", 4, "ngIf"], ["placement", "right", 1, "bento-icon-question-filled", 3, "ngbTooltip", "hidden"], [3, "hidden"], ["scope", "row"], [4, "ngFor", "ngForOf"]], template: function ClientAddressUpdateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function ClientAddressUpdateComponent_Template_button_click_0_listener() { return ctx.activeModal.dismiss("Cross click"); });
        ɵngcc0.ɵɵelement(1, "i", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "h4", 2);
        ɵngcc0.ɵɵtext(3, " Manage Client Details\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3)(5, "bento-wizard", 4);
        ɵngcc0.ɵɵlistener("currentStepChange", function ClientAddressUpdateComponent_Template_bento_wizard_currentStepChange_5_listener($event) { return ctx.currentStep = $event; })("currentStepChange", function ClientAddressUpdateComponent_Template_bento_wizard_currentStepChange_5_listener() { return ctx.wizardStepChange(); });
        ɵngcc0.ɵɵtemplate(6, ClientAddressUpdateComponent_bento_wizard_step_6_Template, 22, 10, "bento-wizard-step", 5);
        ɵngcc0.ɵɵelementStart(7, "bento-wizard-custom-button-group")(8, "button", 6);
        ɵngcc0.ɵɵlistener("click", function ClientAddressUpdateComponent_Template_button_click_8_listener() { return ctx.updateOnvio(); });
        ɵngcc0.ɵɵtext(9, " Update Onvio ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "button", 6);
        ɵngcc0.ɵɵlistener("click", function ClientAddressUpdateComponent_Template_button_click_10_listener() { return ctx.updateAto(); });
        ɵngcc0.ɵɵtext(11, " Update ATO ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "button", 7);
        ɵngcc0.ɵɵlistener("click", function ClientAddressUpdateComponent_Template_button_click_12_listener() { return ctx.activeModal.dismiss("Cancel click"); });
        ɵngcc0.ɵɵtext(13, " Cancel ");
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("disabled", ctx.isDisableModalClose);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("hTag", "h1")("currentStep", ctx.currentStep)("hideDoneButton", true);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.steps);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.hideCustomLeftButtons)("disabled", ctx.isDisableUpdateOnvio)("bentoBusyLoader", ctx.isOnvioUpdateBusy);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.hideCustomLeftButtons)("disabled", ctx.isDisableUpdateATO)("bentoBusyLoader", ctx.isATOUpdateBusy);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", ctx.isDisableCancel);
    } }, directives: [ɵngcc4.BentoFocusMonitorDirective, ɵngcc4.BentoWizardComponent, ɵngcc1.NgForOf, ɵngcc4.BentoWizardStepComponent, ɵngcc1.NgIf, ɵngcc4.BentoNgbTooltipSupportDirective, ɵngcc3.NgbTooltip, ɵngcc4.BentoBusyLoaderDirective, ɵngcc4.BentoWizardComponentCustomButtonGroupComponent], styles: [".wizard-content-center[_ngcontent-%COMP%]{justify-content:center;margin-top:45px}.radio-button-margin-left[_ngcontent-%COMP%]{font-size:15px;vertical-align:2px;margin-left:8px}"] });
ClientAddressUpdateComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: AlertService },
    { type: CoreService },
    { type: AtoIntegrationService },
    { type: AUTaxService },
    { type: HelperService },
    { type: SessionService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ClientAddressUpdateComponent, [{
        type: Component,
        args: [{
                selector: 'autax-client-address-update',
                template: "<!-- NOTE: Add \"ng-bento\" class so that it will not override Bento-Modern css -->\r\n<button type=\"button\" [disabled]='isDisableModalClose' class=\"close\" aria-label=\"Close\"\r\n  (click)=\"activeModal.dismiss('Cross click')\">\r\n  <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\r\n</button>\r\n<h4 id=\"modal-basic-title\" class=\"modal-header\">\r\n  Manage Client Details\r\n</h4>\r\n<div class=\"modal-body ng-bento\">\r\n  <bento-wizard [hTag]=\"'h1'\" [(currentStep)]=\"currentStep\" [hideDoneButton]=\"true\"\r\n    (currentStepChange)=\"wizardStepChange()\">\r\n    <bento-wizard-step *ngFor=\"let step of steps;\" [title]=\"step.title\" [description]=\"step.discription\"\r\n      [disabled]=\"step.disable\">\r\n      <!-- Step 0 -->\r\n      <div [hidden]=\"currentStep !== 0\" class=\"wizard-content-center\" style=\"display: grid;\">\r\n        <div class=\"form-group\" *ngFor=\"let clientUpdate of clientUpdateTypes;\">\r\n          <input type=\"radio\" name=\"clientUpdateRadio\" id=\"{{clientUpdate.id}}\"\r\n            (click)=\"onRadioButtonChange(clientUpdate)\" />\r\n          <label class=\"radio-button-margin-left\">\r\n            {{clientUpdate.name}}\r\n            <span *ngIf=\"isEntityTypeIndividual\" class=\"bento-icon-question-filled\"\r\n              [ngbTooltip]=\"otherDetailsTipContentIndividual\" placement=\"right\"\r\n              [hidden]=\"clientUpdate.id !== 'other_details'\"></span>\r\n            <span *ngIf=\"!isEntityTypeIndividual\" class=\"bento-icon-question-filled\" [ngbTooltip]=\"otherDetailsTipContentNonIndividual\"\r\n              placement=\"right\" [hidden]=\"clientUpdate.id !== 'other_details'\"></span>\r\n          </label>\r\n        </div>\r\n      </div>\r\n      <ng-template #otherDetailsTipContentIndividual> Resident for Tax Purposes <br /> Date of Death\r\n      </ng-template>\r\n      <ng-template #otherDetailsTipContentNonIndividual> Resident for Tax Purposes\r\n      </ng-template>\r\n      <!-- Step 1 -->\r\n      <div [hidden]=\"currentStep !== 1\" class=\"wizard-content-center\" [bentoBusyLoader]=\"isClientUpdateTableBusyLoader\"\r\n        [size]=\"'sm'\">\r\n        <!-- Dynamic table design -->\r\n        <table class=\"table text-center table-bordered\">\r\n          <thead>\r\n            <tr>\r\n              <th colspan=\"3\" scope=\"colgroup\">{{selectedClientUpdate?.name}}</th>\r\n            </tr>\r\n          </thead>\r\n          <thead>\r\n            <tr>\r\n              <td></td>\r\n              <th scope=\"col\">Onvio</th>\r\n              <th scope=\"col\">ATO</th>\r\n            </tr>\r\n          </thead>\r\n          <tbody>\r\n            <tr *ngFor=\"let row of clientUpdateTableRowList\" \r\n                [hidden]=\"!isEntityTypeIndividual && row.rowName === 'Date of Death'\" >\r\n              <th scope=\"row\">{{row.rowName}}</th>\r\n              <td *ngFor=\"let col of row.rowValues\">{{col}}</td>\r\n            </tr>\r\n          </tbody>\r\n        </table>\r\n      </div>\r\n    </bento-wizard-step>\r\n    <!-- Custom Buttons Go Here -->\r\n    <bento-wizard-custom-button-group>\r\n      <button class=\"btn btn-primary\" [hidden]=\"hideCustomLeftButtons\" [disabled]=\"isDisableUpdateOnvio\"\r\n        [bentoBusyLoader]='isOnvioUpdateBusy' (click)=\"updateOnvio()\">\r\n        Update Onvio\r\n      </button>\r\n      <button class=\"btn btn-primary\" [hidden]=\"hideCustomLeftButtons\" [disabled]=\"isDisableUpdateATO\"\r\n        [bentoBusyLoader]='isATOUpdateBusy' (click)=\"updateAto()\">\r\n        Update ATO\r\n      </button>\r\n      <button class=\"btn btn-outline-primary float-right\" [disabled]='isDisableCancel'\r\n        (click)=\"activeModal.dismiss('Cancel click')\">\r\n        Cancel\r\n      </button>\r\n    </bento-wizard-custom-button-group>\r\n  </bento-wizard>\r\n</div>\r\n",
                styles: [".wizard-content-center{justify-content:center;margin-top:45px}.radio-button-margin-left{font-size:15px;vertical-align:2px;margin-left:8px}"]
            }]
    }], function () { return [{ type: ɵngcc3.NgbActiveModal }, { type: AlertService }, { type: CoreService }, { type: AtoIntegrationService }, { type: AUTaxService }, { type: HelperService }, { type: SessionService }]; }, null); })();

class TaxAgent {
}

// System imports
class ClientRelationshipUpdateComponent {
    constructor(activeModal, helperService, alertService, coreService, atoIntegrationService) {
        this.activeModal = activeModal;
        this.helperService = helperService;
        this.alertService = alertService;
        this.coreService = coreService;
        this.atoIntegrationService = atoIntegrationService;
        this.isAddRelationship = true;
        this.isTaxAgentLoader = false;
        this.entityType = AutaxStaffConstants.entityType;
        this.cmbTaxAgentOptions = {
            searchable: true,
            columns: [{ name: 'name' }, 'tan'],
            headerTranslation: { name: 'Name', tan: 'TAN' }
        };
        this.clientDetail = new ClientDetail();
        this.selectedTaxAgent = new TaxAgent();
    }
    // Init data when page load
    ngOnInit() {
        this.taxAgentData = new BehaviorSubject([]);
        this.clientDetail = this.helperService.getClientDetail();
        this.isAddRelationship = this.helperService.getIsAddRelationship();
        if (this.isAddRelationship) {
            this.bindTaxAgents();
        }
        else {
            this.getTaxAgent();
        }
    }
    // Get tax agents when remove client relathionship
    getTaxAgent() {
        this.isTaxAgentLoader = true;
        this.atoIntegrationService.getClientRelationship(this.clientDetail.clientId).subscribe((data) => {
            this.isTaxAgentLoader = false;
            this.selectedTaxAgent = data.agentDetail;
        }, (error) => {
            this.isTaxAgentLoader = false;
            if (error && error.error && error.error.code && error.error.code !== 404) {
                this.alertService.show(AlertType.danger, 'A server error occurred while retrieving  the client relationship details. Please try again. If the issue persists, please contact support.');
            }
        });
    }
    // Bind the tax agnets details
    bindTaxAgents() {
        const taxAgents = [];
        this.isTaxAgentLoader = true;
        forkJoin(this.coreService.getFirmByCompanyId(this.clientDetail.companyId), this.coreService.getTaxAgentByCompanyId(this.clientDetail.companyId)).subscribe(([firmData, taxAgentData]) => {
            const firmList = taxAgentData.items.filter(item => item.contact.id === firmData.companyClient.contactId);
            firmList.forEach((firm) => {
                taxAgents.push({
                    name: firm.contact.name + ' (Firm)',
                    tan: firm.preparer.personalIdentifier,
                    abn: firm.preparer.auTaxAgent.abn
                });
            });
            const taxAgentList = taxAgentData.items.filter(item => item.contact.id !== firmData.companyClient.contactId && item.preparer.personalIdentifier !== '');
            taxAgentList.forEach((taxAgent) => {
                taxAgents.push({
                    name: taxAgent.contact.name,
                    tan: taxAgent.preparer.personalIdentifier,
                    abn: taxAgent.preparer.auTaxAgent.abn
                });
            });
            this.taxAgentData = new BehaviorSubject(taxAgents);
            this.selectedTaxAgent = taxAgents[0];
            this.isTaxAgentLoader = false;
        }, () => {
            this.isTaxAgentLoader = false;
        });
    }
    // Add the client relationship
    addRelationship() {
        if (this.validTaxAgentDetail()) {
            this.isTaxAgentLoader = true;
            this.alertService.show(AlertType.info, 'The client relationship information has been submitted to the ATO.');
            this.atoIntegrationService.addClientRelationship(this.clientDetail).subscribe((data) => {
                this.alertService.clear();
                this.isTaxAgentLoader = false;
                if (!data.hasErrors) {
                    this.closeClientRelationshipModalWindow(data, true);
                    this.alertService.show(AlertType.success, `The client relationship information has been accepted by the ATO. Refer to the <a class="btn-link" id="lnkPDFFile" target="_blank" href="${data.pdfFilePath}">PDF</a> for more details.`, undefined, 'ato_relationship_success');
                }
                else {
                    if (data.schematronErrors) {
                        data.schematronErrors.forEach(error => {
                            this.alertService.show(AlertType.danger, error.shortDescription);
                        });
                    }
                    if (data.messageStatus && data.messageStatus === RelationshipMessageStatus.rejected) {
                        this.closeClientRelationshipModalWindow(data, false);
                        this.alertService.show(AlertType.danger, `The client relationship information has been rejected by the ATO. Please refer to the <a class="btn-link" id="lnkPDFFile" target="_blank" href="${data.pdfFilePath}">PDF</a> for more details.`, undefined, 'ato_relationship_reject');
                    }
                }
            }, () => {
                this.isTaxAgentLoader = false;
                this.alertService.clear();
                this.alertService.show(AlertType.danger, 'An error occurred while submitting the client relationship details. Please try again. If the issue persists, please contact support.');
            });
        }
    }
    closeClientRelationshipModalWindow(responseData, status) {
        this.activeModal.close();
        const relationshipStatusData = {
            relationshipStatus: status,
            messageStatus: responseData.messageStatus,
            pdfFilePath: responseData.pdfFilePath,
            responseDate: responseData.responseDate,
            isShowDetail: true
        };
        this.helperService.setRelationshipStatus(relationshipStatusData);
    }
    // Remove the client relationship
    removeRelationship() {
        if (this.validTaxAgentDetail()) {
            this.isTaxAgentLoader = true;
            this.alertService.show(AlertType.info, 'The request to remove the client relationship has been submitted to the ATO.');
            this.atoIntegrationService.removeClientRelationship(this.clientDetail).subscribe((data) => {
                this.alertService.clear();
                this.isTaxAgentLoader = false;
                if (!data.hasErrors) {
                    this.closeClientRelationshipModalWindow(data, false);
                    this.alertService.show(AlertType.success, `The request to remove the client relationship has been accepted by the ATO. Refer to the <a class="btn-link" id="lnkPDFFile" target="_blank" href="${data.pdfFilePath}">PDF</a> for more details.`, undefined, 'ato_remove_success');
                }
                else {
                    if (data.schematronErrors) {
                        data.schematronErrors.forEach(error => {
                            this.alertService.show(AlertType.danger, error.shortDescription);
                        });
                    }
                    if (data.messageStatus && data.messageStatus === RelationshipMessageStatus.rejected) {
                        this.closeClientRelationshipModalWindow(data, true);
                        this.alertService.show(AlertType.danger, `The request to remove the client relationship has been rejected by the  ATO. Please refer to the <a class="btn-link" id="lnkPDFFile" target="_blank" href="${data.pdfFilePath}">PDF</a> for more details.`, undefined, 'ato_remove_failed');
                    }
                }
            }, () => {
                this.isTaxAgentLoader = false;
                this.alertService.clear();
                this.alertService.show(AlertType.danger, 'An error occurred while requesting to remove the client relationship. Please try again. If the issue persists, please contact support.', undefined, 'ato_remove_error');
            });
        }
    }
    // Validate the tax agent details like ABN and TAN
    validTaxAgentDetail() {
        this.alertService.clear();
        let isValidData = true;
        this.clientDetail.taxAgentNumber = null;
        this.clientDetail.taxAgentAbn = null;
        if (this.selectedTaxAgent) {
            this.clientDetail.taxAgentNumber = this.selectedTaxAgent.tan;
            this.clientDetail.taxAgentAbn = this.selectedTaxAgent.abn;
            this.clientDetail.intermediaryIdentifier = this.selectedTaxAgent.name;
        }
        if (!this.clientDetail.taxAgentNumber) {
            this.alertService.show(AlertType.danger, 'A Tax Agent Number (TAN) is required to establish a client relationship.');
            isValidData = false;
        }
        if (!this.clientDetail.taxAgentAbn) {
            this.alertService.show(AlertType.danger, 'An Australian Business Number (ABN) is required to establish a client relationship.');
            isValidData = false;
        }
        return isValidData;
    }
}
ClientRelationshipUpdateComponent.ɵfac = function ClientRelationshipUpdateComponent_Factory(t) { return new (t || ClientRelationshipUpdateComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(HelperService), ɵngcc0.ɵɵdirectiveInject(AlertService), ɵngcc0.ɵɵdirectiveInject(CoreService), ɵngcc0.ɵɵdirectiveInject(AtoIntegrationService)); };
ClientRelationshipUpdateComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ClientRelationshipUpdateComponent, selectors: [["autax-client-relationship-update"]], decls: 33, vars: 15, consts: [["id", "btnClose", "name", "btnClose", "type", "button", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true", 1, "bento-icon-close-x"], ["class", "modal-header", 4, "ngIf"], [1, "modal-body", 3, "bentoBusyLoader", "size"], ["class", "row mb-3", 4, "ngIf"], [1, "row", "mb-3"], [1, "col-md-4", "col-sm-4", "col-xs-4", "text-right"], ["class", "col-md-8 col-sm-8 col-xs-8 text-left", 4, "ngIf"], [1, "col-md-8", "col-sm-8", "col-xs-8", "text-left"], [1, "modal-footer"], ["id", "btnAdd", "name", "btnAdd", "type", "button", "class", "btn btn-primary", 3, "click", 4, "ngIf"], ["id", "btnRemove", "name", "btnRemove", "type", "button", "class", "btn btn-primary", 3, "click", 4, "ngIf"], ["id", "btnCancel", "name", "btnCancel", "type", "button", 1, "btn", "btn-outline-primary", 3, "click"], [1, "modal-header"], [1, "col-md-12", "col-sm-12", "col-xs-12"], ["id", "cmbTaxAgent", "name", "cmbTaxAgent", 3, "ngModel", "options", "itemsObservable", "ngModelChange"], ["id", "btnAdd", "name", "btnAdd", "type", "button", 1, "btn", "btn-primary", 3, "click"], ["id", "btnRemove", "name", "btnRemove", "type", "button", 1, "btn", "btn-primary", 3, "click"]], template: function ClientRelationshipUpdateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function ClientRelationshipUpdateComponent_Template_button_click_0_listener() { return ctx.activeModal.close(); });
        ɵngcc0.ɵɵelement(1, "i", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, ClientRelationshipUpdateComponent_h4_2_Template, 2, 0, "h4", 2);
        ɵngcc0.ɵɵtemplate(3, ClientRelationshipUpdateComponent_h4_3_Template, 2, 0, "h4", 2);
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtemplate(5, ClientRelationshipUpdateComponent_div_5_Template, 3, 0, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "div", 5)(7, "div", 6)(8, "b");
        ɵngcc0.ɵɵtext(9, "Tax Agent :");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(10, ClientRelationshipUpdateComponent_div_10_Template, 2, 3, "div", 7);
        ɵngcc0.ɵɵtemplate(11, ClientRelationshipUpdateComponent_div_11_Template, 2, 1, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, ClientRelationshipUpdateComponent_div_12_Template, 6, 1, "div", 4);
        ɵngcc0.ɵɵtemplate(13, ClientRelationshipUpdateComponent_div_13_Template, 7, 3, "div", 4);
        ɵngcc0.ɵɵelementStart(14, "div", 5)(15, "div", 6)(16, "b");
        ɵngcc0.ɵɵtext(17, " Name :");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(18, "div", 8);
        ɵngcc0.ɵɵtext(19);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(20, "div", 5)(21, "div", 6)(22, "b");
        ɵngcc0.ɵɵtext(23, "TFN :");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(24, "div", 8);
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(26, ClientRelationshipUpdateComponent_div_26_Template, 7, 3, "div", 4);
        ɵngcc0.ɵɵtemplate(27, ClientRelationshipUpdateComponent_div_27_Template, 7, 4, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "div", 9);
        ɵngcc0.ɵɵtemplate(29, ClientRelationshipUpdateComponent_button_29_Template, 2, 0, "button", 10);
        ɵngcc0.ɵɵtemplate(30, ClientRelationshipUpdateComponent_button_30_Template, 2, 0, "button", 11);
        ɵngcc0.ɵɵelementStart(31, "button", 12);
        ɵngcc0.ɵɵlistener("click", function ClientRelationshipUpdateComponent_Template_button_click_31_listener() { return ctx.activeModal.close(); });
        ɵngcc0.ɵɵtext(32, "Cancel");
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAddRelationship);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isAddRelationship);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx.isTaxAgentLoader)("size", "sm");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isAddRelationship);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAddRelationship);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isAddRelationship);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedTaxAgent);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selectedTaxAgent);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.clientDetail.clientName, " ");
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.clientDetail.clientTfn, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAddRelationship && ctx.clientDetail.entityType !== ctx.entityType.auIndividual);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAddRelationship && ctx.clientDetail.entityType === ctx.entityType.auIndividual);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAddRelationship);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isAddRelationship);
    } }, directives: function () { return [ɵngcc4.BentoFocusMonitorDirective, ɵngcc1.NgIf, ɵngcc4.BentoBusyLoaderDirective, ɵngcc4.BentoComboboxComponent, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc4.BentoFooterTabHelper]; }, pipes: function () { return [AUABNFormat, ɵngcc1.DatePipe]; }, styles: [".ng-bento[_ngcontent-%COMP%]   .alert.alert-danger[_ngcontent-%COMP%]:before, .ng-bento[_ngcontent-%COMP%]   .alert.alert-danger[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .ng-bento[_ngcontent-%COMP%]   .alert.alert-error[_ngcontent-%COMP%]:before, .ng-bento[_ngcontent-%COMP%]   .alert.alert-error[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{text-decoration:underline}"] });
ClientRelationshipUpdateComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: HelperService },
    { type: AlertService },
    { type: CoreService },
    { type: AtoIntegrationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ClientRelationshipUpdateComponent, [{
        type: Component,
        args: [{
                selector: 'autax-client-relationship-update',
                template: "<button id=\"btnClose\" name=\"btnClose\" type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.close()\">\r\n  <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\r\n</button>\r\n<h4 class=\"modal-header\" *ngIf=\"isAddRelationship\"> Update Client Relationship</h4>\r\n<h4 class=\"modal-header\" *ngIf=\"!isAddRelationship\"> Remove Client Relationship</h4>\r\n<div class=\"modal-body\" [bentoBusyLoader]=\"isTaxAgentLoader\" [size]=\"'sm'\">\r\n  <div class=\"row mb-3\" *ngIf=\"!isAddRelationship\">\r\n    <div class=\"col-md-12 col-sm-12 col-xs-12\">\r\n      This will connect to the Australian Tax Office (ATO) to remove the client relationship details\r\n    </div>\r\n  </div>\r\n  <div class=\"row mb-3\">\r\n    <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n      <b>Tax Agent :</b>\r\n    </div>\r\n    <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\" *ngIf=\"isAddRelationship\">\r\n      <bento-combobox id=\"cmbTaxAgent\" name=\"cmbTaxAgent\" [(ngModel)]=\"selectedTaxAgent\" [options]=\"cmbTaxAgentOptions\"\r\n        [itemsObservable]=\"taxAgentData\">\r\n      </bento-combobox>\r\n    </div>\r\n    <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\" *ngIf=\"!isAddRelationship\">\r\n      {{selectedTaxAgent.name}}\r\n    </div>\r\n  </div>\r\n  <div class=\"row mb-3\" *ngIf=\"selectedTaxAgent\">\r\n    <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n      <b> Tax Agent Number :</b>\r\n    </div>\r\n    <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\">\r\n      {{selectedTaxAgent.tan}}\r\n    </div>\r\n  </div>\r\n  <div class=\"row mb-3\" *ngIf=\"selectedTaxAgent\">\r\n    <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n      <b> Tax Agent ABN :</b>\r\n    </div>\r\n    <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\">\r\n      {{selectedTaxAgent.abn|auABNFormat}}\r\n    </div>\r\n  </div>\r\n  <div class=\"row mb-3\">\r\n    <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n      <b> Name :</b>\r\n    </div>\r\n    <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\">\r\n      {{clientDetail.clientName}}\r\n    </div>\r\n  </div>\r\n  <div class=\"row mb-3\">\r\n    <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n      <b>TFN :</b>\r\n    </div>\r\n    <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\">\r\n      {{clientDetail.clientTfn}}\r\n    </div>\r\n  </div>\r\n  <div class=\"row mb-3\" *ngIf=\"isAddRelationship && clientDetail.entityType !== entityType.auIndividual\">\r\n    <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n      <b> ABN :</b>\r\n    </div>\r\n    <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\">\r\n      {{clientDetail.clientAbn|auABNFormat}}\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row mb-3\" *ngIf=\"isAddRelationship && clientDetail.entityType === entityType.auIndividual\">\r\n    <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n      <b> DOB :</b>\r\n    </div>\r\n    <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\">\r\n      {{clientDetail.individualDateOfBirth|date:'dd/MM/yyyy'}}\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n<div class=\"modal-footer\">\r\n  <button *ngIf=\"isAddRelationship\" id=\"btnAdd\" name=\"btnAdd\" type=\"button\" class=\"btn btn-primary\"\r\n    (click)=\"addRelationship()\">Add</button>\r\n  <button *ngIf=\"!isAddRelationship\" id=\"btnRemove\" name=\"btnRemove\" type=\"button\" class=\"btn btn-primary\"\r\n    (click)=\"removeRelationship()\">Remove</button>\r\n  <button id=\"btnCancel\" name=\"btnCancel\" type=\"button\" class=\"btn btn-outline-primary\"\r\n    (click)=\"activeModal.close()\">Cancel</button>\r\n</div>\r\n",
                styles: [".ng-bento .alert.alert-danger:before,.ng-bento .alert.alert-danger a,.ng-bento .alert.alert-error:before,.ng-bento .alert.alert-error a{text-decoration:underline}"]
            }]
    }], function () { return [{ type: ɵngcc3.NgbActiveModal }, { type: HelperService }, { type: AlertService }, { type: CoreService }, { type: AtoIntegrationService }]; }, null); })();

// System Imports
class AtoAgentClientRelationshipComponent {
    constructor(config, modalService, alertService, helperService, atoIntegrationService, sessionService, coreService, zone, location) {
        this.modalService = modalService;
        this.alertService = alertService;
        this.helperService = helperService;
        this.atoIntegrationService = atoIntegrationService;
        this.sessionService = sessionService;
        this.coreService = coreService;
        this.zone = zone;
        this.location = location;
        this.relationshipModel = new RelationshipStatus();
        this.onrelationshiptoggleon = new EventEmitter();
        this.isShowLoader = false;
        this.isValidData = true;
        this.isRelationshipToggleClick = false;
        this.isActionClick = false;
        this.isRefreshClientDetail = false;
        this.clientDetail = new ClientDetail();
        this.relationshipMessageStatus = RelationshipMessageStatus;
        config.backdrop = 'static';
        this.modalOptions = {
            container: AutaxStaffConstants.nucleusStaffModalContainer
        };
    }
    // Init data when page load
    ngOnInit() {
        this.helperService.getRelationshipStatus().subscribe((status) => {
            this.relationshipModel = status;
        });
        // It will check the current developpment status
        this.sessionService.setCurrentDevelopmentPermission();
        if (this.contacteditorclientdata) {
            this.contacteditorclientdata.subscribe(clientData => {
                if (!this.isRefreshClientDetail) {
                    if (clientData && clientData.id !== 'new' && !this.isRelationshipToggleClick && !this.isActionClick) {
                        this.getClientRelationship(clientData);
                    }
                    else if (this.isRelationshipToggleClick || this.isActionClick) {
                        this.validatedClientDataAndSave(clientData);
                    }
                }
                // This method will set the entity type for the current client.
                this.coreService.setOnvioClientEntityType(clientData.primaryContactExpanded.entityType.id);
            });
        }
    }
    // Destroy data when page is unload
    ngOnDestroy() {
        this.isRelationshipToggleClick = false;
        this.isActionClick = false;
        this.isRefreshClientDetail = false;
    }
    // Opens client address update modal window after saving client detail when action buttion clicked
    open() {
        this.modalService.open(ClientAddressUpdateComponent, this.modalOptions).result.then((result) => {
            this.refreshClientDetail();
        }).catch((error) => {
            // Update unit test when something written here
            noop$1();
        });
    }
    // Emit event for save client details when action button click
    onAction() {
        this.isRefreshClientDetail = false;
        this.isRelationshipToggleClick = false;
        this.isActionClick = true;
        this.onrelationshiptoggleon.emit();
    }
    // Emit on relationship event when toggle is on
    onRelationshipChange() {
        this.isRefreshClientDetail = false;
        this.isActionClick = false;
        this.isRelationshipToggleClick = true;
        this.onrelationshiptoggleon.emit();
    }
    // Get Client Relationship details
    getClientRelationship(clientData) {
        this.zone.run(() => {
            this.alertService.clear();
            this.isShowLoader = true;
            this.atoIntegrationService.getClientRelationship(clientData.id).subscribe((data) => {
                this.isShowLoader = false;
                this.relationshipModel.responseDate = data.dateOfResponse;
                this.relationshipModel.pdfFilePath = data.pdfFilePath;
                this.relationshipModel.messageStatus = data.messageStatus;
                this.relationshipModel.relationshipStatus = data.toggleStatus === 'true' ? true : false;
            }, (error) => {
                this.isShowLoader = false;
                if (error && error.error && error.error.code && error.error.code !== 404) {
                    this.alertService.show(AlertType.danger, 'A server error occurred while retrieving  the client relationship details. Please try again. If the issue persists, please contact support.');
                }
            });
        });
    }
    // Validate client data and save the client details
    validatedClientDataAndSave(clientData) {
        this.alertService.clear();
        this.isValidData = true;
        let errorMessage = 'Following detail(s) are missing </br><ul>';
        if (!clientData.code) {
            errorMessage = errorMessage + '<li>Client\'s ID</li>';
            this.isValidData = false;
        }
        if (!clientData.primaryContactExpanded.fullName) {
            errorMessage = errorMessage + '<li>Name of the Client</li>';
            this.isValidData = false;
        }
        const tfn = clientData.primaryContactExpanded.nationalIdentitiesExpanded.filter(function (item) {
            return item.kind.id === AutaxStaffConstants.nationalIdentitiesExpanded.auTFN;
        });
        if (tfn && !tfn[0].identity) {
            errorMessage = errorMessage + '<li>Client\'s TFN</li>';
            this.isValidData = false;
        }
        const abn = clientData.primaryContactExpanded.nationalIdentitiesExpanded.filter(function (item) {
            return item.kind.id === AutaxStaffConstants.nationalIdentitiesExpanded.auABN;
        });
        if (clientData.primaryContactExpanded.entityType.id !== AutaxStaffConstants.entityType.auIndividual) {
            if (abn && !abn[0].identity) {
                errorMessage = errorMessage + '<li>Client\'s ABN</li>';
                this.isValidData = false;
            }
        }
        if (clientData.primaryContactExpanded.entityType.id === AutaxStaffConstants.entityType.auIndividual) {
            if (!clientData.primaryContactExpanded.dateOfBirth) {
                errorMessage = errorMessage + '<li>Date of Birth</li>';
                this.isValidData = false;
            }
        }
        if (!this.isValidData) {
            errorMessage = errorMessage + '</ul>';
            this.alertService.show(AlertType.danger, errorMessage);
        }
        else {
            this.isShowLoader = true;
            this.contacteditorbeforesave().then(() => {
                return this.contacteditorsavepromise();
            }).then((data) => {
                this.isShowLoader = false;
                this.clientDetail = new ClientDetail();
                this.clientDetail.clientTfn = tfn[0].identity;
                this.clientDetail.intermediarySignatureIndicator = true; // Default it to "True" while creating the instance
                this.clientDetail.clientName = clientData.primaryContactExpanded.fullName;
                this.clientDetail.clientType = clientData.primaryContactExpanded.entityType.name;
                this.clientDetail.clientAbn = abn[0].identity;
                this.clientDetail.clientId = data.id;
                this.clientDetail.companyId = data.companyId;
                this.clientDetail.contactId = data.primaryContact.id;
                this.clientDetail.entityType = clientData.primaryContactExpanded.entityType.id;
                if (this.clientDetail.clientAbn) {
                    this.clientDetail.clientAbn = this.clientDetail.clientAbn.replace(/ /g, '');
                }
                else {
                    this.clientDetail.clientAbn = null;
                }
                this.helperService.setClientDetail(this.clientDetail);
                if (this.relationshipModel && !this.relationshipModel.relationshipStatus) {
                    this.clientDetail.individualDateOfBirth = clientData.primaryContactExpanded.dateOfBirth;
                    this.helperService.setIsAddRelationship(true);
                }
                else {
                    this.helperService.setIsAddRelationship(false);
                }
                if (this.isRelationshipToggleClick) {
                    this.location.replaceState(`/setup/clients/${this.clientDetail.clientId}/general`);
                    this.openClientRelationshipModel();
                }
                if (this.isActionClick) {
                    this.open();
                }
            }).finally(() => {
                this.isShowLoader = false;
            });
        }
    }
    // Opens Client Relationship Add modal window when toggle on
    openClientRelationshipModel() {
        this.modalService.open(ClientRelationshipUpdateComponent, this.modalOptions).result.then((result) => {
            noop$1();
        }).catch(() => {
            noop$1();
        });
    }
    // Refresh client detail after updated address to Onvio
    refreshClientDetail() {
        this.isRefreshClientDetail = true;
        this.contacteditorloaddatapromise().then((data) => { }, (error) => { });
    }
}
AtoAgentClientRelationshipComponent.ɵfac = function AtoAgentClientRelationshipComponent_Factory(t) { return new (t || AtoAgentClientRelationshipComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbModalConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbModal), ɵngcc0.ɵɵdirectiveInject(AlertService), ɵngcc0.ɵɵdirectiveInject(HelperService), ɵngcc0.ɵɵdirectiveInject(AtoIntegrationService), ɵngcc0.ɵɵdirectiveInject(SessionService), ɵngcc0.ɵɵdirectiveInject(CoreService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Location)); };
AtoAgentClientRelationshipComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AtoAgentClientRelationshipComponent, selectors: [["autax-ato-agent-client-relationship"]], inputs: { contacteditorclientdata: "contacteditorclientdata", contacteditorbeforesave: "contacteditorbeforesave", contacteditorsavepromise: "contacteditorsavepromise", contacteditorloaddatapromise: "contacteditorloaddatapromise" }, outputs: { onrelationshiptoggleon: "onrelationshiptoggleon" }, decls: 37, vars: 9, consts: [[1, "client-update-panel", "ng-bento"], [1, "row"], [1, "col-md-12", "col-sm-12", "col-xs-12"], [1, "setup-section-header-margin"], [1, "client-update-panel-heading"], [1, "col-md-8", "col-sm-8", "col-xs-6"], [1, "col-md-2", "col-sm-2", "col-xs-3", "text-center"], [3, "bentoBusyLoader"], [1, "client-update-panel-group"], ["id", "btnToggleRelationship", "name", "btnToggleRelationship", "type", "button", 1, "btn-bento-toggle", 3, "click"], ["id", "check-relationship", "name", "check-relationship", 1, "bento-toggle-sm", 3, "ngModel", "disabled", "ngModelChange"], ["id", "clientAddressUpdate", 1, "btn", "btn-link", "btn-action", 3, "disabled", "click"], [1, "client-update-panel-body", 3, "ngbCollapse"], [1, "row", "mb-3"], [1, "col-md-6", "col-sm-6", "col-xs-6", "text-left"], [1, "col-md-2", "col-sm-2", "col-xs-2", "text-center"], ["class", "badge badge-success", 4, "ngIf"], ["class", "badge badge-danger", 4, "ngIf"], ["id", "lnkPDFFile", "target", "_blank", 1, "btn-link", 3, "href"], [1, "ng-bento"], [1, "badge", "badge-success"], [1, "badge", "badge-danger"]], template: function AtoAgentClientRelationshipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "h3", 3);
        ɵngcc0.ɵɵtext(4, "Agent Client Relationship");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(5, "div", 4)(6, "div", 1);
        ɵngcc0.ɵɵelement(7, "div", 5);
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵtext(9, "Relationship");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 6);
        ɵngcc0.ɵɵtext(11, "Manage Detail");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(12, "div", 7)(13, "div", 8)(14, "div", 1)(15, "div", 5);
        ɵngcc0.ɵɵtext(16, " Setup the relationship with the Australian Tax Office (ATO) and manage details ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 6)(18, "button", 9);
        ɵngcc0.ɵɵlistener("click", function AtoAgentClientRelationshipComponent_Template_button_click_18_listener() { return ctx.onRelationshipChange(); });
        ɵngcc0.ɵɵelementStart(19, "bento-toggle", 10);
        ɵngcc0.ɵɵlistener("ngModelChange", function AtoAgentClientRelationshipComponent_Template_bento_toggle_ngModelChange_19_listener($event) { return ctx.relationshipModel.relationshipStatus = $event; });
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(20, "div", 6)(21, "button", 11);
        ɵngcc0.ɵɵlistener("click", function AtoAgentClientRelationshipComponent_Template_button_click_21_listener() { return ctx.onAction(); });
        ɵngcc0.ɵɵtext(22, "Action");
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(23, "div", 12)(24, "div", 13)(25, "div", 14);
        ɵngcc0.ɵɵtext(26, " Relationship has been setup with ATO ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(27, "div", 15);
        ɵngcc0.ɵɵtext(28);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(29, "div", 15);
        ɵngcc0.ɵɵtemplate(30, AtoAgentClientRelationshipComponent_span_30_Template, 2, 1, "span", 16);
        ɵngcc0.ɵɵtemplate(31, AtoAgentClientRelationshipComponent_span_31_Template, 2, 1, "span", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(32, "div", 15)(33, "a", 18);
        ɵngcc0.ɵɵtext(34, " curel_ato_response.pdf ");
        ɵngcc0.ɵɵelementEnd()()()()()();
        ɵngcc0.ɵɵelementStart(35, "div", 19);
        ɵngcc0.ɵɵelement(36, "autax-alert");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(12);
        ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx.isShowLoader);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngModel", ctx.relationshipModel.relationshipStatus)("disabled", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("disabled", !ctx.relationshipModel.relationshipStatus);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngbCollapse", !ctx.relationshipModel.relationshipStatus);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.relationshipModel.responseDate, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.relationshipModel.messageStatus === ctx.relationshipMessageStatus.accepted);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.relationshipModel.messageStatus === ctx.relationshipMessageStatus.rejected);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("href", ctx.relationshipModel.pdfFilePath, ɵngcc0.ɵɵsanitizeUrl);
    } }, directives: function () { return [ɵngcc4.BentoBusyLoaderDirective, ɵngcc4.BentoToggleComponent, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc4.BentoFocusMonitorDirective, ɵngcc3.NgbCollapse, ɵngcc1.NgIf, AlertComponent]; }, styles: [".client-update-panel[_ngcontent-%COMP%]   .client-update-panel-heading[_ngcontent-%COMP%]{font-size:12px;font-family:Arial,Helvetica Neue,sans-serif;text-align:center;text-transform:capitalize;font-weight:700;color:#555;padding:10px;border:1px solid #c3c3ca;background-color:#f4f5f7}.client-update-panel[_ngcontent-%COMP%]   .client-update-panel-group[_ngcontent-%COMP%]{font-size:14px;font-family:Arial,Helvetica Neue,sans-serif;padding:15px 10px 5px;border:1px solid #c3c3ca;border-top:0;background-color:#f4f5f7;min-height:65px}.client-update-panel[_ngcontent-%COMP%]   .client-update-panel-group[_ngcontent-%COMP%]   .details[_ngcontent-%COMP%]{font-size:12px}.client-update-panel[_ngcontent-%COMP%]   .client-update-panel-body[_ngcontent-%COMP%]{padding:20px;border:1px solid #c3c3ca;border-top:0}.client-update-panel[_ngcontent-%COMP%]   .btn-bento-toggle[_ngcontent-%COMP%]{background:none;border:0}.client-update-panel[_ngcontent-%COMP%]   bento-toggle.disabled[_ngcontent-%COMP%]{opacity:unset}"] });
AtoAgentClientRelationshipComponent.ctorParameters = () => [
    { type: NgbModalConfig },
    { type: NgbModal },
    { type: AlertService },
    { type: HelperService },
    { type: AtoIntegrationService },
    { type: SessionService },
    { type: CoreService },
    { type: NgZone },
    { type: Location }
];
AtoAgentClientRelationshipComponent.propDecorators = {
    contacteditorclientdata: [{ type: Input }],
    contacteditorbeforesave: [{ type: Input }],
    contacteditorsavepromise: [{ type: Input }],
    contacteditorloaddatapromise: [{ type: Input }],
    onrelationshiptoggleon: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtoAgentClientRelationshipComponent, [{
        type: Component,
        args: [{
                selector: 'autax-ato-agent-client-relationship',
                template: "<!-- NOTE: Add \"ng-bento\" class so that it will not override Bento-Modern css -->\r\n<div class=\"client-update-panel ng-bento\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12 col-sm-12 col-xs-12\">\r\n      <h3 class=\"setup-section-header-margin\">Agent Client Relationship</h3>\r\n    </div>\r\n  </div>\r\n  <!-- Header -->\r\n  <div class=\"client-update-panel-heading\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-8 col-sm-8 col-xs-6\"></div>\r\n      <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\">Relationship</div>\r\n      <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\">Manage Detail</div>\r\n    </div>\r\n  </div>\r\n  <div [bentoBusyLoader]=\"isShowLoader\">\r\n    <!-- Item heading -->\r\n    <div class=\"client-update-panel-group\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-8 col-sm-8 col-xs-6\">\r\n          Setup the relationship with the Australian Tax Office (ATO) and manage details\r\n        </div>\r\n        <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\">\r\n          <!-- Toggle added inside button because no click event for toggle -->\r\n          <button id=\"btnToggleRelationship\" name=\"btnToggleRelationship\" type=\"button\" (click)=\"onRelationshipChange()\"\r\n            class=\"btn-bento-toggle\">\r\n            <bento-toggle id=\"check-relationship\" name=\"check-relationship\" class=\"bento-toggle-sm\"\r\n              [(ngModel)]=\"relationshipModel.relationshipStatus\" [disabled]=\"true\">\r\n            </bento-toggle>\r\n          </button>\r\n        </div>\r\n        <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\">\r\n          <button class=\"btn btn-link btn-action\" id='clientAddressUpdate' [disabled]=\"!relationshipModel.relationshipStatus\"\r\n            (click)=\"onAction()\">Action</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!-- Item body -->\r\n    <div class=\"client-update-panel-body\" [ngbCollapse]=\"!relationshipModel.relationshipStatus\">\r\n      <div class=\"row mb-3\">\r\n        <div class=\"col-md-6 col-sm-6 col-xs-6 text-left\">\r\n          Relationship has been setup with ATO\r\n        </div>\r\n        <div class=\"col-md-2 col-sm-2 col-xs-2 text-center\">\r\n          {{relationshipModel.responseDate}}\r\n        </div>\r\n        <div class=\"col-md-2 col-sm-2 col-xs-2 text-center\">\r\n          <span class=\"badge badge-success\"\r\n            *ngIf=\"relationshipModel.messageStatus === relationshipMessageStatus.accepted\">\r\n            {{relationshipModel.messageStatus}}\r\n          </span>\r\n          <span class=\"badge badge-danger\"\r\n            *ngIf=\"relationshipModel.messageStatus === relationshipMessageStatus.rejected\">\r\n            {{relationshipModel.messageStatus}}\r\n          </span>\r\n        </div>\r\n        <div class=\"col-md-2 col-sm-2 col-xs-2 text-center\">\r\n          <a class=\"btn-link\" id='lnkPDFFile' target=\"_blank\" [href]=\"relationshipModel.pdfFilePath\">\r\n            curel_ato_response.pdf\r\n          </a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"ng-bento\">\r\n  <autax-alert></autax-alert>\r\n</div>",
                styles: [".client-update-panel .client-update-panel-heading{font-size:12px;font-family:Arial,Helvetica Neue,sans-serif;text-align:center;text-transform:capitalize;font-weight:700;color:#555;padding:10px;border:1px solid #c3c3ca;background-color:#f4f5f7}.client-update-panel .client-update-panel-group{font-size:14px;font-family:Arial,Helvetica Neue,sans-serif;padding:15px 10px 5px;border:1px solid #c3c3ca;border-top:0;background-color:#f4f5f7;min-height:65px}.client-update-panel .client-update-panel-group .details{font-size:12px}.client-update-panel .client-update-panel-body{padding:20px;border:1px solid #c3c3ca;border-top:0}.client-update-panel .btn-bento-toggle{background:none;border:0}.client-update-panel bento-toggle.disabled{opacity:unset}"]
            }]
    }], function () { return [{ type: ɵngcc3.NgbModalConfig }, { type: ɵngcc3.NgbModal }, { type: AlertService }, { type: HelperService }, { type: AtoIntegrationService }, { type: SessionService }, { type: CoreService }, { type: ɵngcc0.NgZone }, { type: ɵngcc1.Location }]; }, { onrelationshiptoggleon: [{
            type: Output
        }], contacteditorclientdata: [{
            type: Input
        }], contacteditorbeforesave: [{
            type: Input
        }], contacteditorsavepromise: [{
            type: Input
        }], contacteditorloaddatapromise: [{
            type: Input
        }] }); })();

// System Import
class AlertComponent {
    constructor(alertService) {
        this.alertService = alertService;
        this.alerts = [];
    }
    // Init data when page load
    ngOnInit() {
        this.alertService.onAlert()
            .subscribe((alert) => {
            this.alerts = alert;
        });
    }
    ;
}
AlertComponent.ɵfac = function AlertComponent_Factory(t) { return new (t || AlertComponent)(ɵngcc0.ɵɵdirectiveInject(AlertService)); };
AlertComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AlertComponent, selectors: [["autax-alert"]], decls: 1, vars: 1, consts: [[1, "ng-bento", 3, "items"]], template: function AlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "bento-alert", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("items", ctx.alerts);
    } }, directives: [ɵngcc4.BentoAlertComponent], styles: ["[_nghost-%COMP%]     bento-alert .alert-container{bottom:0;top:unset}"] });
AlertComponent.ctorParameters = () => [
    { type: AlertService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertComponent, [{
        type: Component,
        args: [{
                selector: 'autax-alert',
                template: "<bento-alert [items]=\"alerts\" class=\"ng-bento\">\r\n</bento-alert>",
                styles: [":host ::ng-deep bento-alert .alert-container{bottom:0;top:unset}"]
            }]
    }], function () { return [{ type: AlertService }]; }, null); })();

class AtoOnvioMigrationV1$1 {
}

// Custom Ngb date parser formatter to support dd/MM/yyyy
class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
    constructor() {
        super(...arguments);
        this.parse = (value) => {
            if (value) {
                let changeday = parseInt(value.slice(0, 2));
                let changemonth = parseInt(value.slice(2, 4));
                let changeyear = parseInt(value.slice(4, 8));
                if (Number(changeday) && Number(changemonth) && Number(changeyear) && value.slice(4, 8).length === 4 && changeyear >= 1000) {
                    return { year: changeyear, month: changemonth, day: changeday };
                }
                else {
                    return null;
                }
            }
            return null;
        };
        this.format = (date) => {
            return date ? `${!isNaN(date.day) ? this.padNumber(date.day) : ''}/${!isNaN(date.month) ? this.padNumber(date.month) : ''}/${date.year}` : '';
        };
        this.padNumber = (value) => {
            return `0${value}`.slice(-2);
        };
    }
}
NgbDateCustomParserFormatter.ɵfac = /*@__PURE__*/ function () { let ɵNgbDateCustomParserFormatter_BaseFactory; return function NgbDateCustomParserFormatter_Factory(t) { return (ɵNgbDateCustomParserFormatter_BaseFactory || (ɵNgbDateCustomParserFormatter_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(NgbDateCustomParserFormatter)))(t || NgbDateCustomParserFormatter); }; }();
NgbDateCustomParserFormatter.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgbDateCustomParserFormatter, factory: NgbDateCustomParserFormatter.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgbDateCustomParserFormatter, [{
        type: Injectable
    }], null, null); })();
//Custom DateValidationClass for to validate date format and validate date value like 31/02/2015 and compareDate function
class DateValidationClass {
    static validationDate(date) {
        const dateParts = date.trim().split('/');
        let checkdate = new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]));
        if (!(checkdate && (checkdate.getMonth() + 1) == parseInt(dateParts[1])) || dateParts.length < 3 || dateParts.length > 3) {
            return true;
        }
        else {
            return false;
        }
    }
    static compareDate(date) {
        const dateParts = date.trim().split('/');
        let checkdate = new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]));
        let today = new Date();
        if (today < checkdate) {
            return true;
        }
        else {
            return false;
        }
    }
    static ngbDatetoString(date) {
        if (!isString(date)) {
            let ngbDateCustomParserFormatterobj = new NgbDateCustomParserFormatter();
            let stringDate = ngbDateCustomParserFormatterobj.format(date);
            return stringDate;
        }
        else {
            return date.toString();
        }
    }
}

class DirectDebitDateService {
    /**
     * Instantiate the service
     * @param  {HttpClient} privatehttp Injected http service for dependency
     * @param  {SessionService} session Bluemoon service injected for dependency
     */
    constructor(http, session) {
        this.http = http;
        this.session = session;
        this.UDSLongToken = ""; //insert token here;
        this.initialAllowableDays = 3;
        this.holidays = [];
    }
    /**
     * Get server data from API
     * @returns Observable Server Data that contains bar graph and year to date data
     */
    getHolidaysForDatePicking() {
        return from(this.session.getBasePath(ServiceKey.AUTaxReportingServices)).pipe(mergeMap((basePath) => this.http.get(`${basePath}/` + BuildRoute.getBuildRoute(EndpointRoute.Get_v1_directDebitHolidays, {}))
            .pipe(map((data) => data), catchError(() => of(null)))));
    }
    /**
     * Check if the date entered is allowed to be cancelled (is within 3 working days)
     * @param  {} paymentDate
     * @param  {} holidays=[]
     * @returns boolean
     */
    checkIfCancellationDateAllowable(paymentDate, holidays = []) {
        const currentDate = new Date();
        const endDate = new Date(paymentDate.replace(/-/g, "/"));
        const diff = new Date(endDate.getTime() - currentDate.getTime());
        const dayDifference = diff.getUTCDate() - 1;
        const holidaysBetween = this.createHolidayListForCertainRange(currentDate, endDate);
        const weekendCount = this.getWeekendCount(currentDate, endDate);
        //subtract holidays and weekends from day difference
        const totalDayDifference = dayDifference - holidaysBetween.length - weekendCount;
        if (totalDayDifference < this.initialAllowableDays) {
            return true;
        }
        return false;
    }
    /**
     * Check if given date is equivalent to a weekend
     * @param  {} date
     * @returns boolean
     */
    checkIfWeekend(date) {
        var formattedDate = new Date(date);
        var isWeekend = formattedDate.getDay() == 0 || formattedDate.getDay() == 6;
        return isWeekend;
    }
    /**
     * Check if given date is a holiday
     * @param  {any} date
     */
    checkIfDateIsHoliday(date, blockedDates) {
        let isHoliday = false;
        blockedDates.forEach((blockedDate, i) => {
            let v = this.convertDateToNGBDate(blockedDate.date);
            if (date.day == v.day &&
                date.month == v.month &&
                date.year == v.year) {
                isHoliday = true;
            }
        });
        return isHoliday;
    }
    /**
     * Convert NGB Date back to a regular Date
     * @param  {} ngbDate
     * @returns Date
     */
    convertNGBDate(ngbDate) {
        return new Date(this.pad(ngbDate.month) + '/' + this.pad(ngbDate.day) + '/' + ngbDate.year);
    }
    /**
     * Pad a number with 0
     * @param  {} n
     */
    pad(n) {
        return Number(n) < 10 ? "0" + Number(n) : n;
    }
    /**
     * Convert a regular date to NGB Date format to be used for ngb datepicker
     * @param  {} dToConvert date to convert
     * @returns IBrokenDownDate
     */
    convertDateToNGBDate(dToConvert) {
        const date = new Date(dToConvert).toLocaleDateString("en-AU");
        const explodedDate = date.split("/");
        let newDate = {
            day: explodedDate[0],
            month: explodedDate[1],
            year: explodedDate[2]
        };
        return newDate;
    }
    /**
    * Check if a date is within a range
    * @param  {} from start of the range
    * @param  {} to end of range
    * @param  {} dateToCheck date to validate
    * @returns boolean
    */
    dateCheck(from, to, dateToCheck) {
        // console.log(from,to,dateToCheck)
        var fDate, lDate, cDate;
        fDate = Date.parse(from);
        lDate = Date.parse(to);
        cDate = Date.parse(dateToCheck);
        if (cDate <= lDate && cDate >= fDate) {
            return false;
        }
        return true;
    }
    /**
     * Get the number of weekends within a range
     * @param  {} startRange
     * @param  {} endRange
     * @returns number
     */
    getWeekendCount(startRange, endRange) {
        var start = new Date(startRange), end = new Date(endRange), weekendCount = 0;
        while (start < end) {
            var day = start.getDay();
            const isWeekend = (day === 6) || (day === 0);
            if (isWeekend) {
                weekendCount += 1;
            }
            start.setDate(start.getDate() + 1);
        }
        return weekendCount;
    }
    /**
     * Get list of holidays for a certain range
     * @param  {} startRange
     * @param  {} endRange
     * @returns any
     */
    createHolidayListForCertainRange(startRange, endRange) {
        const holidayList = [];
        let daysToAddOnRange = 0;
        this.holidays.forEach(holidayObject => {
            holidayObject.holidays.forEach(holiday => {
                if (!this.dateCheck(startRange, endRange, holiday.date) === true) {
                    holidayList.push(holiday);
                    daysToAddOnRange += 1;
                }
            });
        });
        return holidayList;
    }
}
DirectDebitDateService.ɵfac = function DirectDebitDateService_Factory(t) { return new (t || DirectDebitDateService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(SessionService)); };
DirectDebitDateService.ɵprov = i0.ɵɵdefineInjectable({ factory: function DirectDebitDateService_Factory() { return new DirectDebitDateService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(SessionService)); }, token: DirectDebitDateService, providedIn: "root" });
DirectDebitDateService.ctorParameters = () => [
    { type: HttpClient },
    { type: SessionService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DirectDebitDateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: SessionService }]; }, null); })();

class DPDateCustomFormatter extends NgbDateCustomParserFormatter {
    constructor() {
        super(...arguments);
        this.DELIMITER = "/";
        this.parse = (value) => {
            if (value) {
                let date = value.split(this.DELIMITER);
                return {
                    day: parseInt(date[0], 10),
                    month: parseInt(date[1], 10),
                    year: parseInt(date[2], 10)
                };
            }
            return null;
        };
        this.format = (date) => {
            return date
                ? date.month + this.DELIMITER + date.day + this.DELIMITER + date.year
                : "";
        };
    }
}
DPDateCustomFormatter.ɵfac = /*@__PURE__*/ function () { let ɵDPDateCustomFormatter_BaseFactory; return function DPDateCustomFormatter_Factory(t) { return (ɵDPDateCustomFormatter_BaseFactory || (ɵDPDateCustomFormatter_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(DPDateCustomFormatter)))(t || DPDateCustomFormatter); }; }();
DPDateCustomFormatter.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DPDateCustomFormatter, factory: DPDateCustomFormatter.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DPDateCustomFormatter, [{
        type: Injectable
    }], null, null); })();
class DirectDebitPaymentComponent {
    constructor(activeModal, calendar, debitDateService) {
        this.activeModal = activeModal;
        this.calendar = calendar;
        this.debitDateService = debitDateService;
        this.alerts = [];
        this.showVerifiedNote = false;
        this.dateIsInvalid = false;
        this.holidays = [];
        this.datepickerReady = false;
        this.datePickerRules = {
            startRange: new Date(),
            endRange: new Date(),
            blockedDates: []
        };
        this.dateConfig = {
            type: 'recent',
            format: 'mm/dd/yyyy'
        };
        this.isShowLoader = false;
    }
    /**
     * Initialize date picker resources
     * @returns void
     */
    ngOnInit() {
        this.isShowLoader = true;
        this.debitDateService.getHolidaysForDatePicking().subscribe((holidays) => {
            this.debitDateService.holidays = holidays;
            this.setDatePickerBlockedDates(3, 90, holidays);
            this.markDisabledCallback = (date) => {
                const normalDate = this.debitDateService.convertNGBDate(date); //convert to normal date
                var ngbDate = new Date(date.year, date.month - 1, date.day);
                const toBlock = this.isDateInvalid(ngbDate);
                return toBlock;
            };
            this.isShowLoader = false;
        });
    }
    /**
     * Check if the date selected is valid or invalid in 3 cases
     * @param  {any} normalDate
     * @returns boolean
     */
    isDateInvalid(normalDate) {
        let dateInvalidity = false;
        const ngbDate = this.debitDateService.convertDateToNGBDate(normalDate);
        const blockBecauseHoliday = this.debitDateService.checkIfDateIsHoliday(ngbDate, this.datePickerRules.blockedDates);
        const blockBecauseWeekend = this.debitDateService.checkIfWeekend(normalDate);
        const blockBecauseOutsideAllowable = this.debitDateService.dateCheck(this.datePickerRules.startRange, this.datePickerRules.endRange, normalDate);
        dateInvalidity = blockBecauseHoliday || blockBecauseWeekend || blockBecauseOutsideAllowable;
        return dateInvalidity;
    }
    /**
     * Set the range and dates to block on date picke
     * @param  {} startPadding days to add to get the allowable startdate
     * @param  {} range days to add to get the range of dates allowed to be picked
     * @param  {} holidaysObject list of holidays to be blocked on the date picker
     * @returns void
     */
    setDatePickerBlockedDates(startPadding, range, holidaysObject) {
        this.datePickerRules.startRange = this.addDaysToDate(startPadding);
        this.datePickerRules.endRange = this.addDaysToEndDate(range);
        let daysToAddOnRange = 0;
        //from the holidays, get the blocked dates
        holidaysObject.forEach(holidayObject => {
            holidayObject.holidays.forEach(holiday => {
                if (!this.debitDateService.dateCheck(this.datePickerRules.startRange, this.datePickerRules.endRange, holiday.date) === true) {
                    this.datePickerRules.blockedDates.push(holiday);
                    daysToAddOnRange += 1;
                }
            });
        });
        this.datePickerRules.startRange = this.addDaysToDate(startPadding + (daysToAddOnRange - 1));
        this.datePickerRules.endRange = this.addDaysToEndDate(range);
    }
    /**
     * Return true/false based on input amount.
     * @param  {number} amount
     * @returns boolean
     */
    validateTransactionAmountLimit(amount) {
        if (amount > 0 && amount < 100000) {
            return true;
        }
        else {
            this.alertMessage('Direct Debit Payment can not be made, please enter an amount less than AUD 100,000', AlertType.warning);
            return false;
        }
    }
    /**
     * checks if the verified details checkbox is checked
     * @returns boolean
     */
    checkdetails() {
        if (!this.isVerified || this.isVerified === undefined) {
            return true;
        }
        else {
            return false;
        }
    }
    checkDateInvalidity() {
        //get the value of payment date in string
        this.paymentDate = this.rawPaymentDate.month + '/' + this.rawPaymentDate.day + '/' + this.rawPaymentDate.year;
        return this.isDateInvalid(this.paymentDate);
    }
    /**
     * no api calls for now
     * a palceholder for save ewquest to api
     * @returns void
     */
    saveDirectDebit() {
        this.dateIsInvalid = this.checkDateInvalidity();
        //add handling here to stop saving if dateIsInvalid
        if (this.checkdetails()) {
            this.showVerifiedNote = true;
        }
        else {
            this.showVerifiedNote = false;
            this.alertMessage('Direct Debit Payment has been successfully Added', AlertType.success);
        }
    }
    /**
     * Display alert message
     * @param  {string} message
     * @param  {string} type?
     */
    alertMessage(message, type) {
        this.alerts.push({
            type,
            msg: message,
            closeable: true,
        });
    }
    /**
     * prevents user to input characters aside from numbera
     * @param  {} event
     * @returns boolean
     */
    keyPressNumbers(event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if ((charCode < 48 || charCode > 57)) {
            event.preventDefault();
            return false;
        }
        else {
            return true;
        }
    }
    /**
     * Add days to a current date while removing weekends and get a new date
     * @param  {} daysToAdd
     * @param  {} baseDate
     * @returns string
     */
    addDaysToDate(daysToAdd, baseDate = null) {
        var startDate = new Date().toDateString();
        if (baseDate != null) {
            startDate = baseDate.toDateString();
        }
        var newStart = new Date(startDate.replace(/-/g, "/"));
        var count = 0;
        while (count < daysToAdd) {
            var newEndDate = new Date(newStart.setDate(newStart.getDate() + 1));
            var isNotWeekend = newEndDate.getDay() != 0 && newEndDate.getDay() != 6;
            var isHoliday = this.debitDateService.checkIfDateIsHoliday(newEndDate, this.datePickerRules.blockedDates);
            if (isNotWeekend && !isHoliday) {
                //Date.getDay() gives weekday starting from 0(Sunday) to 6(Saturday)
                count++;
            }
        }
        return newEndDate;
    }
    /**
     * Add days to a current date while removing weekends and get a new date
     * @param  {} daysToAdd
     * @param  {} baseDate
     * @returns string
     */
    addDaysToEndDate(daysToAdd, baseDate = null) {
        var startDate = new Date().toDateString();
        if (baseDate != null) {
            startDate = baseDate.toDateString();
        }
        var newStart = new Date(startDate.replace(/-/g, "/"));
        return new Date(newStart.setDate(newStart.getDate() + daysToAdd));
    }
}
DirectDebitPaymentComponent.ɵfac = function DirectDebitPaymentComponent_Factory(t) { return new (t || DirectDebitPaymentComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbCalendar), ɵngcc0.ɵɵdirectiveInject(DirectDebitDateService)); };
DirectDebitPaymentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DirectDebitPaymentComponent, selectors: [["autax-direct-debit-payment"]], features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NgbDateParserFormatter, useClass: DPDateCustomFormatter }
        ])], decls: 59, vars: 10, consts: [[1, "directdebit-details-alerts", 3, "items"], ["id", "btnClose", "name", "btnClose", "type", "button", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true", 1, "bento-icon-close-x"], [1, "modal-body", 3, "bentoBusyLoader"], [1, "form-group"], [1, "row"], [1, "bento-label"], [1, "row", "field-divs"], [1, "col-md-6"], [1, "source-url-el", "input-group", "input-group-unstyled"], ["name", "amount", 1, "form-control"], [1, "input-group"], ["id", "datepicker-dropdown-input", "name", "dp", "placeholder", "mm/dd/yyyy", "ngbDatepicker", "", 1, "form-control", "bento-datepicker", 3, "autoClose", "ngModel", "markDisabled", "bentoDatepickerConfig", "ngModelChange"], ["d", "ngbDatepicker"], ["type", "button", "aria-haspopup", "true", "aria-label", "Open calendar", "title", "Open calendar", 1, "btn", "btn-outline-primary", "btn-icon", "ml-2", 3, "bentoDatepickerToggle"], ["aria-hidden", "true", 1, "bento-icon-calendar", "calendarIcon"], ["id", "asn", "name", "asn", "maxlength", "5", 1, "form-control", 3, "keypress"], [1, "row", "field-divs-2"], [1, "col-md-12"], [1, "form-group", "form-check", "demo-group"], ["id", "my-checkbox", 3, "ngModel", "ngModelChange"], ["for", "my-checkbox", 1, "checkbox-label"], ["class", "checkbox-error-note", 4, "ngIf"], [1, "col-md-5"], [1, "float-right"], ["id", "btnSave", "name", "btnSave", "type", "button", 1, "btn", "btn-primary", "mr-auto", 3, "click"], ["id", "btnCancel", "name", "btnCancel", "type", "button", "data-dismiss", "modal", 1, "btn", "btn-outline-primary", "float-right", 3, "click"], [1, "h5"], [1, "checkbox-error-note"]], template: function DirectDebitPaymentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "bento-alert", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function DirectDebitPaymentComponent_Template_button_click_1_listener() { return ctx.activeModal.close(); });
        ɵngcc0.ɵɵelement(2, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "div")(7, "label", 6);
        ɵngcc0.ɵɵtext(8, " Amount of Payment ");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(9, "div", 7)(10, "div", 8)(11, "div", 9);
        ɵngcc0.ɵɵelement(12, "input", 10);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(13, "div", 7)(14, "div", 8)(15, "label", 6);
        ɵngcc0.ɵɵtext(16, " Date of Payment ");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(17, "div", 5)(18, "div", 8)(19, "div", 4)(20, "div", 11)(21, "input", 12, 13);
        ɵngcc0.ɵɵlistener("ngModelChange", function DirectDebitPaymentComponent_Template_input_ngModelChange_21_listener($event) { return ctx.rawPaymentDate = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(23, "button", 14);
        ɵngcc0.ɵɵelement(24, "i", 15);
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(25, "div", 8)(26, "label", 6);
        ɵngcc0.ɵɵtext(27, " (Please select banking days only) ");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(28, "div", 7)(29, "div", 8)(30, "label", 6);
        ɵngcc0.ɵɵtext(31, " Account Sequence Number ");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(32, "div", 5)(33, "div", 8)(34, "div", 9)(35, "input", 16);
        ɵngcc0.ɵɵlistener("keypress", function DirectDebitPaymentComponent_Template_input_keypress_35_listener($event) { return ctx.keyPressNumbers($event); });
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(36, "div", 17)(37, "div", 18)(38, "label", 6);
        ɵngcc0.ɵɵtext(39, " Bank Account Details as per EFT Details ");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(40, "div", 7)(41, "div", 19)(42, "bento-checkbox", 20);
        ɵngcc0.ɵɵlistener("ngModelChange", function DirectDebitPaymentComponent_Template_bento_checkbox_ngModelChange_42_listener($event) { return ctx.isVerified = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(43, "label", 21);
        ɵngcc0.ɵɵtext(44, "All details verified and authorised by client");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(45, "div");
        ɵngcc0.ɵɵtemplate(46, DirectDebitPaymentComponent_small_46_Template, 2, 0, "small", 22);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(47, "div");
        ɵngcc0.ɵɵtemplate(48, DirectDebitPaymentComponent_small_48_Template, 2, 0, "small", 22);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(49, "div", 23)(50, "div", 24)(51, "button", 25);
        ɵngcc0.ɵɵlistener("click", function DirectDebitPaymentComponent_Template_button_click_51_listener() { return ctx.saveDirectDebit(); });
        ɵngcc0.ɵɵtext(52, "Save");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(53, " \u00A0\u00A0\u00A0 ");
        ɵngcc0.ɵɵelementStart(54, "button", 26);
        ɵngcc0.ɵɵlistener("click", function DirectDebitPaymentComponent_Template_button_click_54_listener() { return ctx.activeModal.close(); });
        ɵngcc0.ɵɵtext(55, "Cancel");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(56, "div", 18)(57, "h2", 27);
        ɵngcc0.ɵɵtext(58, "General Interest Charge will continue to accruse on overdue amount on daily basis until the debt is paid in full.");
        ɵngcc0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(22);
        ɵngcc0.ɵɵproperty("items", ctx.alerts);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx.isShowLoader);
        ɵngcc0.ɵɵadvance(18);
        ɵngcc0.ɵɵproperty("autoClose", false)("ngModel", ctx.rawPaymentDate)("markDisabled", ctx.markDisabledCallback)("bentoDatepickerConfig", ctx.dateConfig);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("bentoDatepickerToggle", _r0);
        ɵngcc0.ɵɵadvance(19);
        ɵngcc0.ɵɵproperty("ngModel", ctx.isVerified);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showVerifiedNote);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.dateIsInvalid);
    } }, directives: [ɵngcc4.BentoAlertComponent, ɵngcc4.BentoFocusMonitorDirective, ɵngcc4.BentoBusyLoaderDirective, ɵngcc3.NgbInputDatepicker, ɵngcc6.DefaultValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc4.BentoDatepickerConfigDirective, ɵngcc4.BentoDatepickerToggleDirective, ɵngcc4.BentoCheckboxComponent, ɵngcc1.NgIf], styles: [".text-bold[_ngcontent-%COMP%]{font-weight:700}.directdebit-details-alerts[_ngcontent-%COMP%]   .alert-container[_ngcontent-%COMP%]{top:auto!important;bottom:0!important}.checkbox-error-note[_ngcontent-%COMP%]{color:#f05056;font-size:12px;font-weight:700;font-family:BentoRegular,arial,helvetica,sans-serif;padding-left:20px}.checkbox-label[_ngcontent-%COMP%]{margin-bottom:0}.field-divs[_ngcontent-%COMP%]{padding-top:10px}.field-divs-2[_ngcontent-%COMP%]{padding-top:15px}[_nghost-%COMP%]     .modal-body{margin:25px 0!important}[_nghost-%COMP%]     .ngb-dp-day.hidden{display:block!important}[_nghost-%COMP%]     .calendarIcon{font-size:24px!important}[_nghost-%COMP%]     small.text-bold{font-weight:700!important}"] });
DirectDebitPaymentComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: NgbCalendar },
    { type: DirectDebitDateService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DirectDebitPaymentComponent, [{
        type: Component,
        args: [{
                selector: 'autax-direct-debit-payment',
                template: "<bento-alert class=\"directdebit-details-alerts\" [items]=\"alerts\"></bento-alert>\r\n<button id=\"btnClose\" name=\"btnClose\" type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.close()\">\r\n    <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\r\n</button>\r\n<div class=\"modal-body\" [bentoBusyLoader]=\"isShowLoader\">\r\n    <div class=\"form-group\">\r\n        <div class=\"row\">\r\n            <div>\r\n                <label class=\"bento-label\">\r\n                    Amount of Payment\r\n                </label>\r\n            </div>\r\n        </div>\r\n        <div class=\"row field-divs\">\r\n            <div class=\"col-md-6\">\r\n                <div class=\"source-url-el input-group input-group-unstyled\">\r\n                    <input class=\"form-control\" name=\"amount\">\r\n                </div>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row field-divs\">\r\n            <div class=\"col-md-6\">\r\n                <label class=\"bento-label\">\r\n                    Date of Payment\r\n                </label>\r\n            </div>\r\n        </div>\r\n        <div class=\"row\">\r\n            <div class=\"col-md-6\">\r\n                <div class=\"form-group\">\r\n                    <div class=\"input-group\">\r\n                        <input id=\"datepicker-dropdown-input\" class=\"form-control bento-datepicker\" name=\"dp\" placeholder=\"mm/dd/yyyy\" ngbDatepicker #d=\"ngbDatepicker\" [autoClose]=\"false\" [(ngModel)]=\"rawPaymentDate\" [markDisabled]=\"markDisabledCallback\" [bentoDatepickerConfig]=\"dateConfig\"/>\r\n                        <button class=\"btn btn-outline-primary btn-icon ml-2\" [bentoDatepickerToggle]=\"d\" type=\"button\"\r\n                            aria-haspopup=\"true\" aria-label=\"Open calendar\" title=\"Open calendar\">\r\n                            <i class=\"bento-icon-calendar calendarIcon\" aria-hidden=\"true\"></i>\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-md-6\">\r\n                <label class=\"bento-label\">\r\n                    (Please select banking days only)\r\n                </label>\r\n            </div>\r\n        </div>\r\n\r\n        <div class=\"row field-divs\">\r\n          <div class=\"col-md-6\">\r\n              <label class=\"bento-label\">\r\n                  Account Sequence Number\r\n              </label>\r\n          </div>\r\n      </div>\r\n      <div class=\"row\">\r\n          <div class=\"col-md-6\">\r\n              <div class=\"source-url-el input-group input-group-unstyled\">\r\n                  <input class=\"form-control\" id=\"asn\" name=\"asn\" maxlength=\"5\" (keypress)=\"keyPressNumbers($event)\">\r\n              </div>\r\n          </div>\r\n      </div>\r\n        <div class=\"row field-divs-2\">\r\n            <div class=\"col-md-12\">\r\n                <label class=\"bento-label\">\r\n                    Bank Account Details as per EFT Details\r\n                </label>\r\n            </div>\r\n        </div>\r\n        <div class=\"row field-divs\">\r\n            <div class=\"form-group form-check demo-group\">\r\n                <bento-checkbox id=\"my-checkbox\" [(ngModel)]=\"isVerified\"></bento-checkbox>\r\n                <label for=\"my-checkbox\" class=\"checkbox-label\">All details verified and authorised by client</label>\r\n                <div> <small class=\"checkbox-error-note\" *ngIf=\"showVerifiedNote\">This field is required</small> </div>\r\n                <div> <small class=\"checkbox-error-note\" *ngIf=\"dateIsInvalid\">Date entered is invalid</small> </div>\r\n            </div>\r\n            <div class=\"col-md-5\">\r\n                <div class=\"float-right\">\r\n                    <button id=\"btnSave\" name=\"btnSave\" type=\"button\"\r\n                        class=\"btn btn-primary mr-auto\" (click)=\"saveDirectDebit()\">Save</button>\r\n                    &nbsp;&nbsp;&nbsp;\r\n                    <button id=\"btnCancel\" name=\"btnCancel\" type=\"button\" class=\"btn btn-outline-primary float-right\"\r\n                        (click)=\"activeModal.close()\" data-dismiss=\"modal\">Cancel</button>\r\n                </div>\r\n            </div>\r\n            <div class=\"col-md-12\">\r\n                <h2 class=\"h5\">General Interest Charge will continue to accruse on overdue amount on daily basis until\r\n                    the debt is paid in full.</h2>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<!-- <div class=\"ng-bento\">\r\n    <autax-alert></autax-alert>\r\n</div> -->\r\n",
                providers: [
                    { provide: NgbDateParserFormatter, useClass: DPDateCustomFormatter }
                ],
                styles: [".text-bold{font-weight:700}.directdebit-details-alerts .alert-container{top:auto!important;bottom:0!important}.checkbox-error-note{color:#f05056;font-size:12px;font-weight:700;font-family:BentoRegular,arial,helvetica,sans-serif;padding-left:20px}.checkbox-label{margin-bottom:0}.field-divs{padding-top:10px}.field-divs-2{padding-top:15px}:host ::ng-deep .modal-body{margin:25px 0!important}:host ::ng-deep .ngb-dp-day.hidden{display:block!important}:host ::ng-deep .calendarIcon{font-size:24px!important}:host ::ng-deep small.text-bold{font-weight:700!important}"]
            }]
    }], function () { return [{ type: ɵngcc3.NgbActiveModal }, { type: ɵngcc3.NgbCalendar }, { type: DirectDebitDateService }]; }, null); })();

class DirectDebitCancelPaymentComponent {
    constructor(activeModal, debitDateService) {
        this.activeModal = activeModal;
        this.debitDateService = debitDateService;
        this.alerts = [];
        this.blockedDates = [];
        this.isShowLoader = false;
    }
    ngOnInit() {
        this.isShowLoader = true;
        this.debitDateService.getHolidaysForDatePicking().subscribe((holidays) => {
            this.debitDateService.holidays = holidays;
            this.setDatePickerBlockedDates(3, 90, holidays);
            this.isShowLoader = false;
        });
    }
    /**
     * Set the range and dates to block on date picke
     * @param  {} startPadding days to add to get the allowable startdate
     * @param  {} range days to add to get the range of dates allowed to be picked
     * @param  {} holidaysObject list of holidays to be blocked on the date picker
     * @returns void
     */
    setDatePickerBlockedDates(startPadding, range, holidaysObject) {
        this.startRange = this.addDaysToDate(startPadding);
        this.endRange = this.addDaysToEndDate(range);
        let daysToAddOnRange = 0;
        //from the holidays, get the blocked dates
        holidaysObject.forEach(holidayObject => {
            holidayObject.holidays.forEach(holiday => {
                if (!this.debitDateService.dateCheck(this.startRange, this.endRange, holiday.date) === true) {
                    console.log(holiday);
                    this.blockedDates.push(holiday);
                    daysToAddOnRange += 1;
                }
            });
        });
        this.startRange = this.addDaysToDate(startPadding + (daysToAddOnRange - 1));
        this.endRange = this.addDaysToEndDate(range);
    }
    /**
     * Add days to a current date while removing weekends and get a new date
     * @param  {} daysToAdd
     * @param  {} baseDate
     * @returns string
     */
    addDaysToDate(daysToAdd, baseDate = null) {
        var startDate = new Date().toDateString();
        if (baseDate != null) {
            startDate = baseDate.toDateString();
        }
        var newStart = new Date(startDate.replace(/-/g, "/"));
        var count = 0;
        while (count < daysToAdd) {
            var newEndDate = new Date(newStart.setDate(newStart.getDate() + 1));
            var isNotWeekend = newEndDate.getDay() != 0 && newEndDate.getDay() != 6;
            var isHoliday = this.debitDateService.checkIfDateIsHoliday(newEndDate, this.blockedDates);
            if (isNotWeekend && !isHoliday) {
                //Date.getDay() gives weekday starting from 0(Sunday) to 6(Saturday)
                count++;
            }
        }
        return newEndDate;
    }
    /**
     * Add days to a current date while removing weekends and get a new date
     * @param  {} daysToAdd
     * @param  {} baseDate
     * @returns string
     */
    addDaysToEndDate(daysToAdd, baseDate = null) {
        var startDate = new Date().toDateString();
        if (baseDate != null) {
            startDate = baseDate.toDateString();
        }
        var newStart = new Date(startDate.replace(/-/g, "/"));
        return new Date(newStart.setDate(newStart.getDate() + daysToAdd));
    }
    /**
     * Check if the date entered is allowed to be cancelled
     * @param  {} paymentDate
     */
    CheckANDCancelPayment(paymentDate) {
        console.log(this.startRange);
        console.log(" Payment Date 01/06/2021 " + this.checkCancelllationDateAllowed("01/06/2021"));
        console.log(" Payment Date 01/07/2021 " + this.checkCancelllationDateAllowed("01/07/2021"));
        console.log(" Payment Date 01/08/2021 " + this.checkCancelllationDateAllowed("01/08/2021"));
        console.log(" Payment Date 01/09/2021 " + this.checkCancelllationDateAllowed("01/09/2021"));
        console.log(" Payment Date 01/10/2021 " + this.checkCancelllationDateAllowed("01/10/2021"));
        if (!this.checkCancelllationDateAllowed("01/06/2021")) {
            this.alertMessage("Cancellation cannot be made less than 3 business days before the payment date.", AlertType.warning);
            return false;
        }
    }
    /**
     * Check if the date entered is in range
     * @param  {} date
     */
    checkCancelllationDateAllowed(date) {
        if (new Date(date) >= this.startRange) {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * Display alert message
     * @param  {string} message
     * @param  {string} type?
     */
    alertMessage(message, type) {
        this.alerts.push({
            type,
            msg: message,
            closeable: true,
        });
    }
}
DirectDebitCancelPaymentComponent.ɵfac = function DirectDebitCancelPaymentComponent_Factory(t) { return new (t || DirectDebitCancelPaymentComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(DirectDebitDateService)); };
DirectDebitCancelPaymentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DirectDebitCancelPaymentComponent, selectors: [["autax-direct-debit-cancel-payment"]], decls: 53, vars: 2, consts: [[1, "directdebit-details-alerts", 3, "items"], ["id", "btnClose", "name", "btnClose", "type", "button", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true", 1, "bento-icon-close-x"], [1, "modal-header"], [1, "modal-body", 3, "bentoBusyLoader"], [1, "form-group"], [1, "row"], [1, "col-md-12"], [1, "table", "table-bordered"], [1, "btn", "btn-primary", "btn-sm", 3, "click"], [1, "btn", "btn-primary", "btn-sm"], [1, "text-bold"]], template: function DirectDebitCancelPaymentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "bento-alert", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function DirectDebitCancelPaymentComponent_Template_button_click_1_listener() { return ctx.activeModal.close(); });
        ɵngcc0.ɵɵelement(2, "i", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "h4", 3);
        ɵngcc0.ɵɵtext(4, " Direct Debit Payment Details");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4)(6, "div", 5)(7, "div", 6)(8, "div", 7);
        ɵngcc0.ɵɵtext(9, "\u00A0");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(10, "div", 6)(11, "div", 7)(12, "table", 8)(13, "tr");
        ɵngcc0.ɵɵelement(14, "td");
        ɵngcc0.ɵɵelementStart(15, "td");
        ɵngcc0.ɵɵtext(16, "Payment Amount");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "td");
        ɵngcc0.ɵɵtext(18, "Account Sequence Number");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "td");
        ɵngcc0.ɵɵtext(20, "Payment Date");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(21, "td");
        ɵngcc0.ɵɵtext(22, "Payment Status");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(23, "tr")(24, "td");
        ɵngcc0.ɵɵtext(25, "1");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(26, "td")(27, "td");
        ɵngcc0.ɵɵelementStart(28, "td");
        ɵngcc0.ɵɵtext(29, "14/11/2020");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(30, "td")(31, "button", 9);
        ɵngcc0.ɵɵlistener("click", function DirectDebitCancelPaymentComponent_Template_button_click_31_listener() { return ctx.CheckANDCancelPayment("14/11/2020"); });
        ɵngcc0.ɵɵtext(32, "CANCEL");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(33, "tr")(34, "td");
        ɵngcc0.ɵɵtext(35, "1");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(36, "td")(37, "td");
        ɵngcc0.ɵɵelementStart(38, "td");
        ɵngcc0.ɵɵtext(39, "12/11/2020");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(40, "td")(41, "button", 10);
        ɵngcc0.ɵɵtext(42, "CANCEL");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(43, "tr")(44, "td");
        ɵngcc0.ɵɵtext(45, "1");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(46, "td")(47, "td");
        ɵngcc0.ɵɵelementStart(48, "td");
        ɵngcc0.ɵɵtext(49, "2/11/2020");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(50, "td")(51, "small", 11);
        ɵngcc0.ɵɵtext(52, "Submitted");
        ɵngcc0.ɵɵelementEnd()()()()()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("items", ctx.alerts);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx.isShowLoader);
    } }, directives: [ɵngcc4.BentoAlertComponent, ɵngcc4.BentoFocusMonitorDirective, ɵngcc4.BentoBusyLoaderDirective], styles: ["[_nghost-%COMP%]     .text-bold{font-weight:700!important}"] });
DirectDebitCancelPaymentComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: DirectDebitDateService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DirectDebitCancelPaymentComponent, [{
        type: Component,
        args: [{
                selector: 'autax-direct-debit-cancel-payment',
                template: "<bento-alert class=\"directdebit-details-alerts\" [items]=\"alerts\"></bento-alert>\r\n<button id=\"btnClose\" name=\"btnClose\" type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.close()\">\r\n    <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\r\n</button>\r\n<h4 class=\"modal-header\"> Direct Debit Payment Details</h4>\r\n<div class=\"modal-body\" [bentoBusyLoader]=\"isShowLoader\">\r\n    <div class=\"form-group\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\">&nbsp;</div>\r\n        </div>\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n                <table class=\"table table-bordered\">\r\n                    <tr>\r\n                        <td></td>\r\n                        <td>Payment Amount</td>\r\n                        <td>Account Sequence Number</td>\r\n                        <td>Payment Date</td>\r\n                        <td>Payment Status</td>\r\n                    </tr>\r\n                    <tr>\r\n                        <td>1</td>\r\n                        <td></td>\r\n                        <td></td>\r\n                        <td>14/11/2020</td>\r\n                        <td><button class=\"btn btn-primary btn-sm\" (click)=\"CheckANDCancelPayment('14/11/2020')\">CANCEL</button></td>\r\n                    </tr>\r\n                    <tr>\r\n                        <td>1</td>\r\n                        <td></td>\r\n                        <td></td>\r\n                        <td>12/11/2020</td>\r\n                        <td><button class=\"btn btn-primary btn-sm\">CANCEL</button></td>\r\n                    </tr>\r\n                    <tr>\r\n                        <td>1</td>\r\n                        <td></td>\r\n                        <td></td>\r\n                        <td>2/11/2020</td>\r\n                        <td><small class=\"text-bold\">Submitted</small></td>\r\n                    </tr>\r\n                </table>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>",
                styles: [":host ::ng-deep .text-bold{font-weight:700!important}"]
            }]
    }], function () { return [{ type: ɵngcc3.NgbActiveModal }, { type: DirectDebitDateService }]; }, null); })();

// System imports
class AtoClientFinanceDetailsComponent {
    constructor(autaxService, alertService, atoIntegrationService, modalService, helperService, sessionService, coreService) {
        this.autaxService = autaxService;
        this.alertService = alertService;
        this.atoIntegrationService = atoIntegrationService;
        this.modalService = modalService;
        this.helperService = helperService;
        this.sessionService = sessionService;
        this.coreService = coreService;
        this.numericRegex = /^[0-9]$/;
        this.alphaRegex = /^[a-zA-Z ]+$/;
        this.clientDetail = new ClientDetail();
        this.relationshipModel = new RelationshipStatus();
        this.agentClientRelationshipStatus = false;
        this.hasPermission = has;
        this.getCompanyId = getCompanyId;
        this.featureToggleGranted = false;
        this.isImportFromAtoButtonBusy = false;
        this.isDisabledRetrieveFromAtoButton = false;
        this.isImportButtonBusy = false;
        this.isDisabledCancelButton = false;
        this.isDisabledCancelIcon = false;
        this.isEFTSDetailsAll = true;
        // Error Display
        this.error = { isError: false, errorMessage: '' };
        this.cmbDeceasedTaxPayerOptions = {
            searchable: true,
        };
        this.cmbTaxPurposesOptions = {
            searchable: true,
        };
        this.cmbPriorTaxYearOptions = {
            searchable: true,
        };
        this.alerts = [];
        /**
         * This function checks whether Bank Account Details (EFT) details are already entered, if not it should make the note turn red
         * @returns void
         */
        this.checkEFTRSDetails = () => {
            if (this.financeDetails.accountName === undefined || this.financeDetails.accountNumber === undefined || this.financeDetails.bsbNumber === undefined) {
                return false;
            }
            else {
                if (this.financeDetails.accountName.length == 0 || this.financeDetails.accountNumber.length == 0 || this.financeDetails.bsbNumber.length == 0) {
                    return false;
                }
                else {
                    return true;
                }
            }
        };
        this.financeDetails = new ClientFinance();
        this.clientOtherDetails = new ClientOtherDetails();
        this.modalOptions = {
            container: AutaxStaffConstants.nucleusStaffModalContainer
        };
    }
    ngOnInit() {
        this.getCompanyId().then((companyId) => {
            this.coreService.getClientWithExpansionById(companyId, this.clientid)
                .subscribe(clientWithExpansionResponse => {
                this.clientdata = clientWithExpansionResponse;
            });
        }).catch((error) => {
            console.warn('company id promise failed: ', error);
            this.alertService.show(AlertType.danger, AutaxStaffConstants.genericToasterErrorMessage, undefined, 'companyid_promise_error');
        });
        this.residentTaxPurposesData = new BehaviorSubject([AutaxStaffConstants.comboOptions.Yes, AutaxStaffConstants.comboOptions.No]);
        this.selectedTaxPurposes = AutaxStaffConstants.comboOptions.Yes;
        this.getClientFinanceDetails();
        this.getClientOtherDetails();
        this.sessionService.getCurrentFirmLicenseDevelopmentPermissionByLicence('AUTax.ATOTaxMigrationV1').then(result => {
            this.featureToggleGranted = result;
        });
        this.priortaxYearData = new BehaviorSubject([AutaxStaffConstants.combPriorTaxYearOptions.taxYear2019, AutaxStaffConstants.combPriorTaxYearOptions.taxYear2020, AutaxStaffConstants.combPriorTaxYearOptions.atoAllYear]);
        this.sessionService.getCurrentFirmLicenseDevelopmentPermissionByLicence('AUTax.DirectDebit').then(result => {
            this.featureToggleDirectDebitGranted = result;
        });
    }
    /**
     * Unbscription before the component is destroyed
     * @returns void
     */
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    // get client finance details by client id and its type
    getClientFinanceDetails() {
        this.autaxService.getOnvioClientFinanceDetailsById(this.clientid, OnvioClientUpdateType.cufi).subscribe(response => {
            this.financeDetails = response;
        }, (error) => {
            this.errorHandling(error, 'get_finance_error');
        });
    }
    // get client other details by client id and its type
    getClientOtherDetails() {
        this.autaxService.getOnvioClientOtherDetailsById(this.clientid, OnvioClientUpdateType.cudtl).subscribe(response => {
            this.clientOtherDetails = response;
            this.selectedTaxPurposes = response.taxPurposes;
        }, (error) => {
            this.errorHandling(error, 'get_other_details_error');
        });
    }
    // update client finance details and console log will removed once ci working successfully
    updateClientFinanceDetails(financeDetails) {
        this.autaxService.updateClientContactDetails(this.clientid, OnvioClientUpdateType.cufi, financeDetails).subscribe(response => {
            console.log(response);
        }, (error) => {
            this.errorHandling(error, 'update_finance_error');
        });
    }
    // update client other details and console log will removed once ci working successfully
    updateClientOtherDetails(clientOtherDetails) {
        this.setFinanceDetails(clientOtherDetails);
        this.autaxService.updateClientContactDetails(this.clientid, OnvioClientUpdateType.cudtl, clientOtherDetails).subscribe(response => {
            console.log(response);
        }, (error) => {
            this.errorHandling(error, 'update_other_details_error');
        });
    }
    // set client other details as per selected tax payer and tax purposes
    setFinanceDetails(clientOtherDetails) {
        clientOtherDetails.taxPurposes = this.selectedTaxPurposes;
        return clientOtherDetails;
    }
    // on combo change update client other details
    onComboChange() {
        if ((this.clientOtherDetails.taxPurposes !== this.selectedTaxPurposes)) {
            this.updateClientOtherDetails(this.clientOtherDetails);
        }
        else {
            noop();
        }
    }
    // common error function for show toaster message.
    errorHandling(error, alertId) {
        if (error && error.error && error.error.error && error.error.error.code && error.error.error.code === 404) {
            // 404 error or some unexpected error not show in front-end side.
            console.log(error, alertId);
        }
        else {
            this.alertService.show(AlertType.danger, 'Something went wrong. Please try again. If the issue persists, please contact support.', undefined, alertId);
            console.log(error, alertId);
        }
    }
    /**
     * It restricts the user to not add the value of BSBNumber & AccountNumber in format numeric value only
     * @param event occurs when user give's the input
     */
    validateNumericValue(event) {
        if (!this.numericRegex.test(event.key)) {
            event.preventDefault();
        }
    }
    /**
     * It restricts the user to enter details in format alpha values only
     * @param event occurs when user give's the input
     */
    validateAccountName(event) {
        if (!this.alphaRegex.test(event.key)) {
            event.preventDefault();
        }
    }
    /**
     * Get agent client relationship status
     */
    getAgentClientRelationshipStatus(content) {
        this.atoIntegrationService.getClientRelationship(this.clientid).subscribe((data) => {
            this.relationshipModel.messageStatus = data.messageStatus;
            this.relationshipModel.relationshipStatus = data.toggleStatus === 'true' ? true : false;
            if (this.relationshipModel.relationshipStatus) {
                this.fillClientDetails();
                this.open(content);
            }
            else {
                this.alertService.show(AlertType.danger, AutaxStaffConstants.toggleStatusToasterErrorMessage, undefined, 'ato_remove_error');
            }
            this.enableAllButtonsWhileNotBusy();
        }, (error) => {
            if (error instanceof HttpErrorResponse) {
                switch (error.status) {
                    case 404:
                        this.alertService.show(AlertType.danger, AutaxStaffConstants.toggleStatusToasterErrorMessage, undefined, 'onvio_data_notfound');
                        break;
                    default:
                        this.alertService.show(AlertType.danger, AutaxStaffConstants.genericToasterErrorMessage, undefined, 'onvio_data_notfound');
                }
            }
            else {
                this.alertService.show(AlertType.danger, AutaxStaffConstants.genericToasterErrorMessage, undefined, 'onvio_data_notfound');
            }
            this.enableAllButtonsWhileNotBusy();
        });
    }
    /**
     * Import project details from ATO
     */
    importFromAto(content) {
        this.disableAllButtonsWhileBusy();
        this.getAgentClientRelationshipStatus(content);
    }
    /**
     * Open the Model Window for Prior TaxReturn.
     */
    open(content) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then(result => {
            this.closeResult = `Closed with: ${result}`;
        }, reason => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
    /**
     * Import from ATO.
     */
    importButtonClicked() {
        this.disableAllButtonsWhileBusy();
        const atoOnvioMigrationData = new AtoOnvioMigrationV1$1();
        atoOnvioMigrationData.clientid = this.clientDetail.clientId;
        atoOnvioMigrationData.taxYear = this.selectedPriorTaxYear;
        atoOnvioMigrationData.tfn = this.clientDetail.clientTfn;
        this.subscription = this.atoIntegrationService.startAtoClientMigration(this.clientDetail.clientId, atoOnvioMigrationData)
            .subscribe((response) => {
            if (response.status === HttpStatusCodes.accepted) {
                this.alertService.show(AlertType.info, 'You will receive an Onvio notification when the migration is complete.');
            }
            else {
                this.alertService.show(AlertType.danger, AutaxStaffConstants.genericToasterErrorMessage);
            }
        }, (error) => {
            this.alertService.show(AlertType.danger, AutaxStaffConstants.genericToasterErrorMessage);
        }).add(() => {
            this.enableAllButtonsWhileNotBusy();
            this.modalService.dismissAll();
        });
    }
    getDismissReason(reason) {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        }
        else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        }
        else {
            return `with: ${reason}`;
        }
    }
    fillClientDetails() {
        if (this.clientdata) {
            this.clientDetail = new ClientDetail();
            this.clientDetail.clientId = this.clientid;
            const tfn = this.clientdata.primaryContactExpanded.nationalIdentitiesExpanded.filter(x => {
                return x.kind.id === AutaxStaffConstants.nationalIdentitiesExpanded.auTFN;
            });
            this.clientDetail.clientTfn = tfn[0].identity;
            this.clientDetail.intermediarySignatureIndicator = true; // Default it to "True" while creating the instance
            this.clientDetail.clientName = this.clientdata.name;
            this.clientDetail.clientType = this.clientdata.primaryContactExpanded.entityType.name;
            this.clientDetail.individualDateOfBirth = this.clientdata.primaryContactExpanded.dateOfBirth;
            this.helperService.setClientDetail(this.clientDetail);
        }
    }
    /**
     *  This method will return true if the client enitity type is INDIVIDUAL.
     * @returns boolean
     */
    isAuIndividual() {
        if (this.clientdata) {
            return this.clientdata.primaryContactExpanded.entityType.id === AutaxStaffConstants.entityType.auIndividual;
        }
        ;
        return false;
    }
    /**
     * It will enable the busy loader and disable all other buttons.
     * @returns void
     */
    disableAllButtonsWhileBusy() {
        this.isImportFromAtoButtonBusy = true;
        this.isDisabledRetrieveFromAtoButton = true;
        this.isImportButtonBusy = true;
        this.isDisabledCancelIcon = true;
        this.isDisabledCancelButton = true;
    }
    /**
     * It will disable the busy loader and enable all other buttons.
     * @returns void
     */
    enableAllButtonsWhileNotBusy() {
        this.isImportFromAtoButtonBusy = false;
        this.isDisabledRetrieveFromAtoButton = false;
        this.isImportButtonBusy = false;
        this.isDisabledCancelButton = false;
        this.isDisabledCancelIcon = false;
    }
    /**
     * open the modal window when the request successfully passes the validation
     */
    openDirectDebitDetails() {
        this.isEFTSDetailsAll = this.checkEFTRSDetails();
        if (this.isEFTSDetailsAll) {
            this.modalService.open(DirectDebitPaymentComponent, this.modalOptions).result.then((result) => {
            }).catch(() => {
                this.alertService.show(AlertType.warning, 'An error was encountered. Please refresh the page. If problem persists, please contact <a rel="noopener" target="_blank" href="https://taxtraining.thomsonreuters.com.au/products/onvio/contact-us">Onvio Support</a>.', undefined, "directdebit_modal_error");
            });
        }
    }
    /**
    * open the modal window when the cancel request successfully passes the validation
    */
    openDirectDebitCancelDetails() {
        this.modalService.open(DirectDebitCancelPaymentComponent, this.modalOptions).result.then((result) => {
        }).catch(() => {
            this.alertService.show(AlertType.warning, 'An error was encountered. Please refresh the page. If problem persists, please contact <a rel="noopener" target="_blank" href="https://taxtraining.thomsonreuters.com.au/products/onvio/contact-us">Onvio Support</a>.', undefined, "directdebit_modal_error");
        });
    }
}
AtoClientFinanceDetailsComponent.ɵfac = function AtoClientFinanceDetailsComponent_Factory(t) { return new (t || AtoClientFinanceDetailsComponent)(ɵngcc0.ɵɵdirectiveInject(AUTaxService), ɵngcc0.ɵɵdirectiveInject(AlertService), ɵngcc0.ɵɵdirectiveInject(AtoIntegrationService), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbModal), ɵngcc0.ɵɵdirectiveInject(HelperService), ɵngcc0.ɵɵdirectiveInject(SessionService), ɵngcc0.ɵɵdirectiveInject(CoreService)); };
AtoClientFinanceDetailsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AtoClientFinanceDetailsComponent, selectors: [["autax-ato-client-finance-details"]], inputs: { clientid: "clientid" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
        ])], decls: 45, vars: 9, consts: [["bfmForm", "", "name", "clientFinanceValidation"], [1, "row"], [1, "col-md-8", "col-sm-8", "col-xs-8"], [1, "no-top-margin"], [1, "row", "section-container", "ng-bento"], [1, "col-md-4"], [1, "form-group", "padding-format"], [1, "bento-label"], [1, "row", "mb-3"], [1, "source-url-el", "input-group", "input-group-unstyled"], ["maxlength", "6", "bfmField", "BSB Number", "name", "bsbNumber", 1, "form-control", "bsb", 3, "ngModel", "keypress", "ngModelChange", "change"], ["maxlength", "12", "bfmField", "Account Number", "name", "accountNumber", 1, "form-control", "bsb", 3, "ngModel", "keypress", "ngModelChange", "change"], ["bfmField", "Account Name", "name", "accountName", "maxlength", "32", 1, "form-control", "bsb", 3, "ngModel", "keypress", "ngModelChange", "change"], [1, "row", "mb-3", "ng-bento"], [1, "source-url-el", "input-group", "input-group-unstyled", "ng-bento"], ["id", "cmbTaxPurposes", "name", "cmbTaxPurposes", 3, "ngModel", "options", "itemsObservable", "ngModelChange", "openChange"], ["class", "row", 4, "ngIf"], ["class", "form-group padding-format", 4, "ngIf"], [1, "col-md-12"], ["content", ""], [1, "ng-bento"], ["type", "button", 1, "btn", "btn-primary", "mr-auto", 3, "disabled", "bentoBusyLoader", "click"], [1, "col-md-12", "col-sm-12", "col-xs-12"], [1, "padding-format"], [1, "no-top-margin", "inline-display"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], [1, "pl-187"], ["id", "EFTS-add-note", 3, "ngClass"], ["type", "button", "aria-label", "Close", 1, "close", 3, "disabled", "click"], ["aria-hidden", "true", 1, "bento-icon-close-x"], ["id", "modal-scrollable-title", 1, "modal-header", "h2"], [1, "modal-body", 2, "text-align", "center"], [1, "col-md-4", "col-sm-4", "col-xs-4", "text-right"], [1, "col-md-8", "col-sm-8", "col-xs-8", "text-left"], [1, "col-md-4", "col-sm-4", "col-xs-4", "text-left", "source-url-el", "input-group", "input-group-unstyled", "ng-bento"], ["id", "cmbPriorTaxYear", "name", "cmbPriorTaxYear", 3, "options", "ngModel", "itemsObservable", "ngModelChange"], [1, "modal-footer"], [1, "col-xs-9", "col-md-9", "col-sm-9"], [1, "col-xs-3", "col-md-3", "col-sm-3"], ["type", "button", 1, "btn", "btn-outline-primary", "float-right", 3, "disabled", "click"]], template: function AtoClientFinanceDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "form", 0)(1, "div", 1)(2, "div", 2)(3, "h3", 3);
        ɵngcc0.ɵɵtext(4, " Electronic Fund Transfer(EFT) Details");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(5, "div", 4)(6, "div", 5)(7, "div", 6)(8, "div", 1)(9, "label", 7);
        ɵngcc0.ɵɵtext(10, " BSB ");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(11, "div", 8)(12, "div", 9)(13, "input", 10);
        ɵngcc0.ɵɵlistener("keypress", function AtoClientFinanceDetailsComponent_Template_input_keypress_13_listener($event) { return ctx.validateNumericValue($event); })("ngModelChange", function AtoClientFinanceDetailsComponent_Template_input_ngModelChange_13_listener($event) { return ctx.financeDetails.bsbNumber = $event; })("change", function AtoClientFinanceDetailsComponent_Template_input_change_13_listener() { return ctx.updateClientFinanceDetails(ctx.financeDetails); });
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(14, "div", 1)(15, "label", 7);
        ɵngcc0.ɵɵtext(16, " Account Number ");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(17, "div", 8)(18, "div", 9)(19, "input", 11);
        ɵngcc0.ɵɵlistener("keypress", function AtoClientFinanceDetailsComponent_Template_input_keypress_19_listener($event) { return ctx.validateNumericValue($event); })("ngModelChange", function AtoClientFinanceDetailsComponent_Template_input_ngModelChange_19_listener($event) { return ctx.financeDetails.accountNumber = $event; })("change", function AtoClientFinanceDetailsComponent_Template_input_change_19_listener() { return ctx.updateClientFinanceDetails(ctx.financeDetails); });
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(20, "div", 1)(21, "label", 7);
        ɵngcc0.ɵɵtext(22, " Account Name ");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(23, "div", 8)(24, "div", 9)(25, "input", 12);
        ɵngcc0.ɵɵlistener("keypress", function AtoClientFinanceDetailsComponent_Template_input_keypress_25_listener($event) { return ctx.validateAccountName($event); })("ngModelChange", function AtoClientFinanceDetailsComponent_Template_input_ngModelChange_25_listener($event) { return ctx.financeDetails.accountName = $event; })("change", function AtoClientFinanceDetailsComponent_Template_input_change_25_listener() { return ctx.updateClientFinanceDetails(ctx.financeDetails); });
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(26, "div", 1)(27, "div", 2)(28, "h3");
        ɵngcc0.ɵɵtext(29, "Other Details");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(30, "div", 6)(31, "div", 1)(32, "label", 7);
        ɵngcc0.ɵɵtext(33, " Resident for Tax Purposes ");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(34, "div", 13)(35, "div", 14)(36, "bento-combobox", 15);
        ɵngcc0.ɵɵlistener("ngModelChange", function AtoClientFinanceDetailsComponent_Template_bento_combobox_ngModelChange_36_listener($event) { return ctx.selectedTaxPurposes = $event; })("openChange", function AtoClientFinanceDetailsComponent_Template_bento_combobox_openChange_36_listener() { return ctx.onComboChange(); });
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵtemplate(37, AtoClientFinanceDetailsComponent_div_37_Template, 4, 0, "div", 16);
        ɵngcc0.ɵɵtemplate(38, AtoClientFinanceDetailsComponent_div_38_Template, 6, 2, "div", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(39, "div", 18);
        ɵngcc0.ɵɵtemplate(40, AtoClientFinanceDetailsComponent_div_40_Template, 16, 3, "div", 16);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵtemplate(41, AtoClientFinanceDetailsComponent_ng_template_41_Template, 45, 13, "ng-template", null, 19, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(43, "div", 20);
        ɵngcc0.ɵɵelement(44, "autax-alert");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(13);
        ɵngcc0.ɵɵproperty("ngModel", ctx.financeDetails.bsbNumber);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.financeDetails.accountNumber);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngModel", ctx.financeDetails.accountName);
        ɵngcc0.ɵɵadvance(11);
        ɵngcc0.ɵɵproperty("ngModel", ctx.selectedTaxPurposes)("options", ctx.cmbTaxPurposesOptions)("itemsObservable", ctx.residentTaxPurposesData);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.featureToggleGranted && ctx.isAuIndividual());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.featureToggleGranted && ctx.isAuIndividual());
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.featureToggleDirectDebitGranted);
    } }, directives: [ɵngcc6.ɵNgNoValidate, ɵngcc6.NgControlStatusGroup, ɵngcc6.NgForm, ɵngcc6.DefaultValueAccessor, ɵngcc6.MaxLengthValidator, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc4.BentoComboboxComponent, ɵngcc1.NgIf, ɵngcc4.BentoFocusMonitorDirective, ɵngcc4.BentoBusyLoaderDirective, ɵngcc1.NgClass, ɵngcc4.BentoFooterTabHelper, AlertComponent], pipes: [ɵngcc1.DatePipe], styles: [".msgerror[_ngcontent-%COMP%]{display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;position:relative;box-sizing:border-box;color:#dc0a0a;padding-top:5px}.msgerror[_ngcontent-%COMP%]:before{font-family:bento-icomoon;font-weight:400;font-size:15px;color:#dc0a0a;content:\"\\e6f3\";width:20px;text-align:left;display:inline-block;vertical-align:text-bottom}.padding-format[_ngcontent-%COMP%]{padding-left:inherit}[class*=\" bento-icon-\"][_ngcontent-%COMP%], [class^=bento-icon-][_ngcontent-%COMP%]{font-family:bento-icomoon!important}.btn[_ngcontent-%COMP%]   .bento-icon-calendar[_ngcontent-%COMP%]{font-size:24px!important}bento-combobox.bento-select[_ngcontent-%COMP%]{box-sizing:border-box;position:relative;overflow:visible;cursor:auto;width:100%;border-width:0;z-index:auto;display:inline-block}bento-combobox.bento-select[_ngcontent-%COMP%]:not(.readonly)   .form-control[readonly][_ngcontent-%COMP%]:not(:disabled){font-weight:400}bento-combobox.bento-select[_ngcontent-%COMP%]   input.ng-hide-add[_ngcontent-%COMP%]{display:none}bento-combobox.bento-select.open[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border-bottom-left-radius:0;border-bottom-right-radius:0}bento-combobox.bento-select[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]{pointer-events:auto;cursor:default;display:flex;align-items:center;justify-content:center}bento-combobox.bento-select[_ngcontent-%COMP%] > div.input-label.disabled[_ngcontent-%COMP%]{cursor:not-allowed;pointer-events:none}bento-combobox.bento-select[_ngcontent-%COMP%] > .btn.disabled[_ngcontent-%COMP%]{cursor:not-allowed;pointer-events:none;background:0 0}bento-combobox.bento-select[_ngcontent-%COMP%]   input[disabled][_ngcontent-%COMP%]:not(.readonly){font-weight:400;cursor:not-allowed;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none}bento-combobox.bento-select[_ngcontent-%COMP%] > .preloader[_ngcontent-%COMP%]{position:absolute;width:40px;top:0;bottom:0;right:30px;pointer-events:none}bento-combobox.bento-select[_ngcontent-%COMP%] > .preloader[_ngcontent-%COMP%]   .bento-busyloader-blocker[_ngcontent-%COMP%]{background:0 0;z-index:auto}bento-combobox.bento-select.input-sm[_ngcontent-%COMP%]   .bento-combobox-container[_ngcontent-%COMP%]{top:28px}bento-combobox.bento-select.input-sm[_ngcontent-%COMP%] > .btn[_ngcontent-%COMP%]   [class*=bento-icon][_ngcontent-%COMP%]{font-size:.857rem}bento-combobox.bento-select[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{position:absolute;top:9px;right:59px}bento-combobox.bento-select[_ngcontent-%COMP%]   i.preloader[_ngcontent-%COMP%]{width:24px;height:24px;background-size:24px 24px;display:none}bento-combobox.bento-select[_ngcontent-%COMP%]   div.input-label[_ngcontent-%COMP%], bento-combobox.bento-select[_ngcontent-%COMP%]   div.placeholder[_ngcontent-%COMP%]{-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none;cursor:default}bento-combobox.bento-select[_ngcontent-%COMP%]   div.placeholder[_ngcontent-%COMP%]{position:absolute;left:0;top:0}bento-combobox.bento-select[_ngcontent-%COMP%]   div.input-label[_ngcontent-%COMP%], bento-combobox.bento-select[_ngcontent-%COMP%]   div.placeholder[_ngcontent-%COMP%], bento-combobox.bento-select[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]{box-sizing:border-box;width:100%;font-size:1rem}bento-combobox.bento-select[_ngcontent-%COMP%]   div.input-label[_ngcontent-%COMP%]:focus, bento-combobox.bento-select[_ngcontent-%COMP%]   div.placeholder[_ngcontent-%COMP%]:focus, bento-combobox.bento-select[_ngcontent-%COMP%]   input[type=text][_ngcontent-%COMP%]:focus{outline:0}bento-combobox.bento-select[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:hover{box-shadow:none}bento-combobox.bento-select[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]   .bento-combobox-dropdown-button-icon[_ngcontent-%COMP%]{font-size:1rem;top:0}body.touch[_ngcontent-%COMP%], body.touch[_ngcontent-%COMP%]   .bento-combobox-container-body[_ngcontent-%COMP%]{-webkit-overflow-scrolling:touch}.bui-bento-combobox-container[_ngcontent-%COMP%]{display:block;position:absolute;margin-top:-1px;min-width:100%;min-height:0;z-index:10;border-width:1px;border-style:solid;width:auto;overflow:hidden;visibility:hidden;opacity:0;transition:border .3s,opacity .2s}.bui-bento-combobox-container.bento-append-to[_ngcontent-%COMP%], .open[_ngcontent-%COMP%]   .bui-bento-combobox-container[_ngcontent-%COMP%]{visibility:visible;opacity:1}.bui-bento-combobox-container.out[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.dropup[_ngcontent-%COMP%]   .bui-bento-combobox-container[_ngcontent-%COMP%], .up[_ngcontent-%COMP%]   .bui-bento-combobox-container[_ngcontent-%COMP%]{top:auto;margin:0 0 -1px}.bui-bento-combobox-container[_ngcontent-%COMP%]   bento-list[_ngcontent-%COMP%]{margin-bottom:-1px;border:none;position:absolute;width:100%}.bui-bento-combobox-container[_ngcontent-%COMP%]   ol[_ngcontent-%COMP%], .bui-bento-combobox-container[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin:0;padding:0}.bui-bento-combobox-container.dropdown-menu-up[_ngcontent-%COMP%]{margin:0 0 -1px}.bui-bento-combobox-container.bento-append-to[_ngcontent-%COMP%]{margin:0}.bui-bento-combobox-list-wrapper[_ngcontent-%COMP%]{display:table-row}.bui-bento-combobox-container-header[_ngcontent-%COMP%]{font-weight:700;padding-right:0;text-transform:capitalize;list-style:none;white-space:nowrap;display:table-header-group;width:100%}[dir=rtl][_ngcontent-%COMP%]   .bui-bento-combobox-container-header[_ngcontent-%COMP%]{padding-left:0;padding-right:auto}.bui-bento-combobox-container-header-label[_ngcontent-%COMP%]{padding:5px 10px;white-space:nowrap;display:table-cell;border-bottom-width:1px;border-bottom-style:solid}.bui-bento-combobox-container-header-label-filler[_ngcontent-%COMP%]{padding:0}.bui-bento-combobox-container-footer[_ngcontent-%COMP%]{display:block;width:100%;height:35px;border-top-width:solid;border-top-style:1px;position:relative;line-height:normal;font-size:.879rem}.bui-bento-combobox-footer-inner[_ngcontent-%COMP%]{display:table;width:100%;height:35px}.bui-bento-combobox-footer-row[_ngcontent-%COMP%]{display:table-row}.bui-bento-combobox-footer-item[_ngcontent-%COMP%]{display:table-cell;position:relative;vertical-align:middle;text-align:center}.bui-bento-combobox-footer-item[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{padding:0;letter-spacing:0;cursor:pointer}.bui-bento-combobox-footer-item[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:disabled{pointer-events:none}.bui-bento-combobox-footer-item[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:disabled:hover   span[_ngcontent-%COMP%]{text-decoration:none}.bui-bento-combobox-footer-item[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]:first-child, .bui-bento-combobox-footer-item[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]:last-child{margin:0!important;top:0;vertical-align:baseline}.bui-bento-combobox-footer-item[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:hover{text-decoration:none}.bui-bento-combobox-footer-item[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]:hover   span[_ngcontent-%COMP%]{text-decoration:underline}.bui-bento-combobox-footer-item[_ngcontent-%COMP%]:last-child{text-align:right}.bui-bento-combobox-footer-item[_ngcontent-%COMP%]:first-child, [dir=rtl][_ngcontent-%COMP%]   .bui-bento-combobox-footer-item[_ngcontent-%COMP%]:last-child{text-align:left}[dir=rtl][_ngcontent-%COMP%]   .bui-bento-combobox-footer-item[_ngcontent-%COMP%]:first-child{text-align:right}.bui-bento-combobox-footer-item-inner[_ngcontent-%COMP%]{width:100%;vertical-align:middle;white-space:nowrap;padding:0 14px;text-overflow:ellipsis;overflow:hidden}bento-combobox-list[_ngcontent-%COMP%]   .bento-combobox-container-empty-label[_ngcontent-%COMP%]{opacity:.1;position:absolute;top:50%;left:50%;font-size:7.143rem;width:100px;height:100px;transform:translate(-50%,-60px);z-index:-1}.bui-bento-combobox-container-list[_ngcontent-%COMP%]{display:table;table-layout:fixed;position:relative;width:calc(100% + 1px)}.bui-bento-combobox-container-list[_ngcontent-%COMP%]   .bento-list-viewport[_ngcontent-%COMP%]   .cdk-virtual-scroll-content-wrapper[_ngcontent-%COMP%]{display:table;table-layout:fixed;width:100%}.bui-bento-combobox-container-item.bento-list-row[_ngcontent-%COMP%]{display:table-row;cursor:pointer}.bui-bento-combobox-container-item.bento-list-row[_ngcontent-%COMP%] > div[_ngcontent-%COMP%], .bui-bento-combobox-container-item.bento-list-row[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{display:table-cell;padding:6px 10px;line-height:17px;white-space:nowrap;text-overflow:ellipsis;border-bottom-width:1px;border-bottom-style:solid;overflow:hidden;box-sizing:border-box}.bui-bento-combobox-container-item.bento-list-row[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]   [class*=\" bento-icon-\"][_ngcontent-%COMP%], .bui-bento-combobox-container-item.bento-list-row[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]   [class^=bento-icon-][_ngcontent-%COMP%], .bui-bento-combobox-container-item.bento-list-row[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]   [class*=\" bento-icon-\"][_ngcontent-%COMP%], .bui-bento-combobox-container-item.bento-list-row[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]   [class^=bento-icon-][_ngcontent-%COMP%]{line-height:inherit}.bui-bento-combobox-container-item.bento-list-row[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:last-child, .bui-bento-combobox-container-item.bento-list-row[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]:last-child{padding-right:23px}[dir=rtl][_ngcontent-%COMP%]   .bui-bento-combobox-container-item.bento-list-row[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]:last-child, [dir=rtl][_ngcontent-%COMP%]   .bui-bento-combobox-container-item.bento-list-row[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]:last-child{padding-right:10px;padding-left:23px}bento-list-core[_ngcontent-%COMP%]{display:block;position:relative;width:100%}bento-list[_ngcontent-%COMP%]{display:block;min-width:200px;height:200px;border:1px solid transparent}.bento-list-viewport[_ngcontent-%COMP%]{display:block;height:100%}.bento-list-inner[_ngcontent-%COMP%]{position:absolute;display:block;width:100%;height:200%}.bento-list-row[_ngcontent-%COMP%]{height:30px;line-height:29px;border-bottom:1px solid grey;font-size:.879rem}cdk-virtual-scroll-viewport[_ngcontent-%COMP%]{display:block;position:relative;overflow:auto;contain:strict;transform:translateZ(0);will-change:scroll-position;-webkit-overflow-scrolling:touch}.cdk-virtual-scroll-content-wrapper[_ngcontent-%COMP%]{position:absolute;top:0;left:0;contain:content}[dir=rtl][_ngcontent-%COMP%]   .cdk-virtual-scroll-content-wrapper[_ngcontent-%COMP%]{right:0;left:auto}.cdk-virtual-scroll-orientation-horizontal[_ngcontent-%COMP%]   .cdk-virtual-scroll-content-wrapper[_ngcontent-%COMP%]{min-height:100%}.cdk-virtual-scroll-orientation-horizontal[_ngcontent-%COMP%]   .cdk-virtual-scroll-content-wrapper[_ngcontent-%COMP%] > dl[_ngcontent-%COMP%]:not([cdkVirtualFor]), .cdk-virtual-scroll-orientation-horizontal[_ngcontent-%COMP%]   .cdk-virtual-scroll-content-wrapper[_ngcontent-%COMP%] > ol[_ngcontent-%COMP%]:not([cdkVirtualFor]), .cdk-virtual-scroll-orientation-horizontal[_ngcontent-%COMP%]   .cdk-virtual-scroll-content-wrapper[_ngcontent-%COMP%] > table[_ngcontent-%COMP%]:not([cdkVirtualFor]), .cdk-virtual-scroll-orientation-horizontal[_ngcontent-%COMP%]   .cdk-virtual-scroll-content-wrapper[_ngcontent-%COMP%] > ul[_ngcontent-%COMP%]:not([cdkVirtualFor]){padding-left:0;padding-right:0;margin-left:0;margin-right:0;border-left-width:0;border-right-width:0;outline:0}.cdk-virtual-scroll-orientation-vertical[_ngcontent-%COMP%]   .cdk-virtual-scroll-content-wrapper[_ngcontent-%COMP%]{min-width:100%}.cdk-virtual-scroll-orientation-vertical[_ngcontent-%COMP%]   .cdk-virtual-scroll-content-wrapper[_ngcontent-%COMP%] > dl[_ngcontent-%COMP%]:not([cdkVirtualFor]), .cdk-virtual-scroll-orientation-vertical[_ngcontent-%COMP%]   .cdk-virtual-scroll-content-wrapper[_ngcontent-%COMP%] > ol[_ngcontent-%COMP%]:not([cdkVirtualFor]), .cdk-virtual-scroll-orientation-vertical[_ngcontent-%COMP%]   .cdk-virtual-scroll-content-wrapper[_ngcontent-%COMP%] > table[_ngcontent-%COMP%]:not([cdkVirtualFor]), .cdk-virtual-scroll-orientation-vertical[_ngcontent-%COMP%]   .cdk-virtual-scroll-content-wrapper[_ngcontent-%COMP%] > ul[_ngcontent-%COMP%]:not([cdkVirtualFor]){padding-top:0;padding-bottom:0;margin-top:0;margin-bottom:0;border-top-width:0;border-bottom-width:0;outline:0}.cdk-virtual-scroll-spacer[_ngcontent-%COMP%]{position:absolute;top:0;left:0;height:1px;width:1px;transform-origin:0 0}[dir=rtl][_ngcontent-%COMP%]   .cdk-virtual-scroll-spacer[_ngcontent-%COMP%]{right:0;left:auto;transform-origin:100% 0}.inline-display[_ngcontent-%COMP%]{display:inline-block}.EFTS-note-true[_ngcontent-%COMP%]{color:#4396d1}.EFTS-note-false[_ngcontent-%COMP%], .EFTS-note-true[_ngcontent-%COMP%]{font-size:12px;font-weight:700;font-family:BentoRegular,arial,helvetica,sans-serif}.EFTS-note-false[_ngcontent-%COMP%]{color:#f05056}.pr-15[_ngcontent-%COMP%]{padding-right:15px}.mr-15[_ngcontent-%COMP%]{margin-right:15px}.pl-187[_ngcontent-%COMP%]{padding-left:187px}"] });
AtoClientFinanceDetailsComponent.ctorParameters = () => [
    { type: AUTaxService },
    { type: AlertService },
    { type: AtoIntegrationService },
    { type: NgbModal },
    { type: HelperService },
    { type: SessionService },
    { type: CoreService }
];
AtoClientFinanceDetailsComponent.propDecorators = {
    clientid: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AtoClientFinanceDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'autax-ato-client-finance-details',
                template: "<form bfmForm name=\"clientFinanceValidation\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-8 col-sm-8 col-xs-8\">\r\n      <h3 class=\"no-top-margin\"> Electronic Fund Transfer(EFT) Details</h3>\r\n    </div>\r\n  </div>\r\n  <div class=\"row section-container ng-bento\">\r\n    <div class=\"col-md-4\">\r\n\r\n      <div class=\"form-group padding-format\">\r\n        <div class=\"row\">\r\n          <label class=\"bento-label\">\r\n            BSB\r\n          </label>\r\n        </div>\r\n        <div class=\"row mb-3\">\r\n          <div class=\"source-url-el input-group input-group-unstyled\">\r\n            <input (keypress)=\"validateNumericValue($event)\" maxlength=\"6\" bfmField=\"BSB Number\"\r\n              class=\"form-control bsb\" name=\"bsbNumber\" [(ngModel)]=\"financeDetails.bsbNumber\"\r\n              (change)=\"updateClientFinanceDetails(financeDetails)\">\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <label class=\"bento-label\">\r\n            Account Number\r\n          </label>\r\n        </div>\r\n        <div class=\"row mb-3\">\r\n          <div class=\"source-url-el input-group input-group-unstyled\">\r\n            <input (keypress)=\"validateNumericValue($event)\" maxlength=\"12\" bfmField=\"Account Number\"\r\n              class=\"form-control bsb\" name=\"accountNumber\" [(ngModel)]=\"financeDetails.accountNumber\"\r\n              (change)=\"updateClientFinanceDetails(financeDetails)\">\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <label class=\"bento-label\">\r\n            Account Name\r\n          </label>\r\n        </div>\r\n        <div class=\"row mb-3\">\r\n          <div class=\"source-url-el input-group input-group-unstyled\">\r\n            <input bfmField=\"Account Name\" class=\"form-control bsb\" (keypress)=\"validateAccountName($event)\"\r\n              name=\"accountName\" [(ngModel)]=\"financeDetails.accountName\" maxlength=\"32\"\r\n              (change)=\"updateClientFinanceDetails(financeDetails)\">\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-8 col-sm-8 col-xs-8\">\r\n          <h3>Other Details</h3>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group padding-format\">\r\n        <div class=\"row\">\r\n          <label class=\"bento-label\">\r\n            Resident for Tax Purposes\r\n          </label>\r\n        </div>\r\n        <div class=\"row mb-3 ng-bento\">\r\n          <div class=\"source-url-el input-group input-group-unstyled ng-bento\">\r\n            <bento-combobox id=\"cmbTaxPurposes\" name=\"cmbTaxPurposes\" [(ngModel)]=\"selectedTaxPurposes\"\r\n              [options]=\"cmbTaxPurposesOptions\" [itemsObservable]=\"residentTaxPurposesData\"\r\n              (openChange)=\"onComboChange()\">\r\n            </bento-combobox>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\" *ngIf='featureToggleGranted && isAuIndividual()'>\r\n        <div class=\"col-md-8 col-sm-8 col-xs-8\">\r\n          <h3>Prior year's tax return</h3>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group padding-format\" *ngIf='featureToggleGranted && isAuIndividual()'>\r\n        <div class=\"row\">\r\n          <label class=\"bento-label\">\r\n            Click to import prior year's tax return\r\n            <button  class=\"btn btn-primary mr-auto\" type=\"button\" [disabled]=\"isDisabledRetrieveFromAtoButton\"\r\n            [bentoBusyLoader]='isImportFromAtoButtonBusy' (click)=\"importFromAto(content)\">\r\n              Import from ATO\r\n            </button>\r\n          </label>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <div class=\"col-md-12\">\r\n      <div class=\"row\" *ngIf='featureToggleDirectDebitGranted'>\r\n        <div class=\"col-md-12 col-sm-12 col-xs-12\">\r\n          <div class=\"padding-format\">\r\n            <div class=\"row\">\r\n              <label class=\"bento-label\">\r\n                <h3 class=\"no-top-margin inline-display\"> Direct Debit Payment</h3>&nbsp;&nbsp;\r\n                <button class=\"btn btn-primary\" type=\"button\" (click)=\"openDirectDebitDetails()\">\r\n                  ADD\r\n                </button>\r\n                &nbsp;&nbsp;\r\n                <button class=\"btn btn-primary\" type=\"button\" (click)=\"openDirectDebitCancelDetails()\">\r\n                  CANCEL\r\n                </button>\r\n              </label>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"pl-187\">\r\n          <span [ngClass]=\"[isEFTSDetailsAll ? 'EFTS-note-true' : 'EFTS-note-false']\" id=\"EFTS-add-note\">\r\n            (Please ADD/Verify Bank Account (EFT) Details before adding payment)\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n\r\n<ng-template #content let-c=\"close\" let-d=\"dismiss\">\r\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"d('Cross click')\" [disabled]=\"isDisabledCancelIcon\">\r\n    <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\r\n  </button>\r\n  <h4 id=\"modal-scrollable-title\" class=\"modal-header h2\">\r\n    Prior year's tax return\r\n  </h4>\r\n  <div class=\"modal-body\" style=\"text-align: center;\">\r\n    <div class=\"row mb-3\">\r\n      <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n        <b> Name :</b>\r\n      </div>\r\n      <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\">\r\n        {{clientDetail.clientName}}\r\n      </div>\r\n    </div>\r\n    <div class=\"row mb-3\">\r\n      <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n        <b>TFN :</b>\r\n      </div>\r\n      <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\">\r\n        {{clientDetail.clientTfn}}\r\n      </div>\r\n    </div>\r\n    <div class=\"row mb-3\">\r\n      <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n        <b> DOB :</b>\r\n      </div>\r\n      <div class=\"col-md-8 col-sm-8 col-xs-8 text-left\">\r\n        {{clientDetail.individualDateOfBirth|date:'dd/MM/yyyy'}}\r\n      </div>\r\n    </div>\r\n    <div class=\"row mb-3\">\r\n      <div class=\"col-md-4 col-sm-4 col-xs-4 text-right\">\r\n        <b> Year :</b>\r\n      </div>\r\n      <div class=\"col-md-4 col-sm-4 col-xs-4 text-left source-url-el input-group input-group-unstyled ng-bento\">\r\n        <bento-combobox id=\"cmbPriorTaxYear\" name=\"cmbPriorTaxYear\" [options]=\"cmbPriorTaxYearOptions\" [(ngModel)]=\"selectedPriorTaxYear\"\r\n                        [itemsObservable]=\"priortaxYearData\" >\r\n        </bento-combobox>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n  <b>Note:</b>\r\n  <ul>\r\n    <li>By selecting \"All\" option, only 2019 and 2020 individual tax returns will be imported from ATO.</li>\r\n    <li>Importing the tax returns form ATO takes addtional time and thus increase the overall time of importing</li>\r\n  </ul>\r\n  <div class=\"modal-footer\">\r\n    <div class=\"row\">\r\n\r\n      <div class=\"col-xs-9 col-md-9 col-sm-9\">\r\n        <button class=\"btn btn-primary mr-auto\" type=\"button\" [disabled]=\"isDisabledRetrieveFromAtoButton\"\r\n        [bentoBusyLoader]='isImportButtonBusy' (click)='importButtonClicked()'>Import</button>\r\n      </div>\r\n      <div class=\"col-xs-3 col-md-3 col-sm-3\">\r\n        <button type=\"button\" class=\"btn btn-outline-primary float-right\" (click)=\"c('Close click')\" [disabled] ='isDisabledCancelButton'>Cancel</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-template>\r\n\r\n\r\n<div class=\"ng-bento\">\r\n  <autax-alert></autax-alert>\r\n</div>\r\n",
                providers: [
                    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
                ],
                styles: [".msgerror{display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;position:relative;box-sizing:border-box;color:#dc0a0a;padding-top:5px}.msgerror:before{font-family:bento-icomoon;font-weight:400;font-size:15px;color:#dc0a0a;content:\"\\e6f3\";width:20px;text-align:left;display:inline-block;vertical-align:text-bottom}.padding-format{padding-left:inherit}[class*=\" bento-icon-\"],[class^=bento-icon-]{font-family:bento-icomoon!important}.btn .bento-icon-calendar{font-size:24px!important}bento-combobox.bento-select{box-sizing:border-box;position:relative;overflow:visible;cursor:auto;width:100%;border-width:0;z-index:auto;display:inline-block}bento-combobox.bento-select:not(.readonly) .form-control[readonly]:not(:disabled){font-weight:400}bento-combobox.bento-select input.ng-hide-add{display:none}bento-combobox.bento-select.open input{border-bottom-left-radius:0;border-bottom-right-radius:0}bento-combobox.bento-select>.btn{pointer-events:auto;cursor:default;display:flex;align-items:center;justify-content:center}bento-combobox.bento-select>div.input-label.disabled{cursor:not-allowed;pointer-events:none}bento-combobox.bento-select>.btn.disabled{cursor:not-allowed;pointer-events:none;background:0 0}bento-combobox.bento-select input[disabled]:not(.readonly){font-weight:400;cursor:not-allowed;-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none}bento-combobox.bento-select>.preloader{position:absolute;width:40px;top:0;bottom:0;right:30px;pointer-events:none}bento-combobox.bento-select>.preloader .bento-busyloader-blocker{background:0 0;z-index:auto}bento-combobox.bento-select.input-sm .bento-combobox-container{top:28px}bento-combobox.bento-select.input-sm>.btn [class*=bento-icon]{font-size:.857rem}bento-combobox.bento-select>i{position:absolute;top:9px;right:59px}bento-combobox.bento-select i.preloader{width:24px;height:24px;background-size:24px 24px;display:none}bento-combobox.bento-select div.input-label,bento-combobox.bento-select div.placeholder{-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-o-user-select:none;cursor:default}bento-combobox.bento-select div.placeholder{position:absolute;left:0;top:0}bento-combobox.bento-select div.input-label,bento-combobox.bento-select div.placeholder,bento-combobox.bento-select input[type=text]{box-sizing:border-box;width:100%;font-size:1rem}bento-combobox.bento-select div.input-label:focus,bento-combobox.bento-select div.placeholder:focus,bento-combobox.bento-select input[type=text]:focus{outline:0}bento-combobox.bento-select .btn:hover{box-shadow:none}bento-combobox.bento-select .btn .bento-combobox-dropdown-button-icon{font-size:1rem;top:0}body.touch,body.touch .bento-combobox-container-body{-webkit-overflow-scrolling:touch}.bui-bento-combobox-container{display:block;position:absolute;margin-top:-1px;min-width:100%;min-height:0;z-index:10;border-width:1px;border-style:solid;width:auto;overflow:hidden;visibility:hidden;opacity:0;transition:border .3s,opacity .2s}.bui-bento-combobox-container.bento-append-to,.open .bui-bento-combobox-container{visibility:visible;opacity:1}.bui-bento-combobox-container.out{opacity:0;transition:opacity .2s}.dropup .bui-bento-combobox-container,.up .bui-bento-combobox-container{top:auto;margin:0 0 -1px}.bui-bento-combobox-container bento-list{margin-bottom:-1px;border:none;position:absolute;width:100%}.bui-bento-combobox-container ol,.bui-bento-combobox-container ul{margin:0;padding:0}.bui-bento-combobox-container.dropdown-menu-up{margin:0 0 -1px}.bui-bento-combobox-container.bento-append-to{margin:0}.bui-bento-combobox-list-wrapper{display:table-row}.bui-bento-combobox-container-header{font-weight:700;padding-right:0;text-transform:capitalize;list-style:none;white-space:nowrap;display:table-header-group;width:100%}[dir=rtl] .bui-bento-combobox-container-header{padding-left:0;padding-right:auto}.bui-bento-combobox-container-header-label{padding:5px 10px;white-space:nowrap;display:table-cell;border-bottom-width:1px;border-bottom-style:solid}.bui-bento-combobox-container-header-label-filler{padding:0}.bui-bento-combobox-container-footer{display:block;width:100%;height:35px;border-top-width:solid;border-top-style:1px;position:relative;line-height:normal;font-size:.879rem}.bui-bento-combobox-footer-inner{display:table;width:100%;height:35px}.bui-bento-combobox-footer-row{display:table-row}.bui-bento-combobox-footer-item{display:table-cell;position:relative;vertical-align:middle;text-align:center}.bui-bento-combobox-footer-item .btn{padding:0;letter-spacing:0;cursor:pointer}.bui-bento-combobox-footer-item .btn:disabled{pointer-events:none}.bui-bento-combobox-footer-item .btn:disabled:hover span{text-decoration:none}.bui-bento-combobox-footer-item .btn i:first-child,.bui-bento-combobox-footer-item .btn i:last-child{margin:0!important;top:0;vertical-align:baseline}.bui-bento-combobox-footer-item .btn:hover{text-decoration:none}.bui-bento-combobox-footer-item .btn:hover span{text-decoration:underline}.bui-bento-combobox-footer-item:last-child{text-align:right}.bui-bento-combobox-footer-item:first-child,[dir=rtl] .bui-bento-combobox-footer-item:last-child{text-align:left}[dir=rtl] .bui-bento-combobox-footer-item:first-child{text-align:right}.bui-bento-combobox-footer-item-inner{width:100%;vertical-align:middle;white-space:nowrap;padding:0 14px;text-overflow:ellipsis;overflow:hidden}bento-combobox-list .bento-combobox-container-empty-label{opacity:.1;position:absolute;top:50%;left:50%;font-size:7.143rem;width:100px;height:100px;transform:translate(-50%,-60px);z-index:-1}.bui-bento-combobox-container-list{display:table;table-layout:fixed;position:relative;width:calc(100% + 1px)}.bui-bento-combobox-container-list .bento-list-viewport .cdk-virtual-scroll-content-wrapper{display:table;table-layout:fixed;width:100%}.bui-bento-combobox-container-item.bento-list-row{display:table-row;cursor:pointer}.bui-bento-combobox-container-item.bento-list-row>div,.bui-bento-combobox-container-item.bento-list-row>span{display:table-cell;padding:6px 10px;line-height:17px;white-space:nowrap;text-overflow:ellipsis;border-bottom-width:1px;border-bottom-style:solid;overflow:hidden;box-sizing:border-box}.bui-bento-combobox-container-item.bento-list-row>div [class*=\" bento-icon-\"],.bui-bento-combobox-container-item.bento-list-row>div [class^=bento-icon-],.bui-bento-combobox-container-item.bento-list-row>span [class*=\" bento-icon-\"],.bui-bento-combobox-container-item.bento-list-row>span [class^=bento-icon-]{line-height:inherit}.bui-bento-combobox-container-item.bento-list-row>div:last-child,.bui-bento-combobox-container-item.bento-list-row>span:last-child{padding-right:23px}[dir=rtl] .bui-bento-combobox-container-item.bento-list-row>div:last-child,[dir=rtl] .bui-bento-combobox-container-item.bento-list-row>span:last-child{padding-right:10px;padding-left:23px}bento-list-core{display:block;position:relative;width:100%}bento-list{display:block;min-width:200px;height:200px;border:1px solid transparent}.bento-list-viewport{display:block;height:100%}.bento-list-inner{position:absolute;display:block;width:100%;height:200%}.bento-list-row{height:30px;line-height:29px;border-bottom:1px solid grey;font-size:.879rem}cdk-virtual-scroll-viewport{display:block;position:relative;overflow:auto;contain:strict;transform:translateZ(0);will-change:scroll-position;-webkit-overflow-scrolling:touch}.cdk-virtual-scroll-content-wrapper{position:absolute;top:0;left:0;contain:content}[dir=rtl] .cdk-virtual-scroll-content-wrapper{right:0;left:auto}.cdk-virtual-scroll-orientation-horizontal .cdk-virtual-scroll-content-wrapper{min-height:100%}.cdk-virtual-scroll-orientation-horizontal .cdk-virtual-scroll-content-wrapper>dl:not([cdkVirtualFor]),.cdk-virtual-scroll-orientation-horizontal .cdk-virtual-scroll-content-wrapper>ol:not([cdkVirtualFor]),.cdk-virtual-scroll-orientation-horizontal .cdk-virtual-scroll-content-wrapper>table:not([cdkVirtualFor]),.cdk-virtual-scroll-orientation-horizontal .cdk-virtual-scroll-content-wrapper>ul:not([cdkVirtualFor]){padding-left:0;padding-right:0;margin-left:0;margin-right:0;border-left-width:0;border-right-width:0;outline:0}.cdk-virtual-scroll-orientation-vertical .cdk-virtual-scroll-content-wrapper{min-width:100%}.cdk-virtual-scroll-orientation-vertical .cdk-virtual-scroll-content-wrapper>dl:not([cdkVirtualFor]),.cdk-virtual-scroll-orientation-vertical .cdk-virtual-scroll-content-wrapper>ol:not([cdkVirtualFor]),.cdk-virtual-scroll-orientation-vertical .cdk-virtual-scroll-content-wrapper>table:not([cdkVirtualFor]),.cdk-virtual-scroll-orientation-vertical .cdk-virtual-scroll-content-wrapper>ul:not([cdkVirtualFor]){padding-top:0;padding-bottom:0;margin-top:0;margin-bottom:0;border-top-width:0;border-bottom-width:0;outline:0}.cdk-virtual-scroll-spacer{position:absolute;top:0;left:0;height:1px;width:1px;transform-origin:0 0}[dir=rtl] .cdk-virtual-scroll-spacer{right:0;left:auto;transform-origin:100% 0}.inline-display{display:inline-block}.EFTS-note-true{color:#4396d1}.EFTS-note-false,.EFTS-note-true{font-size:12px;font-weight:700;font-family:BentoRegular,arial,helvetica,sans-serif}.EFTS-note-false{color:#f05056}.pr-15{padding-right:15px}.mr-15{margin-right:15px}.pl-187{padding-left:187px}"]
            }]
    }], function () { return [{ type: AUTaxService }, { type: AlertService }, { type: AtoIntegrationService }, { type: ɵngcc3.NgbModal }, { type: HelperService }, { type: SessionService }, { type: CoreService }]; }, { clientid: [{
            type: Input
        }] }); })();

// System Import
class AUABNFormat {
    transform(value) {
        var allDigits = /^\d+$/;
        if (allDigits.test(value)) {
            return value.slice(0, 2) + ' ' + value.slice(2, 5) + ' ' + value.slice(5, 8) + ' ' + value.slice(8, 11);
        }
        else {
            var formattedDigits = /^\d{2} \d{3} \d{3} \d{3}$/;
            if (formattedDigits.test(value)) {
                return value;
            }
        }
        return value;
    }
}
AUABNFormat.ɵfac = function AUABNFormat_Factory(t) { return new (t || AUABNFormat)(); };
AUABNFormat.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "auABNFormat", type: AUABNFormat, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AUABNFormat, [{
        type: Pipe,
        args: [{ name: 'auABNFormat' }]
    }], null, null); })();

// System Import
class AutaxAtoClientUpdateModule {
}
AutaxAtoClientUpdateModule.ɵfac = function AutaxAtoClientUpdateModule_Factory(t) { return new (t || AutaxAtoClientUpdateModule)(); };
AutaxAtoClientUpdateModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AutaxAtoClientUpdateModule });
AutaxAtoClientUpdateModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            BrowserAnimationsModule,
            BentoModule,
            NgbModule,
            BentoD3Module,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutaxAtoClientUpdateModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AtoAgentClientRelationshipComponent,
                    ClientAddressUpdateComponent,
                    AlertComponent,
                    AtoClientFinanceDetailsComponent,
                    ClientRelationshipUpdateComponent,
                    AUABNFormat,
                    AtoClientAssociationDetailsComponent,
                    ClientAssociationDetailsUpdateComponent,
                    DirectDebitPaymentComponent,
                    DirectDebitCancelPaymentComponent
                ],
                entryComponents: [
                    AtoAgentClientRelationshipComponent,
                    ClientAddressUpdateComponent,
                    AlertComponent,
                    AtoClientFinanceDetailsComponent,
                    ClientRelationshipUpdateComponent,
                    AtoClientAssociationDetailsComponent,
                    ClientAssociationDetailsUpdateComponent,
                    DirectDebitPaymentComponent,
                    DirectDebitCancelPaymentComponent
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    BrowserAnimationsModule,
                    BentoModule,
                    NgbModule,
                    BentoD3Module,
                ],
                exports: [
                    AlertComponent,
                    AtoAgentClientRelationshipComponent,
                    AtoClientFinanceDetailsComponent,
                    AtoClientAssociationDetailsComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AutaxAtoClientUpdateModule, { declarations: function () { return [AtoAgentClientRelationshipComponent, ClientAddressUpdateComponent, AlertComponent, AtoClientFinanceDetailsComponent, ClientRelationshipUpdateComponent, AUABNFormat, AtoClientAssociationDetailsComponent, ClientAssociationDetailsUpdateComponent, DirectDebitPaymentComponent, DirectDebitCancelPaymentComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        BrowserAnimationsModule,
        BentoModule,
        NgbModule,
        BentoD3Module]; }, exports: function () { return [AlertComponent, AtoAgentClientRelationshipComponent, AtoClientFinanceDetailsComponent, AtoClientAssociationDetailsComponent]; } }); })();

// System Import
class AutaxStaffComponent {
    constructor() { }
    ngOnInit() {
    }
}
AutaxStaffComponent.ɵfac = function AutaxStaffComponent_Factory(t) { return new (t || AutaxStaffComponent)(); };
AutaxStaffComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AutaxStaffComponent, selectors: [["autax-staff"]], decls: 0, vars: 0, template: function AutaxStaffComponent_Template(rf, ctx) { }, encapsulation: 2 });
AutaxStaffComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutaxStaffComponent, [{
        type: Component,
        args: [{
                selector: 'autax-staff',
                template: ''
            }]
    }], function () { return []; }, null); })();

// System Import
class AutaxStaffService {
    constructor() { }
}
AutaxStaffService.ɵfac = function AutaxStaffService_Factory(t) { return new (t || AutaxStaffService)(); };
AutaxStaffService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AutaxStaffService, factory: AutaxStaffService.ɵfac });
AutaxStaffService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutaxStaffService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class AutaxMigrationService {
    constructor(http, session) {
        this.http = http;
        this.session = session;
        this.startMigration = (xmlFile) => {
            let input = new FormData();
            input.append('file', xmlFile[0]);
            return from(this.session.getBasePath(ServiceKey.AUTaxMigrationServices)).pipe(mergeMap((basePath) => this.http.post(`${basePath}/${BuildRoute.getBuildRoute(EndpointRoute.Post_v2_Startmigration, {})}`, input).pipe(map((data) => data), catchError(ExceptionHandler.handleError))));
        };
        /**
         * This will start the migartion process from SA to Onvio of clients and tax returns
         */
        this.startMigrationSaV1 = (xmlFile, softAssistModel) => {
            let input = new FormData();
            input.append('file', xmlFile[0]);
            input.append('data', JSON.stringify(softAssistModel));
            return from(this.session.getBasePath(ServiceKey.AUTaxMigrationServices)).pipe(mergeMap((basePath) => this.http.post(`${basePath}/${BuildRoute.getBuildRoute(EndpointRoute.Post_v1_Migrate, {})}`, input).pipe(map((data) => data), catchError(ExceptionHandler.handleError))));
        };
    }
    getMigrationEventDetails(id) {
        const url = `/api/autax/migration/v2/migrate/events/${id}/details`;
        return this.http.get(url)
            .pipe(catchError(ExceptionHandler.handleError));
    }
    /**
     * This method will return latestItcrptReport with success status
     */
    getSuccessITCRPTReport() {
        return from(this.session.getBasePath(ServiceKey.AUTaxReportingServices)).pipe(mergeMap((basePath) => this.http.get(`${basePath}/${BuildRoute.getBuildRoute(EndpointRoute.Get_v1_successItcrptReport, {})}`)
            .pipe(map((data) => data), catchError(ExceptionHandler.handleError))));
    }
    /**
     *  This method will return latestItcrptReport with pending status
     */
    getPendingITCRPTReport() {
        return from(this.session.getBasePath(ServiceKey.AUTaxReportingServices)).pipe(mergeMap((basePath) => this.http.get(`${basePath}/${BuildRoute.getBuildRoute(EndpointRoute.Get_v1_pendingItcrptReport, {})}`)
            .pipe(map((data) => data), catchError(ExceptionHandler.handleError))));
    }
    startMigrationAtoV1(atoOnvioMigrationV1) {
        return from(this.session.getBasePath(ServiceKey.AUTaxMigrationServices)).pipe(mergeMap((basePath) => this.http.post(`${basePath}/${BuildRoute.getBuildRoute(EndpointRoute.Post_v1_atoToOnvio_bulkMigration, {})}`, atoOnvioMigrationV1)
            .pipe(map((data) => data), catchError(ExceptionHandler.handleError))));
    }
}
AutaxMigrationService.ɵfac = function AutaxMigrationService_Factory(t) { return new (t || AutaxMigrationService)(ɵngcc0.ɵɵinject(ɵngcc2.HttpClient), ɵngcc0.ɵɵinject(SessionService)); };
AutaxMigrationService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AutaxMigrationService_Factory() { return new AutaxMigrationService(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(SessionService)); }, token: AutaxMigrationService, providedIn: "root" });
AutaxMigrationService.ctorParameters = () => [
    { type: HttpClient },
    { type: SessionService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutaxMigrationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.HttpClient }, { type: SessionService }]; }, null); })();

class MigrationDetailsComponent {
    constructor(autaxMigrationService) {
        this.autaxMigrationService = autaxMigrationService;
        this.alerts = [];
        this.showtable = new EventEmitter();
        this.closetable = new EventEmitter();
        this.statuses = [
            {
                id: 0,
                status: 'Warning',
                class: 'warning' // class available from Bento
            },
            {
                id: 1,
                status: 'Error',
                class: 'error' // class available from Bento
            }
        ];
        this.pageInfo = {
            infoText: '_START_ to _END_ of _MAX_ Users',
            infoPageText: '_PAGE_ of _PAGES_',
            goText: 'Go',
            pageSize: 25
        };
        this.statusMap = new wjcGrid.DataMap(this.statuses, 'id', 'status');
        this.itemFormatter = this.itemFormatterBounded.bind(this);
    }
    ngOnChanges() {
        this.tableData(this.eventid, this.migrationtype);
    }
    tableData(id, migrationtype) {
        this.hide = false;
        this.isBusy = true;
        this.autaxMigrationService.getMigrationEventDetails(id).subscribe((response) => {
            const details = this.getMigrationEventDetails(response);
            this.data = new wjcCore.CollectionView(details);
            this.data.pageSize = this.pageInfo.pageSize;
            if (this.data._src.length === 0) {
                this.hide = true;
                this.alertMessage(this.getSuccessMigrationTypeDescription(migrationtype), AlertType.success);
            }
            this.isBusy = false;
            this.showtable.emit();
        }, (error => {
            this.hide = true;
            this.isBusy = false;
            this.alertMessage('Something went wrong. Please try again. If the issue persists, please contact support.', AlertType.danger);
            console.log(error);
            this.showtable.emit();
        }));
    }
    itemFormatterBounded(panel, r, c, cell) {
        if (panel.cellType === wjcGrid.CellType.Cell) {
            const flex = panel.grid;
            const col = flex.columns[c];
            if (col.binding === 'status') {
                const cellData = flex.getCellData(r, c);
                cell.classList.add('status-indicator');
                cell.classList.add(this.statuses[cellData].class);
            }
        }
    }
    exportExcelDelay(grid) {
        this.isBusy = true;
        grid.cells.columns[0].visible = true;
        setTimeout(() => {
            this.exportExcel(grid);
        }, 100); // To show the busy loader before the UI changes.
    }
    exportExcel(grid) {
        const view = grid.collectionView;
        const oldPgSize = view.pageSize;
        const oldPgIndex = view.pageIndex;
        grid.beginUpdate();
        view.pageSize = 0;
        wjcGridXlsx.FlexGridXlsxConverter.saveAsync(grid, {
            includeColumnHeaders: true,
            includeCellStyles: true,
            includeRowHeaders: false
        }, `Report-${this.eventid.split('-')[0]}.xlsx`, saved => this.onSaved(view, oldPgSize, oldPgIndex, grid), null);
    }
    onSaved(view, oldPgSize, oldPgIndex, grid) {
        grid.cells.columns[0].visible = false;
        view.pageSize = oldPgSize;
        view.moveToPage(oldPgIndex);
        grid.endUpdate();
        setTimeout(() => { this.isBusy = false; }, 100);
    }
    getSuccessMigrationTypeDescription(type) {
        let option;
        switch (type) {
            case 'clientAndTaxReturn':
                option = 'Clients and Tax Returns';
                break;
            case 'taxReturnOnly':
                option = 'Tax Returns';
                break;
            default:
                option = 'Clients';
                break;
        }
        return `All ${option} have been successfully migrated in Onvio. No Errors/Warnings found.`;
    }
    getMigrationEventDetails(data) {
        const listOfEvents = [];
        data.forEach((element, i) => {
            if (element.status !== 'success') {
                const migrationEventDetails = {
                    no: i + 1,
                    clientName: element.clientName,
                    migrationType: element.migrationType,
                    message: element.statusMessage,
                    status: this.getStatus(element.status),
                };
                listOfEvents.push(migrationEventDetails);
            }
        });
        return listOfEvents;
    }
    getStatus(status) {
        switch (status) {
            case 'warning': return 0;
            case 'failed': return 1;
        }
    }
    // Pagination Size Changed Event Handler
    onPageSizeChanged(size) {
        this.data.pageSize = size;
    }
    // Pagination Page Changed Event Handler
    onPageChanged(page) {
        this.data.moveToPage(page - 1);
    }
    alertMessage(message, type) {
        this.alerts.push({
            type,
            msg: message,
            closeable: false,
            timeout: 5000,
        });
        setTimeout(() => {
            this.closetable.emit();
        }, 5000);
    }
}
MigrationDetailsComponent.ɵfac = function MigrationDetailsComponent_Factory(t) { return new (t || MigrationDetailsComponent)(ɵngcc0.ɵɵdirectiveInject(AutaxMigrationService)); };
MigrationDetailsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MigrationDetailsComponent, selectors: [["autax-migration"]], viewQuery: function MigrationDetailsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.flexGrid = _t.first);
    } }, inputs: { migrationtype: "migrationtype", eventid: "eventid" }, outputs: { showtable: "showtable", closetable: "closetable" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 24, vars: 43, consts: [[1, "migration-details-alerts", 3, "items"], [3, "bentoBusyLoader", "hidden"], [1, "flexgrid-demo"], [1, "bento-toolbar", "navbar", "bg-faded"], [1, "navbar-header"], ["role", "group", 1, "nav", "navbar-right"], [1, "btn", "btn-default", 3, "click"], [1, "bento-flex-grid", "custom-grid", 3, "itemsSource", "stickyHeaders", "itemFormatter", "selectionMode", "showSort", "allowSorting", "autoRowHeights"], ["flexGrid", ""], ["wjFlexGridCellTemplate", "", 3, "cellType"], [3, "header", "binding", "isReadOnly", "visible", "width"], ["wjFlexGridCellTemplate", "", "class", "center", 3, "cellType"], [3, "header", "binding", "dataMap", "cssClass", "isReadOnly", "width"], [3, "header", "binding", "wordWrap", "isReadOnly", "visible", "width"], [4, "ngIf"], [1, "align-center"], [3, "page", "directionLinks", "boundaryLinks", "totalItems", "itemsPerPage", "itemsPerPageChange", "pageChange"]], template: function MigrationDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        const _r23 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelement(0, "bento-alert", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1)(2, "section", 2)(3, "div", 3)(4, "div", 4)(5, "h2");
        ɵngcc0.ɵɵtext(6, "Migration Reports");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(7, "ul", 5)(8, "li")(9, "button", 6);
        ɵngcc0.ɵɵlistener("click", function MigrationDetailsComponent_Template_button_click_9_listener() { ɵngcc0.ɵɵrestoreView(_r23); const _r0 = ɵngcc0.ɵɵreference(12); return ctx.exportExcelDelay(_r0); });
        ɵngcc0.ɵɵtext(10, " Export ");
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(11, "wj-flex-grid", 7, 8);
        ɵngcc0.ɵɵtemplate(13, MigrationDetailsComponent_ng_template_13_Template, 1, 1, "ng-template", 9);
        ɵngcc0.ɵɵelementStart(14, "wj-flex-grid-column", 10);
        ɵngcc0.ɵɵtemplate(15, MigrationDetailsComponent_ng_template_15_Template, 3, 1, "ng-template", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "wj-flex-grid-column", 10);
        ɵngcc0.ɵɵtemplate(17, MigrationDetailsComponent_ng_template_17_Template, 3, 1, "ng-template", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "wj-flex-grid-column", 10);
        ɵngcc0.ɵɵtemplate(19, MigrationDetailsComponent_ng_template_19_Template, 3, 1, "ng-template", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(20, "wj-flex-grid-column", 12);
        ɵngcc0.ɵɵtemplate(21, MigrationDetailsComponent_ng_template_21_Template, 3, 1, "ng-template", 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(22, "wj-flex-grid-column", 13);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(23, MigrationDetailsComponent_div_23_Template, 2, 5, "div", 14);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("items", ctx.alerts);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("bentoBusyLoader", ctx.isBusy)("hidden", ctx.hide);
        ɵngcc0.ɵɵadvance(10);
        ɵngcc0.ɵɵproperty("itemsSource", ctx.data)("stickyHeaders", true)("itemFormatter", ctx.itemFormatter)("selectionMode", "Row")("showSort", false)("allowSorting", false)("autoRowHeights", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("cellType", "RowHeader");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("header", "No.")("binding", "no")("isReadOnly", true)("visible", false)("width", 80);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cellType", "Cell");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("header", "Client Name")("binding", "clientName")("isReadOnly", true)("visible", true)("width", "*");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cellType", "Cell");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("header", "Migration Type")("binding", "migrationType")("isReadOnly", true)("visible", true)("width", "*");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cellType", "Cell");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("header", "Status")("binding", "status")("dataMap", ctx.statusMap)("cssClass", "status")("isReadOnly", true)("width", "*");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cellType", "Cell");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("header", "Message")("binding", "message")("wordWrap", true)("isReadOnly", true)("visible", true)("width", "3*");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data != null);
    } }, directives: [ɵngcc4.BentoAlertComponent, ɵngcc4.BentoBusyLoaderDirective, ɵngcc3.NgbNavbar, ɵngcc4.BentoFocusMonitorDirective, ɵngcc7.WjFlexGrid, ɵngcc7.WjFlexGridCellTemplate, ɵngcc1.NgIf, ɵngcc7.WjFlexGridColumn, ɵngcc4.BentoPaginationComponent], styles: [".bento-flex-grid{max-height:400px}.align-center{height:100%;display:flex;flex-direction:row;align-items:center}.migration-details-alerts .alert-container{top:auto!important;bottom:0!important}"], encapsulation: 2 });
MigrationDetailsComponent.ctorParameters = () => [
    { type: AutaxMigrationService }
];
MigrationDetailsComponent.propDecorators = {
    migrationtype: [{ type: Input }],
    eventid: [{ type: Input }],
    showtable: [{ type: Output }],
    closetable: [{ type: Output }],
    flexGrid: [{ type: ViewChild, args: ['flexGrid', { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MigrationDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'autax-migration',
                template: "<bento-alert class=\"migration-details-alerts\" [items]=\"alerts\"></bento-alert>\r\n<div [bentoBusyLoader]=\"isBusy\" [hidden]=\"hide\">\r\n  <section class=\"flexgrid-demo\">\r\n    <div class=\"bento-toolbar navbar bg-faded\">\r\n      <div class=\"navbar-header\">\r\n        <h2>Migration Reports</h2>\r\n      </div>\r\n      <ul class=\"nav navbar-right\" role=\"group\">\r\n        <li>\r\n          <button class=\"btn btn-default\" (click)=\"exportExcelDelay(flexGrid)\">\r\n            Export\r\n          </button>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n    <!-- FLEXGRID -->\r\n    <wj-flex-grid\r\n      #flexGrid\r\n      class=\"bento-flex-grid custom-grid\"\r\n      [itemsSource]=\"data\"\r\n      [stickyHeaders]=\"true\"\r\n      [itemFormatter]=\"itemFormatter\"\r\n      [selectionMode]=\"'Row'\"\r\n      [showSort]=\"false\"\r\n      [allowSorting]=\"false\"\r\n      [autoRowHeights]=\"true\"\r\n    >\r\n      <!-- FLEXGRID FILTER -->\r\n      <ng-template\r\n        wjFlexGridCellTemplate\r\n        [cellType]=\"'RowHeader'\"\r\n        let-col=\"col\"\r\n        let-row=\"row\"\r\n        let-item=\"item\"\r\n      >\r\n        <div *ngIf=\"col.index === 0\">{{ data.pageSize * data.pageIndex + row.index + 1 }}</div>\r\n      </ng-template>\r\n      <wj-flex-grid-column\r\n        [header]=\"'No.'\"\r\n        [binding]=\"'no'\"\r\n        [isReadOnly]=\"true\"\r\n        [visible]=\"false\"\r\n        [width]=\"80\"\r\n      >\r\n      <ng-template\r\n          wjFlexGridCellTemplate\r\n          [cellType]=\"'Cell'\"\r\n          let-item=\"item\"\r\n          let-cell=\"cell\"\r\n          class=\"center\"\r\n        >\r\n          <div class=\"align-center\">\r\n            <span>{{ item.no }}</span>\r\n          </div>\r\n        </ng-template>\r\n      </wj-flex-grid-column>\r\n      <wj-flex-grid-column\r\n        [header]=\"'Client Name'\"\r\n        [binding]=\"'clientName'\"\r\n        [isReadOnly]=\"true\"\r\n        [visible]=\"true\"\r\n        [width]=\"'*'\"\r\n      >\r\n        <ng-template\r\n          wjFlexGridCellTemplate\r\n          [cellType]=\"'Cell'\"\r\n          let-item=\"item\"\r\n          let-cell=\"cell\"\r\n          class=\"center\"\r\n        >\r\n          <div class=\"align-center\">\r\n            <span>{{ item.clientName }}</span>\r\n          </div>\r\n        </ng-template>\r\n      </wj-flex-grid-column>\r\n      <wj-flex-grid-column\r\n        [header]=\"'Migration Type'\"\r\n        [binding]=\"'migrationType'\"\r\n        [isReadOnly]=\"true\"\r\n        [visible]=\"true\"\r\n        [width]=\"'*'\"\r\n      >\r\n        <ng-template\r\n          wjFlexGridCellTemplate\r\n          [cellType]=\"'Cell'\"\r\n          let-item=\"item\"\r\n          let-cell=\"cell\"\r\n          class=\"center\"\r\n        >\r\n          <div class=\"align-center\">\r\n            <span>{{ item.migrationType }}</span>\r\n          </div>\r\n        </ng-template>\r\n      </wj-flex-grid-column>\r\n      <wj-flex-grid-column\r\n        [header]=\"'Status'\"\r\n        [binding]=\"'status'\"\r\n        [dataMap]=\"statusMap\"\r\n        [cssClass]=\"'status'\"\r\n        [isReadOnly]=\"true\"\r\n        [width]=\"'*'\"\r\n      >\r\n        <ng-template\r\n          wjFlexGridCellTemplate\r\n          [cellType]=\"'Cell'\"\r\n          let-item=\"item\"\r\n          let-cell=\"cell\"\r\n        >\r\n          <div class=\"align-center\">\r\n            <span>{{ statusMap.getDisplayValue(item.status) }}</span>\r\n          </div>\r\n        </ng-template>\r\n      </wj-flex-grid-column>\r\n      <wj-flex-grid-column\r\n        [header]=\"'Message'\"\r\n        [binding]=\"'message'\"\r\n        [wordWrap]=\"true\"\r\n        [isReadOnly]=\"true\"\r\n        [visible]=\"true\"\r\n        [width]=\"'3*'\"\r\n      >\r\n      </wj-flex-grid-column>\r\n    </wj-flex-grid>\r\n  </section>\r\n\r\n  <div *ngIf=\"data != null\">\r\n    <!-- BENTO PAGINATION -->\r\n    <bento-pagination\r\n      [page]=\"data.pageIndex + 1\"\r\n      [directionLinks]=\"true\"\r\n      [boundaryLinks]=\"true\"\r\n      [totalItems]=\"data?.totalItemCount\"\r\n      [itemsPerPage]=\"pageInfo.pageSize\"\r\n      (itemsPerPageChange)=\"onPageSizeChanged($event)\"\r\n      (pageChange)=\"onPageChanged($event)\"\r\n    >\r\n    </bento-pagination>\r\n  </div>\r\n</div>\r\n\r\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".bento-flex-grid{max-height:400px}.align-center{height:100%;display:flex;flex-direction:row;align-items:center}.migration-details-alerts .alert-container{top:auto!important;bottom:0!important}"]
            }]
    }], function () { return [{ type: AutaxMigrationService }]; }, { showtable: [{
            type: Output
        }], closetable: [{
            type: Output
        }], migrationtype: [{
            type: Input
        }], eventid: [{
            type: Input
        }], flexGrid: [{
            type: ViewChild,
            args: ['flexGrid', { static: true }]
        }] }); })();

class SoftAssitMigrationV1 {
}
class SoftAssistModel extends SoftAssitMigrationV1 {
}

class AtoModel {
}

class AtoOnvioMigrationV1 {
}

// System Imports
class MigrationModalWindowComponent {
    /**
     * Initialize the modal window objects, services and constants to be used.
     * @param ngbModal ngbModal object initialization
     * @param activeModal ngbActiveModal object initialization
     * @param autaxMigrationService migrationService object initialization
     * @param datePipe DataPipe object initialization
     */
    constructor(ngbModal, activeModal, autaxMigrationService, sessionService, datePipe) {
        this.ngbModal = ngbModal;
        this.activeModal = activeModal;
        this.autaxMigrationService = autaxMigrationService;
        this.sessionService = sessionService;
        this.datePipe = datePipe;
        //sa used variables
        this.isSoftwareAssistant = false;
        this.showSelected = true;
        this.showFileSize = true;
        this.appendOnSelection = false;
        this.multipleSelect = false;
        this.disableFS = false;
        this.showSelectedFiles = true;
        this.saIsYearComboDisabled = false;
        this.saIsImportTypeClientOnly = false;
        this.isSaFileSelecterControll = false;
        this.isSaYearSelected = false;
        this.fileSelectorConstant = AutaxStaffConstants.fileSelectorConstant;
        this.softAssistModel = new SoftAssitMigrationV1();
        this.saModel = new SoftAssistModel();
        this.cmbSaMigrationYearOptions = {
            searchable: true,
        };
        this.isAtoReports = false;
        this.isHaveITCRPTReport = false;
        this.isReportCheckBusy = false;
        this.isDoneButtonDisable = true;
        this.isDoneButtonHidden = true;
        this.isItcrptReportStatusPending = false;
        this.atoIsAnyOptionSelected = false;
        this.atoOnvioMigrationV1 = new AtoOnvioMigrationV1();
        this.cmbAtoMigrationYearOptions = {
            searchable: true,
        };
        this.atoModel = new AtoModel();
        this.isEnableToViewStep2 = true;
        this.isEnableToViewStep3 = true;
        this.hasAUTaxSAMigrationV2 = false;
        this.hasAUTaxATOMigrationV2 = false;
        this.showSelected = true;
        this.showFileSize = true;
        this.importTypes = [
            { value: 'softwareAssistant', label: 'Software Assistant' },
            { value: 'atoReportsNew', label: 'ATO – Income Tax Client Report (ITCRPT)' }
        ];
        this.saImportTypes = [
            {
                value: 'clientDetailsOnly',
                label: 'Client details',
                label1: 'This will create only those clients which are not present in onvio',
            },
            {
                value: 'taxReturnOnly',
                label: 'Tax returns',
                label1: 'This will import tax return only for those clients which are present in onvio',
            },
            {
                value: 'clientAndTaxReturn',
                label: 'All clients details and tax returns',
            }
        ];
        this.atoImportTypes = [
            {
                value: 'newReportFromATO',
                label: 'Request a new ATO report (may take up to 48 hours)',
                label1: 'New ATO report (may take up to 48 hours)'
            },
            {
                value: 'fromLatestITCRPT',
                label: 'Import using the latest ATO report received on',
                label1: '(ITCRPT) received on'
            },
            {
                value: 'newReportFromITCRPT',
                label: 'Request a new ATO report (may take up to 48 hours)',
                label1: 'New ATO report (may take up to 48 hours)'
            }
        ];
    }
    /**
     * Intitialize the component with the comboBox options and firmLicensePermission check for sa and ato migration
     * @returns void
     */
    ngOnInit() {
        // Get the value of License permission status for AUTax.ATOMigrationV2.
        this.hasAUTaxATOMigrationV2 = this.sessionService.getCurrentFirmLicensePermissionATOMigrationV2();
        // Get the value of License permission status for AUTax.SAMigrationV2.
        this.hasAUTaxSAMigrationV2 = this.sessionService.getCurrentFirmLicensePermissionSAMigrationV2();
        // Get the value of License permission status for AUTax.ATOTaxMigrationV1.
        this.hasAUTaxATOTaxMigrationV1 = this.sessionService.getCurrentFirmLicensePermissionATOTaxMigrationV1();
        this.saMigrationYearSelection = new BehaviorSubject([
            AutaxStaffConstants.combPriorTaxYearOptions.allYear,
            AutaxStaffConstants.combPriorTaxYearOptions.taxYear2020,
            AutaxStaffConstants.combPriorTaxYearOptions.taxYear2019
        ]);
        this.atoMigrationYearSelection = new BehaviorSubject([
            AutaxStaffConstants.combPriorTaxYearOptions.none,
            AutaxStaffConstants.combPriorTaxYearOptions.taxYear2019,
            AutaxStaffConstants.combPriorTaxYearOptions.taxYear2020,
            AutaxStaffConstants.combPriorTaxYearOptions.atoAllYear
        ]);
        this.atoMigrationOptionSelection = new BehaviorSubject([
            AutaxStaffConstants.comboOptions.Yes,
            AutaxStaffConstants.comboOptions.No,
        ]);
    }
    /**
     * It will enable/diable the import button based on the setp number
     */
    wizardStepChange() {
        if (this.currentStepNumber === 2) {
            this.isDoneButtonHidden = false;
        }
        else {
            this.isDoneButtonHidden = true;
        }
    }
    /**
     * It will enable/disable the steps further based on source (SA/ATO) selected.
     */
    onFormTypeChangeStep1() {
        this.isEnableToViewStep2 = false;
        if (this.importType === "atoReportsNew") {
            this.isAtoReports = true;
            this.isSoftwareAssistant = false;
            this.setReportExistsFlags();
            this.checkNewItcrptReportStatus();
        }
        else if (this.importType === "softwareAssistant") {
            this.isSoftwareAssistant = true;
            this.isAtoReports = false;
        }
    }
    /**
     * It will enable the step 3
     */
    onFormTypeChangeStep2() {
        this.isEnableToViewStep3 = false;
        this.saIsImportTypeClientOnly = true;
        if (this.hasAUTaxATOMigrationV2 && !this.hasAUTaxATOTaxMigrationV1) {
            this.isDoneButtonDisable = false;
        }
    }
    /**
     * In step 2 of SA it will set the required values for further process if client only is not selected.
     */
    onFormTypeChangeSaStep2() {
        this.isEnableToViewStep3 = false;
        this.saIsImportTypeClientOnly = false;
        this.disableFS = true;
    }
    /**
    * In step 2 of SA it will set the required values for further process if client only is selected.
    */
    onFormTypeChangeClientsOnlyStep2() {
        this.isEnableToViewStep3 = false;
        this.saIsImportTypeClientOnly = true;
        this.disableFS = false;
    }
    /**
     * In step 3 of SA it will set the required values for further process while Selecting tax year.
      */
    onFormTypeChangeSaYearStep3() {
        this.isSaYearSelected = false;
        this.saTaxYearSelected ? this.disableFS = false : this.disableFS = true;
    }
    /**
     * In step 3 of SA it will set the required values for further process while browsing file.
     */
    onFormTypeChangeSaFileStep3() {
        this.isEnableToViewStep3 = false;
        this.isDoneButtonHidden = false;
        this.isDoneButtonDisable = false;
    }
    setReportExistsFlags() {
        this.isReportCheckBusy = true;
        this.autaxMigrationService.getSuccessITCRPTReport().subscribe((response) => {
            this.isReportCheckBusy = false;
            if (response != null && response[0] !== null) {
                this.latestDate = this.datePipe.transform(response[0].receivedDate, "dd/MM/yyyy");
                this.isHaveITCRPTReport = true;
            }
            else {
                this.isHaveITCRPTReport = false;
            }
        }, (error) => {
            this.isReportCheckBusy = false;
            this.isHaveITCRPTReport = false;
        });
    }
    /**
     * This method is used to check the status of new Itcrpt report pending/not
     */
    checkNewItcrptReportStatus() {
        this.autaxMigrationService.getPendingITCRPTReport().subscribe((response) => {
            if (response != null && response[0] !== null) {
                this.isItcrptReportStatusPending = true;
            }
            else {
                this.isItcrptReportStatusPending = false;
            }
        }, (error) => {
            this.isItcrptReportStatusPending = false;
        });
    }
    /**
     * It will close the modal window and will start the migration process with notification emitted
     */
    onWizardFinish() {
        if (this.importType === "softwareAssistant") {
            this.softAssistModel.migrationOption = this.saImportType;
            this.softAssistModel.taxYear = this.saTaxYearSelected == AutaxStaffConstants.combPriorTaxYearOptions.allYear ? AutaxStaffConstants.combPriorTaxYearOptions.saAllYear : this.saTaxYearSelected;
            this.saModel.softAssistMigrationV1 = this.softAssistModel;
            this.saModel.selectedFile = this.selectedFiles;
            this.activeModal.close(this.saModel);
        }
        else if (this.importType === "atoReportsNew") {
            this.atoModel.atoImportType = this.atoImportType;
            this.atoModel.hasFirmLisence = this.hasAUTaxATOMigrationV2;
            this.atoOnvioMigrationV1.taxYear = this.hasAUTaxATOMigrationV2 ? (this.hasAUTaxATOTaxMigrationV1 ?
                this.atoSelectedYear : AutaxStaffConstants.combPriorTaxYearOptions.none) : AutaxStaffConstants.combPriorTaxYearOptions.none;
            this.atoModel.atoOnvioMigrationV1 = this.atoOnvioMigrationV1;
            this.activeModal.close(this.atoModel);
        }
    }
    onFileSelect(e) {
        this.selectedFiles = e.files;
        this.isDoneButtonHidden = false;
        this.isDoneButtonDisable = false;
    }
    onFileRemove(e) {
        this.selectedFiles = null;
        this.isDoneButtonHidden = false;
        this.isDoneButtonDisable = true;
    }
    /**
     * Based on year selection this method will enable or disable import button
     */
    onAtoYearSelected() {
        this.atoSelectedYear
            ? (this.isDoneButtonDisable = false)
            : (this.isDoneButtonDisable = true);
    }
}
MigrationModalWindowComponent.ɵfac = function MigrationModalWindowComponent_Factory(t) { return new (t || MigrationModalWindowComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(AutaxMigrationService), ɵngcc0.ɵɵdirectiveInject(SessionService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.DatePipe)); };
MigrationModalWindowComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MigrationModalWindowComponent, selectors: [["autax-migration-modal-window"]], decls: 27, vars: 17, consts: [["type", "button", "aria-label", "Close", 1, "close", 3, "click"], ["aria-hidden", "true", 1, "bento-icon-close-x"], [1, "modal-header"], [2, "margin", "0 auto"], [1, "modal-body"], [3, "hTag", "hideDoneButton", "currentStep", "currentStepChange"], ["description", "Select the data source you are importing from", 3, "title"], [1, "step1-format"], ["bento-fm-group", "importTypeRadio", "bento-fm-label", "Import Type", "ng-form", "importTypeRadio", 1, "form-group", "first-page-form"], ["class", "display-block", 4, "ngIf"], ["description", "Select the information you want to import", 3, "title", "disabled"], [4, "ngIf"], ["description", "Clients/Tax Returns", 3, "title", "disabled"], ["style", "height: 100px;", 4, "ngIf"], [1, "btn", "btn-primary", "float-left", 3, "hidden", "disabled", "click"], [1, "btn", "btn-outline-primary", "float-right", 3, "click"], [1, "display-block"], ["bento-fm-field", "", "name", "importType", "type", "radio", 3, "ngModel", "value", "ngModelChange", "change"], [1, "text-span"], ["bento-fm-group", "saImportTypeRadio", "bento-fm-label", "SA Import Type", "ng-form", "saImportTypeRadio", 1, "form-group", "second-page-form"], ["bento-fm-field", "", "name", "saImportType", "type", "radio", 3, "ngModel", "value", "ngModelChange", "click"], [1, "sub-text-span"], [3, "bentoBusyLoader", 4, "ngIf"], [3, "bentoBusyLoader"], ["bento-fm-group", "atoImportTypeRadio", "bento-fm-label", "ATO Import Type", "ng-form", "atoImportTypeRadio", 1, "form-group", "second-page-form"], ["bento-fm-field", "", "name", "atoImportType", "type", "radio", 3, "ngModel", "value", "disabled", "ngModelChange", "change"], ["class", "disable-text-message", 4, "ngIf"], [1, "radioBtn"], ["bento-fm-field", "", "name", "atoImportType", "type", "radio", 3, "ngModel", "value", "ngModelChange", "change"], [1, "disable-text-message"], [1, "bento-icon-close-thick", 2, "color", "black"], ["bento-fm-group", "itcrptImportTypeRadio", "bento-fm-label", "ITCRPT Import Type", "ng-form", "itcrptImportTypeRadio", 1, "form-group", "second-page-form"], [3, "ngModel", "dropFieldLabel", "showSelectedFiles", "multiple", "showFileSize", "appendOnSelection", "disabled", "accept", "ngModelChange", "fileSelect", "fileRemove", "change"], [1, "year-label"], ["for", "custom-template-combobox", 1, "sa-year-label"], ["id", "custom-template-combobox", 1, "sa-year-combo", 3, "ngModel", "itemsObservable", "options", "ngModelChange", "openChange"], ["for", "ato-year-template-combobox", 1, "ato-year-label"], ["id", "ato-year-template-combobox", 1, "year-combo", 3, "ngModel", "itemsObservable", "options", "ngModelChange", "openChange"], [2, "height", "100px"], [1, "year-sub-label"], [1, "year-sub-label-1"]], template: function MigrationModalWindowComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function MigrationModalWindowComponent_Template_button_click_0_listener() { return ctx.activeModal.close(); });
        ɵngcc0.ɵɵelement(1, "i", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "div", 2)(3, "h1", 3)(4, "b");
        ɵngcc0.ɵɵtext(5, "Import your clients and tax returns from below options");
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(6, "div", 4)(7, "bento-wizard", 5);
        ɵngcc0.ɵɵlistener("currentStepChange", function MigrationModalWindowComponent_Template_bento_wizard_currentStepChange_7_listener($event) { return ctx.currentStepNumber = $event; })("currentStepChange", function MigrationModalWindowComponent_Template_bento_wizard_currentStepChange_7_listener() { return ctx.wizardStepChange(); });
        ɵngcc0.ɵɵelementStart(8, "bento-wizard-step", 6)(9, "div", 7)(10, "h2");
        ɵngcc0.ɵɵtext(11, "Which data source are you importing from?");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 8);
        ɵngcc0.ɵɵtemplate(13, MigrationModalWindowComponent_label_13_Template, 4, 3, "label", 9);
        ɵngcc0.ɵɵtemplate(14, MigrationModalWindowComponent_label_14_Template, 4, 3, "label", 9);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(15, "bento-wizard-step", 10);
        ɵngcc0.ɵɵtemplate(16, MigrationModalWindowComponent_div_16_Template, 26, 11, "div", 11);
        ɵngcc0.ɵɵtemplate(17, MigrationModalWindowComponent_div_17_Template, 4, 2, "div", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "bento-wizard-step", 12);
        ɵngcc0.ɵɵtemplate(19, MigrationModalWindowComponent_div_19_Template, 11, 9, "div", 11);
        ɵngcc0.ɵɵtemplate(20, MigrationModalWindowComponent_div_20_Template, 13, 3, "div", 11);
        ɵngcc0.ɵɵtemplate(21, MigrationModalWindowComponent_div_21_Template, 12, 0, "div", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "bento-wizard-custom-button-group")(23, "button", 14);
        ɵngcc0.ɵɵlistener("click", function MigrationModalWindowComponent_Template_button_click_23_listener() { return ctx.onWizardFinish(); });
        ɵngcc0.ɵɵtext(24, " Import ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(25, "button", 15);
        ɵngcc0.ɵɵlistener("click", function MigrationModalWindowComponent_Template_button_click_25_listener() { return ctx.activeModal.close("cancel"); });
        ɵngcc0.ɵɵtext(26, " Cancel ");
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("hTag", "h1")("hideDoneButton", true)("currentStep", ctx.currentStepNumber);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", "Before you start");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasAUTaxSAMigrationV2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasAUTaxATOMigrationV2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", "Select data to import")("disabled", ctx.isEnableToViewStep2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isSoftwareAssistant);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAtoReports);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("title", "Import")("disabled", ctx.isEnableToViewStep3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isSoftwareAssistant);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAtoReports && ctx.hasAUTaxATOTaxMigrationV1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isAtoReports && ctx.hasAUTaxATOMigrationV2 && !ctx.hasAUTaxATOTaxMigrationV1);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("hidden", ctx.isDoneButtonHidden)("disabled", ctx.isDoneButtonDisable);
    } }, directives: [ɵngcc4.BentoFocusMonitorDirective, ɵngcc4.BentoWizardComponent, ɵngcc4.BentoWizardStepComponent, ɵngcc1.NgIf, ɵngcc6.RadioControlValueAccessor, ɵngcc6.DefaultValueAccessor, ɵngcc6.NgControlStatus, ɵngcc6.NgModel, ɵngcc4.BentoBusyLoaderDirective, ɵngcc4.BentoComboboxComponent, ɵngcc4.BentoFileSelectorComponent, ɵngcc4.BentoWizardComponentCustomButtonGroupComponent], styles: [".step1-format[_ngcontent-%COMP%]{padding:1px 115px 25px;margin-bottom:auto;z-index:1}.sub-text-span[_ngcontent-%COMP%]{margin:2px 5px 5px;font-size:10px}  .modal .modal-dialog.modal-xl .modal-content{width:100%!important}.first-page-form[_ngcontent-%COMP%]{margin-top:10px;margin-left:30px}.radioBtn[_ngcontent-%COMP%]{margin-top:10px}.second-page-form[_ngcontent-%COMP%]{margin-top:50px;margin-left:30px}.or-style[_ngcontent-%COMP%]{text-align:center;margin-right:60px}.notes-style[_ngcontent-%COMP%]{margin-top:30px;font-size:11px}.text-span[_ngcontent-%COMP%]{margin-left:5px}.text-span-large[_ngcontent-%COMP%]{margin-left:15px}.upload-form[_ngcontent-%COMP%]{margin-right:-20px;margin-left:-20px}.disable-text-message[_ngcontent-%COMP%]{font-weight:700;font-size:12px;color:#b22222}.year-combo[_ngcontent-%COMP%]{width:30%}.sa-year-combo[_ngcontent-%COMP%]{width:35%}.year-label[_ngcontent-%COMP%]{float:left;margin-top:50px;margin-left:100px;font-size:large}.year-sub-label[_ngcontent-%COMP%]{margin-left:130px;margin-top:30px;margin-bottom:0}.year-sub-label-1[_ngcontent-%COMP%]{margin-left:100px}.year-label-ato[_ngcontent-%COMP%]{float:right}.year-span[_ngcontent-%COMP%]{overflow:hidden;margin-top:25px;padding:50px 4px 0 6px}.ato-year-label[_ngcontent-%COMP%]{padding-top:50px}.ato-year-label[_ngcontent-%COMP%], .sa-year-label[_ngcontent-%COMP%]{padding-right:10px}.ato-note-label[_ngcontent-%COMP%]{margin-top:auto}.ato-note[_ngcontent-%COMP%]{float:left;padding:25px 5px}"] });
MigrationModalWindowComponent.ctorParameters = () => [
    { type: NgbModal },
    { type: NgbActiveModal },
    { type: AutaxMigrationService },
    { type: SessionService },
    { type: DatePipe }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MigrationModalWindowComponent, [{
        type: Component,
        args: [{
                selector: "autax-migration-modal-window",
                template: "<button type=\"button\" class=\"close\" aria-label=\"Close\"\r\n        (click)=\"activeModal.close()\">\r\n  <i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\r\n</button>\r\n<div class=\"modal-header\">\r\n  <h1 style=\"margin: 0 auto;\"><b>Import your clients and tax returns from below options</b></h1>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <bento-wizard  [hTag]=\"'h1'\" [hideDoneButton]=\"true\" [(currentStep)]=\"currentStepNumber\" (currentStepChange)=\"wizardStepChange()\">\r\n    <bento-wizard-step [title]=\"'Before you start'\" description=\"Select the data source you are importing from\">\r\n      <!--Step 1 common-->\r\n      <div class=\"step1-format\">\r\n      <h2>Which data source are you importing from?</h2>\r\n      <div bento-fm-group=\"importTypeRadio\" bento-fm-label=\"Import Type\" class=\"form-group first-page-form\" ng-form=\"importTypeRadio\">\r\n        <label *ngIf=\"hasAUTaxSAMigrationV2\" class=\"display-block\">\r\n          <input bento-fm-field name=\"importType\" [(ngModel)]=\"importType\" [value]=\"importTypes[0].value\"\r\n            (change)=\"onFormTypeChangeStep1()\" type=\"radio\">\r\n          <span class=\"text-span\">{{ importTypes[0].label }}</span>\r\n        </label>\r\n        <label *ngIf=\"hasAUTaxATOMigrationV2\" class=\"display-block\">\r\n          <input bento-fm-field name=\"importType\" [(ngModel)]=\"importType\" [value]=\"importTypes[1].value\"\r\n            (change)=\"onFormTypeChangeStep1()\" type=\"radio\">\r\n          <span class=\"text-span\">{{ importTypes[1].label }}</span>\r\n        </label>\r\n      </div>\r\n    </div>\r\n    </bento-wizard-step>\r\n    <bento-wizard-step [title]=\"'Select data to import'\" description=\"Select the information you want to import\" [disabled]=\"isEnableToViewStep2\" >\r\n      <!--Step 2 SA-->\r\n      <div *ngIf=\"isSoftwareAssistant\">\r\n        <div class=\"step1-format\">\r\n        <h1>Select which data to import</h1>\r\n        <div bento-fm-group=\"saImportTypeRadio\" bento-fm-label=\"SA Import Type\" class=\"form-group second-page-form\"\r\n        ng-form=\"saImportTypeRadio\">\r\n      <label class=\"display-block\">\r\n       <input bento-fm-field name=\"saImportType\" [(ngModel)]=\"saImportType\" [value]=\"saImportTypes[0].value\"\r\n       (click)=\"onFormTypeChangeClientsOnlyStep2()\" type=\"radio\" >\r\n               <span class=\"text-span\">{{ saImportTypes[0].label }}</span><br>\r\n               <span class=\"sub-text-span\">{{saImportTypes[0].label1}}</span><br>\r\n      </label>\r\n      <label class=\"display-block\">\r\n       <input bento-fm-field name=\"saImportType\" [(ngModel)]=\"saImportType\" [value]=\"saImportTypes[1].value\"\r\n       (click)=\"onFormTypeChangeSaStep2()\"   type=\"radio\" >\r\n               <span class=\"text-span\">{{ saImportTypes[1].label }}</span><br>\r\n               <span class=\"sub-text-span\">{{saImportTypes[1].label1}}</span><br>\r\n      </label>\r\n      <label class=\"display-block\">\r\n       <input bento-fm-field name=\"saImportType\" [(ngModel)]=\"saImportType\" [value]=\"saImportTypes[2].value\"\r\n       (click)=\"onFormTypeChangeSaStep2()\"  type=\"radio\" >\r\n              <span class=\"text-span\">{{ saImportTypes[2].label }}</span><br>\r\n       </label>\r\n      </div>\r\n   </div>\r\n    </div>\r\n      <!-- Step 2 ATO-->\r\n      <div *ngIf=\"isAtoReports\">\r\n        <div class=\"step1-format\">\r\n        <div *ngIf=\"isHaveITCRPTReport\" [bentoBusyLoader]=\"isReportCheckBusy\">\r\n          <div bento-fm-group=\"atoImportTypeRadio\" bento-fm-label=\"ATO Import Type\" class=\"form-group second-page-form\"\r\n               ng-form=\"atoImportTypeRadio\">\r\n            <label class=\"display-block\">\r\n              <input bento-fm-field name=\"atoImportType\" [(ngModel)]=\"atoImportType\" [value]=\"atoImportTypes[0].value\"\r\n                     (change)=\"onFormTypeChangeStep2()\" type=\"radio\" [disabled]=\"isItcrptReportStatusPending\">\r\n              <span class=\"text-span\">{{ isItcrptReportStatusPending? atoImportTypes[0].label1: atoImportTypes[0].label }}</span><br>\r\n              <span class=\"disable-text-message\" *ngIf=\"isItcrptReportStatusPending\"><i style=\"color: black;\" class=\"bento-icon-close-thick\"></i><i> Unable to proceed! Your previous request is still in progress.\r\n                Please wait until the ATO report is received or use an existing ATO report.</i></span>\r\n            </label>\r\n            <div class=\"radioBtn\">\r\n              <label class=\"display-block\">\r\n                <input bento-fm-field name=\"atoImportType\" [(ngModel)]=\"atoImportType\" [value]=\"atoImportTypes[1].value\"\r\n                       (change)=\"onFormTypeChangeStep2()\" type=\"radio\">\r\n                <span class=\"text-span\">{{ atoImportTypes[1].label }} {{latestDate}}</span><br>\r\n              </label>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div *ngIf=\"!isHaveITCRPTReport\" [bentoBusyLoader]=\"isReportCheckBusy\">\r\n          <div bento-fm-group=\"itcrptImportTypeRadio\" bento-fm-label=\"ITCRPT Import Type\"\r\n            class=\"form-group second-page-form\" ng-form=\"itcrptImportTypeRadio\">\r\n            <label class=\"display-block\">\r\n              <input bento-fm-field name=\"atoImportType\" [(ngModel)]=\"atoImportType\" [value]=\"atoImportTypes[2].value\"\r\n              (change)=\"onFormTypeChangeStep2()\" type=\"radio\" [disabled]=\"isItcrptReportStatusPending\">\r\n              <span class=\"text-span\">{{ isItcrptReportStatusPending? atoImportTypes[2].label1: atoImportTypes[2].label }}</span><br>\r\n              <span class=\"disable-text-message\" *ngIf=\"isItcrptReportStatusPending\"><i style=\"color: black;\" class=\"bento-icon-close-thick\"></i><i> Unable to proceed! Your previous request is still in progress.\r\n                Please wait until the ATO report is received.</i></span>\r\n            </label>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    </bento-wizard-step>\r\n    <bento-wizard-step [title]=\"'Import'\"\r\n      description=\"Clients/Tax Returns\" [disabled]=\"isEnableToViewStep3\" >\r\n      <!--Step 3 SA-->\r\n    <div *ngIf=\"isSoftwareAssistant\">\r\n      <div *ngIf=\"!saIsImportTypeClientOnly\">\r\n        <div class=\"year-label\">\r\n        <label class=\"sa-year-label\" for=\"custom-template-combobox\">Select the tax year(s) to import</label>\r\n        <bento-combobox\r\n          class=\"sa-year-combo\"\r\n          id=\"custom-template-combobox\"\r\n          [(ngModel)]=\"saTaxYearSelected\"\r\n          [itemsObservable]=\"saMigrationYearSelection\"\r\n          [options]=\"cmbSaMigrationYearOptions\"\r\n          (openChange)=\"onFormTypeChangeSaYearStep3()\"\r\n        ></bento-combobox>\r\n      </div>\r\n    </div>\r\n    <br><br><br><br><br>\r\n        <div>\r\n            <h4>Select the export file created from Software Assistant</h4>\r\n            <bento-file-selector [(ngModel)]=\"selectedFiles\"\r\n                                 [dropFieldLabel] = \"fileSelectorConstant\"\r\n                                 [showSelectedFiles]=\"showSelectedFiles\"\r\n                                 [multiple]=\"multipleSelect\"\r\n                                 [showFileSize]=\"showFileSize\"\r\n                                 [appendOnSelection]=\"appendOnSelection\"\r\n                                 (fileSelect)=\"onFileSelect($event)\"\r\n                                 (fileRemove)=\"onFileRemove($event)\"\r\n                                 [disabled]=\"disableFS\"\r\n                                 [accept]=\"'.zip'\" (change)=\"onFormTypeChangeSaFileStep3()\"></bento-file-selector>\r\n        </div>\r\n    </div>\r\n    <!--Step 3 ATO-->\r\n    <!--Forcefully hidding this for q3 ato client migration feature-->\r\n      <div *ngIf=\"isAtoReports && hasAUTaxATOTaxMigrationV1\">\r\n        <div class=\"step1-format\">\r\n          <label class=\"ato-year-label\" for=\"ato-year-template-combobox\">Select the tax year(s) to import</label>\r\n          <bento-combobox\r\n            class=\"year-combo\"\r\n            [(ngModel)]=\"atoSelectedYear\"\r\n            id=\"ato-year-template-combobox\"\r\n            [itemsObservable]=\"atoMigrationYearSelection\"\r\n            [options]=\"cmbAtoMigrationYearOptions\"\r\n            (openChange)=\"onAtoYearSelected()\"\r\n          ></bento-combobox>\r\n        </div>\r\n      <div>\r\n        <b>Note:</b>\r\n        <ul>\r\n          <li>By selecting \"All\" option, only 2019 and 2020 individual tax returns will be imported from ATO.</li>\r\n          <li>Importing clients and tax returns from ATO can take additional time to import.</li>\r\n        </ul>\r\n      </div>\r\n    </div>\r\n    <div style=\"height: 100px;\" *ngIf=\"isAtoReports && hasAUTaxATOMigrationV2 && !hasAUTaxATOTaxMigrationV1\">\r\n      <label class=\"year-label\">To finalise the import of your clients to Onvio, click <b>Import</b>.</label>\r\n      <label class=\"year-sub-label\"><i>The ability to migrate tax returns is currently under development.</i></label>\r\n      <label class=\"year-sub-label-1\"><i>We plan to release the ATO tax return import in the near future. Stay tuned!</i></label>\r\n    </div>\r\n    </bento-wizard-step>\r\n    <bento-wizard-custom-button-group>\r\n      <!--Text of Done button changed to Import-->\r\n      <button class=\"btn btn-primary float-left\"  (click)=\"onWizardFinish()\" [hidden]=\"isDoneButtonHidden\" [disabled]='isDoneButtonDisable'>\r\n        Import\r\n      </button>\r\n      <button class=\"btn btn-outline-primary float-right\" (click)=\"activeModal.close('cancel')\">\r\n        Cancel\r\n      </button>\r\n    </bento-wizard-custom-button-group>\r\n  </bento-wizard>\r\n</div>\r\n",
                styles: [".step1-format{padding:1px 115px 25px;margin-bottom:auto;z-index:1}.sub-text-span{margin:2px 5px 5px;font-size:10px}::ng-deep .modal .modal-dialog.modal-xl .modal-content{width:100%!important}.first-page-form{margin-top:10px;margin-left:30px}.radioBtn{margin-top:10px}.second-page-form{margin-top:50px;margin-left:30px}.or-style{text-align:center;margin-right:60px}.notes-style{margin-top:30px;font-size:11px}.text-span{margin-left:5px}.text-span-large{margin-left:15px}.upload-form{margin-right:-20px;margin-left:-20px}.disable-text-message{font-weight:700;font-size:12px;color:#b22222}.year-combo{width:30%}.sa-year-combo{width:35%}.year-label{float:left;margin-top:50px;margin-left:100px;font-size:large}.year-sub-label{margin-left:130px;margin-top:30px;margin-bottom:0}.year-sub-label-1{margin-left:100px}.year-label-ato{float:right}.year-span{overflow:hidden;margin-top:25px;padding:50px 4px 0 6px}.ato-year-label{padding-top:50px}.ato-year-label,.sa-year-label{padding-right:10px}.ato-note-label{margin-top:auto}.ato-note{float:left;padding:25px 5px}"]
            }]
    }], function () { return [{ type: ɵngcc3.NgbModal }, { type: ɵngcc3.NgbActiveModal }, { type: AutaxMigrationService }, { type: SessionService }, { type: ɵngcc1.DatePipe }]; }, null); })();

// System Imports
class SaAtoMigrationModalComponent {
    /**
     * Initialize the modal window properties options and services to be used in constructor
     */
    constructor(config, modalService, autaxMigrationService, sessionService) {
        this.modalService = modalService;
        this.autaxMigrationService = autaxMigrationService;
        this.sessionService = sessionService;
        this.modalClosed = new EventEmitter();
        this.migrationCompleted = new EventEmitter();
        this.migrationErrorMessage = new EventEmitter();
        this.softAssistModel = new SoftAssitMigrationV1();
        this.atoOnvioMigrationV1 = new AtoOnvioMigrationV1();
        this.saModel = new SoftAssistModel();
        this.atoModel = new AtoModel();
        config.backdrop = "static";
        this.modalOptions = {
            container: AutaxStaffConstants.nucleusStaffModalContainer,
            size: "lg",
        };
    }
    /**
     * On ngOnInit it will open the modal window and emit an event to core to set the value
     */
    ngOnInit() {
        this.modalClosed.emit();
        this.openModal();
        // This check for License permission status for AUTax.ATOMigrationV2 and set value accordingly.
        this.sessionService.checkFirmLicensePermissionForATOMigrationV2();
        // This check for License permission status for AUTax.SAMigrationV2 and set value accordingly.
        this.sessionService.checkFirmLicensePermissionForSAMigrationV2();
        // This check for License permission status for AUTax.ATOTaxMigrationV1 and set value accordingly.
        this.sessionService.checkFirmLicensePermissionForATOTaxMigrationV1();
    }
    /**
     * This will open the modal window for SA and ATO migration steps
     */
    openModal() {
        this.modalService
            .open(MigrationModalWindowComponent, this.modalOptions)
            .result.then((response) => {
            if (response === "cancel") {
                noop();
            }
            else if ((response.atoImportType === AutaxStaffConstants.atoImportType.newReportFromATO ||
                response.atoImportType === AutaxStaffConstants.atoImportType.newReportFromITCRPT ||
                response.atoImportType === AutaxStaffConstants.atoImportType.fromLatestITCRPT) && response.hasFirmLisence) {
                this.sendNotification();
                this.importFromAtoV2(response);
            }
            else {
                this.importFromSA(response);
            }
        })
            .catch(() => {
            noop();
        });
    }
    /**
     * This will start the migration of clients and tax returns based on the slection of migration option from SoftAssit to Onvio
     */
    importFromSA(saModel) {
        if (saModel.selectedFile !== undefined && saModel.softAssistMigrationV1 !== undefined) {
            this.autaxMigrationService.startMigrationSaV1(saModel.selectedFile, saModel.softAssistMigrationV1).subscribe((response) => {
                this.sendNotification();
            }, (errorResponse) => {
                const errorMessage = errorResponse;
                this.sendErrorMessage(errorMessage);
            });
        }
    }
    /**
     * This will start the migartion of clients/tax returns from ATO to Onvio
     */
    importFromAtoV2(atoModel) {
        this.atoOnvioMigrationV1.taxYear = atoModel.atoOnvioMigrationV1.taxYear;
        atoModel.atoImportType === "fromLatestITCRPT" ? this.atoOnvioMigrationV1.migrationOption = 'existing' : this.atoOnvioMigrationV1.migrationOption = 'new';
        this.autaxMigrationService.startMigrationAtoV1(this.atoOnvioMigrationV1).subscribe((response) => {
            noop();
        }, (error) => { });
    }
    /**
     * Once the process of migration is completed through UI this will emit an event for notification to core
     */
    sendNotification() {
        this.migrationCompleted.emit();
    }
    /**
     * It will emit an event to show any toast message related to the modal window
     * @param message
     */
    sendErrorMessage(message) {
        this.migrationErrorMessage.emit(message);
    }
}
SaAtoMigrationModalComponent.ɵfac = function SaAtoMigrationModalComponent_Factory(t) { return new (t || SaAtoMigrationModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbModalConfig), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbModal), ɵngcc0.ɵɵdirectiveInject(AutaxMigrationService), ɵngcc0.ɵɵdirectiveInject(SessionService)); };
SaAtoMigrationModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SaAtoMigrationModalComponent, selectors: [["autax-sa-ato-migration-modal"]], outputs: { modalClosed: "modalClosed", migrationCompleted: "migrationCompleted", migrationErrorMessage: "migrationErrorMessage" }, decls: 0, vars: 0, template: function SaAtoMigrationModalComponent_Template(rf, ctx) { }, styles: [".modal .modal-dialog.modal-xl .modal-content{width:100%!important}"] });
SaAtoMigrationModalComponent.ctorParameters = () => [
    { type: NgbModalConfig },
    { type: NgbModal },
    { type: AutaxMigrationService },
    { type: SessionService }
];
SaAtoMigrationModalComponent.propDecorators = {
    modalClosed: [{ type: Output }],
    migrationCompleted: [{ type: Output }],
    migrationErrorMessage: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SaAtoMigrationModalComponent, [{
        type: Component,
        args: [{
                selector: "autax-sa-ato-migration-modal",
                template: "",
                styles: ["::ng-deep .modal .modal-dialog.modal-xl .modal-content{width:100%!important}"]
            }]
    }], function () { return [{ type: ɵngcc3.NgbModalConfig }, { type: ɵngcc3.NgbModal }, { type: AutaxMigrationService }, { type: SessionService }]; }, { modalClosed: [{
            type: Output
        }], migrationCompleted: [{
            type: Output
        }], migrationErrorMessage: [{
            type: Output
        }] }); })();

class AutaxMigrationModule {
}
AutaxMigrationModule.ɵfac = function AutaxMigrationModule_Factory(t) { return new (t || AutaxMigrationModule)(); };
AutaxMigrationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AutaxMigrationModule });
AutaxMigrationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [NgbActiveModal, DatePipe], imports: [[
            BentoFlexGridControlModule,
            WjGridFilterModule,
            WjGridGrouppanelModule,
            WjGridDetailModule,
            WjGridModule,
            NgbModule,
            BentoModule,
            BentoD3Module,
            FormsModule,
            BrowserAnimationsModule,
            BrowserModule,
            BentoPaginationModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutaxMigrationModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    MigrationDetailsComponent,
                    SaAtoMigrationModalComponent,
                    MigrationModalWindowComponent
                ],
                imports: [
                    BentoFlexGridControlModule,
                    WjGridFilterModule,
                    WjGridGrouppanelModule,
                    WjGridDetailModule,
                    WjGridModule,
                    NgbModule,
                    BentoModule,
                    BentoD3Module,
                    FormsModule,
                    BrowserAnimationsModule,
                    BrowserModule,
                    BentoPaginationModule
                ],
                providers: [NgbActiveModal, DatePipe],
                entryComponents: [
                    MigrationModalWindowComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AutaxMigrationModule, { declarations: function () { return [MigrationDetailsComponent, SaAtoMigrationModalComponent, MigrationModalWindowComponent]; }, imports: function () { return [BentoFlexGridControlModule,
        WjGridFilterModule,
        WjGridGrouppanelModule,
        WjGridDetailModule,
        WjGridModule,
        NgbModule,
        BentoModule,
        BentoD3Module,
        FormsModule,
        BrowserAnimationsModule,
        BrowserModule,
        BentoPaginationModule]; } }); })();

// System Import
class AutaxStaffModule {
}
AutaxStaffModule.ɵfac = function AutaxStaffModule_Factory(t) { return new (t || AutaxStaffModule)(); };
AutaxStaffModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AutaxStaffModule });
AutaxStaffModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        AutaxStaffService,
        CoreService,
        AtoIntegrationService,
        HelperService,
        AlertService
    ], imports: [[
            AutaxAtoClientUpdateModule,
            AutaxMigrationModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AutaxStaffModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AutaxStaffComponent
                ],
                imports: [
                    AutaxAtoClientUpdateModule,
                    AutaxMigrationModule,
                ],
                providers: [
                    AutaxStaffService,
                    CoreService,
                    AtoIntegrationService,
                    HelperService,
                    AlertService
                ],
                exports: [
                    AutaxStaffComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AutaxStaffModule, { declarations: [AutaxStaffComponent], imports: [AutaxAtoClientUpdateModule, AutaxMigrationModule], exports: [AutaxStaffComponent] }); })();

/*
 * Public API Surface of autax-staff
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AUABNFormat, AUTaxService, AlertComponent, AlertService, AlertType, AtoAgentClientRelationshipComponent, AtoClientAssociationDetailsComponent, AtoClientFinanceDetailsComponent, AtoClientUpdateType, AtoIntegrationService, AuTaxLodgePerformanceComponent, AuTaxLodgePerformanceModule, AuTaxLodgePerformanceService, AutaxAtoClientUpdateModule, AutaxMigrationModule, AutaxStaffComponent, AutaxStaffModule, ClientAddressUpdateComponent, ClientAssociationDetailsUpdateComponent, ClientRelationshipUpdateComponent, CoreService, DPDateCustomFormatter, DateValidationClass, DirectDebitPaymentComponent, HelperService, LodgementOverallProgressGraphComponent, MigrationDetailsComponent, MigrationModalWindowComponent, NgbDateCustomParserFormatter, OnvioAddressType, OnvioClientUpdateType, RelationshipMessageStatus, SaAtoMigrationModalComponent, YearToDateGraphComponent, SessionService as ɵa, LodgementOverallProgressGraphModule as ɵb, YearToDateGraphModule as ɵc, DirectDebitDateService as ɵd, DirectDebitCancelPaymentComponent as ɵe, AutaxMigrationService as ɵf, AutaxStaffService as ɵg };

